var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _rect, _rect2, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _rect3, _rect4, _circle, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _circle2, _g, _circle3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecFullSetup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1021,
    height: 407,
    viewBox: "0 0 1021 407",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1015.98 146.633H774.425C771.882 146.633 769.82 148.695 769.82 151.238V401.592C769.82 404.136 771.882 406.197 774.425 406.197H1015.98C1018.53 406.197 1020.59 404.136 1020.59 401.592V151.238C1020.59 148.695 1018.53 146.633 1015.98 146.633Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M780.239 247.856C778.275 247.856 776.679 249.453 776.679 251.417C776.679 253.381 778.275 254.977 780.239 254.977C782.203 254.977 783.799 253.381 783.799 251.417C783.799 249.453 782.203 247.856 780.239 247.856Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M797.759 247.856C795.795 247.856 794.199 249.453 794.199 251.417C794.199 253.381 795.795 254.977 797.759 254.977C799.723 254.977 801.319 253.381 801.319 251.417C801.319 249.453 799.723 247.856 797.759 247.856Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M992.263 339.763C994.623 339.763 996.539 337.848 996.539 335.487C996.539 333.127 994.72 331.317 992.447 331.221V335.41C992.447 335.506 992.369 335.594 992.263 335.594C992.156 335.594 992.079 335.516 992.079 335.41V331.221C989.806 331.317 987.987 333.185 987.987 335.487C987.987 337.79 989.902 339.763 992.263 339.763Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M992.263 330.389C992.36 330.389 992.447 330.311 992.447 330.205V329.508C992.447 329.412 992.369 329.324 992.263 329.324C992.156 329.324 992.079 329.402 992.079 329.508V330.205C992.079 330.302 992.156 330.389 992.263 330.389Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M990.202 330.708C990.202 330.708 990.251 330.708 990.27 330.698C990.367 330.66 990.406 330.553 990.367 330.456L990.135 329.905C990.096 329.808 989.99 329.77 989.893 329.808C989.796 329.847 989.757 329.953 989.796 330.05L990.028 330.602C990.057 330.669 990.125 330.718 990.202 330.718V330.708Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M988.587 331.821C988.655 331.753 988.655 331.637 988.587 331.559L988.161 331.134C988.094 331.066 987.978 331.066 987.9 331.134C987.823 331.202 987.832 331.318 987.9 331.395L988.326 331.821C988.326 331.821 988.413 331.879 988.452 331.879C988.49 331.879 988.548 331.859 988.577 331.821H988.587Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996.2 339.173C996.133 339.105 996.017 339.105 995.939 339.173C995.862 339.241 995.872 339.357 995.939 339.434L997.11 340.605C997.11 340.605 997.197 340.663 997.236 340.663C997.274 340.663 997.332 340.644 997.361 340.605C997.429 340.537 997.429 340.421 997.361 340.344L996.191 339.173H996.2Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M986.806 333.039C986.71 333.001 986.603 333.039 986.565 333.136C986.526 333.233 986.565 333.339 986.661 333.378L987.213 333.61C987.213 333.61 987.261 333.62 987.281 333.62C987.348 333.62 987.426 333.581 987.455 333.504C987.493 333.407 987.455 333.301 987.358 333.262L986.806 333.03V333.039Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M997.865 337.615L997.313 337.383C997.217 337.345 997.11 337.383 997.071 337.48C997.033 337.577 997.071 337.683 997.168 337.722L997.72 337.954C997.72 337.954 997.768 337.964 997.787 337.964C997.855 337.964 997.932 337.925 997.962 337.848C998 337.751 997.962 337.644 997.865 337.606V337.615Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M987.068 335.497C987.068 335.4 986.991 335.313 986.884 335.313H986.284C986.188 335.313 986.101 335.39 986.101 335.497C986.101 335.603 986.178 335.681 986.284 335.681H986.884C986.981 335.681 987.068 335.603 987.068 335.497Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M998.242 335.313H997.642C997.545 335.313 997.458 335.39 997.458 335.497C997.458 335.603 997.535 335.681 997.642 335.681H998.242C998.338 335.681 998.425 335.603 998.425 335.497C998.425 335.39 998.348 335.313 998.242 335.313Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M987.455 337.48C987.416 337.383 987.31 337.345 987.213 337.383L986.661 337.615C986.565 337.654 986.526 337.761 986.565 337.857C986.594 337.925 986.661 337.973 986.739 337.973C986.758 337.973 986.787 337.973 986.806 337.964L987.358 337.732C987.455 337.693 987.493 337.586 987.455 337.49V337.48Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M997.72 333.04L997.168 333.272C997.071 333.31 997.033 333.417 997.071 333.514C997.1 333.581 997.168 333.63 997.246 333.63C997.265 333.63 997.294 333.63 997.313 333.62L997.865 333.388C997.962 333.349 998 333.243 997.962 333.146C997.923 333.049 997.816 333.011 997.72 333.049V333.04Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M988.586 339.173C988.519 339.105 988.402 339.105 988.325 339.173L987.174 340.324C987.106 340.392 987.106 340.508 987.174 340.586C987.213 340.624 987.261 340.644 987.3 340.644C987.338 340.644 987.396 340.624 987.425 340.586L988.577 339.434C988.644 339.367 988.644 339.251 988.577 339.173H988.586Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996.626 331.134C996.558 331.066 996.442 331.066 996.365 331.134L995.939 331.559C995.871 331.627 995.871 331.743 995.939 331.821C995.978 331.859 996.026 331.879 996.065 331.879C996.103 331.879 996.161 331.859 996.191 331.821L996.616 331.395C996.684 331.327 996.684 331.211 996.616 331.134H996.626Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M994.323 330.708C994.391 330.708 994.468 330.669 994.497 330.592L994.73 330.04C994.768 329.944 994.73 329.837 994.633 329.799C994.536 329.76 994.43 329.799 994.391 329.895L994.159 330.447C994.12 330.543 994.159 330.65 994.256 330.689C994.275 330.689 994.304 330.698 994.323 330.698V330.708Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M970.602 258.827H1012.73C1013.07 258.827 1013.35 259.108 1013.35 259.447V294.371H969.983V259.447C969.983 259.108 970.263 258.827 970.602 258.827Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M808.072 138.197H813.848C814.09 138.197 814.283 138.391 814.283 138.633V146.614H807.627V138.642C807.627 138.4 807.821 138.207 808.063 138.207L808.072 138.197Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M828.495 144.524H832.461C832.558 144.524 832.636 144.602 832.636 144.699V146.624H828.321V144.699C828.321 144.602 828.398 144.524 828.495 144.524Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M843.345 144.524H847.312C847.408 144.524 847.486 144.602 847.486 144.699V146.624H843.171V144.699C843.171 144.602 843.248 144.524 843.345 144.524Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M858.757 144.524H862.723C862.82 144.524 862.897 144.602 862.897 144.699V146.624H858.583V144.699C858.583 144.602 858.66 144.524 858.757 144.524Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M866.476 144.524H870.443C870.54 144.524 870.617 144.602 870.617 144.699V146.624H866.302V144.699C866.302 144.602 866.38 144.524 866.476 144.524Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M889.047 144.524H893.014C893.11 144.524 893.188 144.602 893.188 144.699V146.624H888.873V144.699C888.873 144.602 888.95 144.524 889.047 144.524Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M927.077 144.524H931.044C931.141 144.524 931.218 144.602 931.218 144.699V146.624H926.903V144.699C926.903 144.602 926.981 144.524 927.077 144.524Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M944.617 144.524H948.583C948.68 144.524 948.757 144.602 948.757 144.699V146.624H944.442V144.699C944.442 144.602 944.52 144.524 944.617 144.524Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M957.096 144.524H961.063C961.16 144.524 961.237 144.602 961.237 144.699V146.624H956.922V144.699C956.922 144.602 957 144.524 957.096 144.524Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M970.321 144.524H974.288C974.384 144.524 974.462 144.602 974.462 144.699V146.624H970.147V144.699C970.147 144.602 970.224 144.524 970.321 144.524Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M985.849 138.197H991.624C991.866 138.197 992.06 138.391 992.06 138.633V146.614H985.404V138.642C985.404 138.4 985.597 138.207 985.839 138.207L985.849 138.197Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M806.969 153.589V241.965",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M806.969 245.399V257.008",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M806.969 261.352V272.952",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M806.969 276.831V288.441",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M806.969 292.862V304.471",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M806.969 308.186V347.687",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M806.969 350.792V395.623",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M987.474 185.302C986.555 183.725 984.93 182.825 983.237 182.758L983.266 188.001C983.266 188.127 983.159 188.233 983.034 188.233C982.908 188.233 982.802 188.127 982.802 188.001L982.773 182.758C981.97 182.796 981.167 183.009 980.422 183.444C977.964 184.876 977.132 188.03 978.564 190.497C979.996 192.954 983.15 193.786 985.617 192.355C988.074 190.923 988.906 187.769 987.474 185.302Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M983.015 180.958V181.635",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M979.541 181.887L979.88 182.477",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M986.149 193.332L986.488 193.912",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M977.007 184.431L977.587 184.77",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M988.442 191.039L989.032 191.377",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M976.068 187.904H976.755",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M989.284 187.904H989.961",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M977.007 191.377L977.587 191.039",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M988.442 184.77L989.032 184.431",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M979.541 193.912L979.87 193.332",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M986.149 182.477L986.488 181.887",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M987.474 210.958C986.555 209.382 984.93 208.482 983.237 208.414L983.266 213.658C983.266 213.783 983.159 213.89 983.034 213.89C982.908 213.89 982.802 213.783 982.802 213.658L982.773 208.414C981.97 208.453 981.167 208.666 980.422 209.101C977.964 210.533 977.132 213.687 978.564 216.154C979.996 218.611 983.15 219.443 985.617 218.011C988.074 216.579 988.906 213.425 987.474 210.958Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M983.015 206.615V207.292",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M979.541 207.543L979.88 208.133",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M986.149 218.988L986.488 219.578",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M977.007 210.088L977.587 210.426",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M988.442 216.695L989.032 217.034",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M976.068 213.561H976.755",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M989.284 213.561H989.961",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M977.007 217.034L977.587 216.695",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M988.442 210.426L989.032 210.088",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M979.541 219.578L979.87 218.988",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M986.149 208.133L986.488 207.543",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M987.474 236.625C986.555 235.048 984.93 234.148 983.237 234.08L983.266 239.324C983.266 239.45 983.159 239.556 983.034 239.556C982.908 239.556 982.802 239.45 982.802 239.324L982.773 234.08C981.97 234.119 981.167 234.332 980.422 234.767C977.964 236.199 977.132 239.353 978.564 241.82C979.996 244.277 983.15 245.109 985.617 243.677C988.074 242.246 988.906 239.092 987.474 236.625Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M983.015 232.281V232.958",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M979.541 233.209L979.88 233.8",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M986.149 244.654L986.488 245.235",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M977.007 235.754L977.587 236.093",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M988.442 242.362L989.032 242.7",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M976.068 239.227H976.755",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M989.284 239.227H989.961",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M977.007 242.7L977.587 242.362",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M988.442 236.093L989.032 235.754",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M979.541 245.235L979.87 244.654",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M986.149 233.8L986.488 233.209",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.98 338.69C959.496 337.867 958.655 337.393 957.765 337.354L957.784 340.092C957.784 340.16 957.726 340.218 957.668 340.218C957.6 340.218 957.552 340.16 957.552 340.102L957.532 337.364C957.116 337.384 956.691 337.5 956.304 337.722C955.017 338.467 954.582 340.121 955.327 341.408C956.072 342.695 957.726 343.13 959.013 342.385C960.299 341.64 960.735 339.986 959.99 338.699L959.98 338.69Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M957.658 336.416V336.774",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M955.839 336.909L956.014 337.209",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M959.293 342.888L959.467 343.188",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M954.514 338.235L954.814 338.409",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M960.493 341.688L960.802 341.863",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M954.021 340.054H954.378",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M960.928 340.054H961.286",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M954.514 341.863L954.814 341.688",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M960.493 338.409L960.802 338.235",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M955.839 343.188L956.014 342.888",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M959.293 337.209L959.467 336.909",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M994.411 351.498C993.927 350.676 993.085 350.202 992.195 350.163L992.215 352.901C992.215 352.969 992.157 353.027 992.098 353.027C992.031 353.027 991.982 352.969 991.982 352.911L991.963 350.173C991.547 350.192 991.121 350.308 990.734 350.531C989.448 351.276 989.012 352.93 989.757 354.217C990.502 355.504 992.157 355.939 993.443 355.194C994.73 354.449 995.165 352.795 994.42 351.508L994.411 351.498Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M992.079 349.225V349.583",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M990.261 349.718L990.445 350.018",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M993.714 355.697L993.898 355.997",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M988.935 351.044L989.245 351.218",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M994.914 354.497L995.224 354.671",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M988.451 352.863H988.809",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M995.359 352.863H995.707",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M988.935 354.671L989.245 354.497",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M994.914 351.218L995.224 351.044",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M990.261 355.997L990.435 355.697",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M993.714 350.018L993.898 349.718",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M811.391 330.331C811.391 330.418 811.458 330.486 811.545 330.486H817.969C818.056 330.486 818.124 330.418 818.124 330.331C818.124 330.244 818.056 330.176 817.969 330.176H811.545C811.458 330.176 811.391 330.244 811.391 330.331Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.531 330.176H820.107C820.02 330.176 819.952 330.244 819.952 330.331C819.952 330.418 820.02 330.486 820.107 330.486H826.531C826.618 330.486 826.686 330.418 826.686 330.331C826.686 330.244 826.618 330.176 826.531 330.176Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M811.545 332.895H817.969C818.056 332.895 818.124 332.827 818.124 332.74C818.124 332.653 818.056 332.585 817.969 332.585H811.545C811.458 332.585 811.391 332.653 811.391 332.74C811.391 332.827 811.458 332.895 811.545 332.895Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.531 332.585H820.107C820.02 332.585 819.952 332.653 819.952 332.74C819.952 332.827 820.02 332.895 820.107 332.895H826.531C826.618 332.895 826.686 332.827 826.686 332.74C826.686 332.653 826.618 332.585 826.531 332.585Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M811.545 335.303H817.969C818.056 335.303 818.124 335.236 818.124 335.149C818.124 335.062 818.056 334.994 817.969 334.994H811.545C811.458 334.994 811.391 335.062 811.391 335.149C811.391 335.236 811.458 335.303 811.545 335.303Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.531 334.994H820.107C820.02 334.994 819.952 335.062 819.952 335.149C819.952 335.236 820.02 335.303 820.107 335.303H826.531C826.618 335.303 826.686 335.236 826.686 335.149C826.686 335.062 826.618 334.994 826.531 334.994Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M811.545 337.712H817.969C818.056 337.712 818.124 337.645 818.124 337.558C818.124 337.471 818.056 337.403 817.969 337.403H811.545C811.458 337.403 811.391 337.471 811.391 337.558C811.391 337.645 811.458 337.712 811.545 337.712Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.531 337.403H820.107C820.02 337.403 819.952 337.471 819.952 337.558C819.952 337.645 820.02 337.712 820.107 337.712H826.531C826.618 337.712 826.686 337.645 826.686 337.558C826.686 337.471 826.618 337.403 826.531 337.403Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M811.545 340.121H817.969C818.056 340.121 818.124 340.054 818.124 339.967C818.124 339.879 818.056 339.812 817.969 339.812H811.545C811.458 339.812 811.391 339.879 811.391 339.967C811.391 340.054 811.458 340.121 811.545 340.121Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M813.326 342.491H824.335C824.48 342.491 824.606 342.424 824.606 342.337C824.606 342.25 824.49 342.182 824.335 342.182H813.326C813.18 342.182 813.055 342.25 813.055 342.337C813.055 342.424 813.171 342.491 813.326 342.491Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.531 339.802H820.107C820.02 339.802 819.952 339.87 819.952 339.957C819.952 340.044 820.02 340.112 820.107 340.112H826.531C826.618 340.112 826.686 340.044 826.686 339.957C826.686 339.87 826.618 339.802 826.531 339.802Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M811.545 344.939H817.969C818.056 344.939 818.124 344.871 818.124 344.784C818.124 344.697 818.056 344.629 817.969 344.629H811.545C811.458 344.629 811.391 344.697 811.391 344.784C811.391 344.871 811.458 344.939 811.545 344.939Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.531 344.62H820.107C820.02 344.62 819.952 344.688 819.952 344.775C819.952 344.862 820.02 344.929 820.107 344.929H826.531C826.618 344.929 826.686 344.862 826.686 344.775C826.686 344.688 826.618 344.62 826.531 344.62Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M811.545 347.338H817.969C818.056 347.338 818.124 347.271 818.124 347.184C818.124 347.097 818.056 347.029 817.969 347.029H811.545C811.458 347.029 811.391 347.097 811.391 347.184C811.391 347.271 811.458 347.338 811.545 347.338Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.531 347.029H820.107C820.02 347.029 819.952 347.097 819.952 347.184C819.952 347.271 820.02 347.338 820.107 347.338H826.531C826.618 347.338 826.686 347.271 826.686 347.184C826.686 347.097 826.618 347.029 826.531 347.029Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M811.545 349.747H817.969C818.056 349.747 818.124 349.68 818.124 349.593C818.124 349.505 818.056 349.438 817.969 349.438H811.545C811.458 349.438 811.391 349.505 811.391 349.593C811.391 349.68 811.458 349.747 811.545 349.747Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.531 349.438H820.107C820.02 349.438 819.952 349.505 819.952 349.593C819.952 349.68 820.02 349.747 820.107 349.747H826.531C826.618 349.747 826.686 349.68 826.686 349.593C826.686 349.505 826.618 349.438 826.531 349.438Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M811.545 352.156H817.969C818.056 352.156 818.124 352.089 818.124 352.001C818.124 351.914 818.056 351.847 817.969 351.847H811.545C811.458 351.847 811.391 351.914 811.391 352.001C811.391 352.089 811.458 352.156 811.545 352.156Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.531 351.847H820.107C820.02 351.847 819.952 351.914 819.952 352.001C819.952 352.089 820.02 352.156 820.107 352.156H826.531C826.618 352.156 826.686 352.089 826.686 352.001C826.686 351.914 826.618 351.847 826.531 351.847Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M811.545 354.507H817.969C818.056 354.507 818.124 354.439 818.124 354.352C818.124 354.265 818.056 354.198 817.969 354.198H811.545C811.458 354.198 811.391 354.265 811.391 354.352C811.391 354.439 811.458 354.507 811.545 354.507Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.531 354.188H820.107C820.02 354.188 819.952 354.256 819.952 354.343C819.952 354.43 820.02 354.498 820.107 354.498H826.531C826.618 354.498 826.686 354.43 826.686 354.343C826.686 354.256 826.618 354.188 826.531 354.188Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M817.573 373.236C817.631 373.236 817.679 373.188 817.679 373.13V371.263C817.679 371.205 817.631 371.156 817.573 371.156C817.515 371.156 817.466 371.205 817.466 371.263V373.13C817.466 373.188 817.515 373.236 817.573 373.236Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M814.932 369.86V374.601C814.932 374.968 815.232 375.268 815.599 375.268H822.487C822.855 375.268 823.155 374.968 823.155 374.601V369.86C823.155 369.493 822.855 369.193 822.487 369.193H815.599C815.232 369.193 814.932 369.493 814.932 369.86ZM822.932 369.86V374.601C822.932 374.852 822.729 375.055 822.478 375.055H815.589C815.338 375.055 815.135 374.852 815.135 374.601V369.86C815.135 369.609 815.338 369.405 815.589 369.405H822.478C822.729 369.405 822.932 369.609 822.932 369.86Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M816.663 374.194H821.404C821.771 374.194 822.071 373.894 822.071 373.527V370.934C822.071 370.567 821.771 370.267 821.404 370.267H816.663C816.296 370.267 815.996 370.567 815.996 370.934V373.527C815.996 373.894 816.296 374.194 816.663 374.194ZM816.208 370.934C816.208 370.683 816.412 370.479 816.663 370.479H821.404C821.655 370.479 821.858 370.683 821.858 370.934V373.527C821.858 373.778 821.655 373.982 821.404 373.982H816.663C816.412 373.982 816.208 373.778 816.208 373.527V370.934Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M811.178 193.457V251.252",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M781.294 181.471C781.294 180.89 780.82 180.416 780.239 180.416C779.659 180.416 779.185 180.89 779.185 181.471C779.185 182.051 779.659 182.525 780.239 182.525C780.82 182.525 781.294 182.051 781.294 181.471Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M782.812 181.471C782.812 180.049 781.661 178.897 780.239 178.897C778.817 178.897 777.666 180.049 777.666 181.471C777.666 182.893 778.817 184.044 780.239 184.044C781.661 184.044 782.812 182.893 782.812 181.471Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M798.301 181.471C798.301 180.89 797.827 180.416 797.246 180.416C796.666 180.416 796.192 180.89 796.192 181.471C796.192 182.051 796.666 182.525 797.246 182.525C797.827 182.525 798.301 182.051 798.301 181.471Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M799.82 181.471C799.82 180.049 798.669 178.897 797.247 178.897C795.825 178.897 794.673 180.049 794.673 181.471C794.673 182.893 795.825 184.044 797.247 184.044C798.669 184.044 799.82 182.893 799.82 181.471Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M818.966 160.032C818.966 159.878 818.849 159.752 818.695 159.781C817.592 159.965 816.721 160.893 816.673 162.054C816.615 163.389 817.65 164.512 818.975 164.57C820.31 164.628 821.433 163.593 821.491 162.267C821.549 161.038 820.668 159.984 819.488 159.781C819.343 159.761 819.227 159.868 819.217 160.013L819.159 161.358C819.159 161.425 819.091 161.483 819.024 161.483C818.956 161.483 818.898 161.416 818.898 161.348L818.956 160.032H818.966Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M815.947 159.045L816.876 159.974",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M818.046 158.117L818.279 159.278",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M820.368 158.117L820.136 159.278",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M822.225 159.045L821.529 159.974",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M945.555 275.796H807.473",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M945.555 259.176H807.473",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M945.555 289.708H807.473",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M945.555 306.532H807.473",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M871.459 379.235H815.212",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M939.132 379.235H882.885",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M800.158 285.838C801.98 285.838 803.457 284.361 803.457 282.539C803.457 280.717 801.98 279.24 800.158 279.24C798.336 279.24 796.859 280.717 796.859 282.539C796.859 284.361 798.336 285.838 800.158 285.838Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M788.54 285.838C790.362 285.838 791.839 284.361 791.839 282.539C791.839 280.717 790.362 279.24 788.54 279.24C786.718 279.24 785.241 280.717 785.241 282.539C785.241 284.361 786.718 285.838 788.54 285.838Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M776.921 285.838C778.743 285.838 780.22 284.361 780.22 282.539C780.22 280.717 778.743 279.24 776.921 279.24C775.099 279.24 773.622 280.717 773.622 282.539C773.622 284.361 775.099 285.838 776.921 285.838Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M800.158 300.679C801.98 300.679 803.457 299.202 803.457 297.38C803.457 295.558 801.98 294.081 800.158 294.081C798.336 294.081 796.859 295.558 796.859 297.38C796.859 299.202 798.336 300.679 800.158 300.679Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M819.033 285.838C820.855 285.838 822.332 284.361 822.332 282.539C822.332 280.717 820.855 279.24 819.033 279.24C817.211 279.24 815.734 280.717 815.734 282.539C815.734 284.361 817.211 285.838 819.033 285.838Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M788.54 300.679C790.362 300.679 791.839 299.202 791.839 297.38C791.839 295.558 790.362 294.081 788.54 294.081C786.718 294.081 785.241 295.558 785.241 297.38C785.241 299.202 786.718 300.679 788.54 300.679Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M776.921 300.679C778.743 300.679 780.22 299.202 780.22 297.38C780.22 295.558 778.743 294.081 776.921 294.081C775.099 294.081 773.622 295.558 773.622 297.38C773.622 299.202 775.099 300.679 776.921 300.679Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M780.423 209.091H796.231",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.12 171.206V156.859C1011.12 156.549 1010.87 156.298 1010.56 156.298H999.412C999.102 156.298 998.851 156.549 998.851 156.859V171.206C998.851 171.516 999.102 171.767 999.412 171.767H1010.56C1010.87 171.767 1011.12 171.516 1011.12 171.206Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.73 158.243H1000.25",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M782.571 198.982C782.087 198.159 781.245 197.685 780.355 197.646L780.375 200.384C780.375 200.452 780.317 200.51 780.259 200.51C780.191 200.51 780.143 200.452 780.143 200.394L780.123 197.656C779.707 197.676 779.282 197.792 778.895 198.014C777.608 198.759 777.172 200.413 777.917 201.7C778.662 202.987 780.317 203.422 781.603 202.677C782.89 201.932 783.325 200.278 782.58 198.991L782.571 198.982Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M780.239 196.708V197.066",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M778.42 197.201L778.604 197.501",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M781.874 203.18L782.058 203.48",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M777.095 198.527L777.405 198.701",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M783.074 201.98L783.383 202.155",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M776.611 200.336H776.96",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M783.509 200.336H783.867",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M777.095 202.155L777.405 201.98",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M783.074 198.701L783.383 198.527",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M778.42 203.48L778.595 203.18",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M781.874 197.501L782.058 197.201",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M800.091 198.982C799.607 198.159 798.765 197.685 797.875 197.646L797.895 200.384C797.895 200.452 797.837 200.51 797.779 200.51C797.711 200.51 797.663 200.452 797.663 200.394L797.643 197.656C797.227 197.676 796.802 197.792 796.415 198.014C795.128 198.759 794.693 200.413 795.437 201.7C796.182 202.987 797.837 203.422 799.123 202.677C800.41 201.932 800.845 200.278 800.1 198.991L800.091 198.982Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M797.759 196.708V197.066",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M795.941 197.201L796.125 197.501",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M799.395 203.18L799.578 203.48",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M794.615 198.527L794.925 198.701",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M800.594 201.98L800.904 202.155",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M794.131 200.336H794.48",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M801.039 200.336H801.387",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M794.615 202.155L794.925 201.98",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M800.594 198.701L800.904 198.527",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M795.941 203.48L796.115 203.18",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M799.395 197.501L799.578 197.201",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M813.693 173.189C812.871 173.673 812.397 174.515 812.358 175.405L815.096 175.385C815.164 175.385 815.222 175.444 815.222 175.502C815.222 175.569 815.164 175.627 815.106 175.627L812.368 175.647C812.387 176.063 812.504 176.488 812.726 176.875C813.471 178.162 815.125 178.597 816.412 177.852C817.699 177.108 818.134 175.453 817.389 174.167C816.644 172.88 814.99 172.444 813.703 173.189H813.693Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M811.42 175.511H811.778",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M811.913 177.33L812.213 177.156",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M817.892 173.877L818.192 173.702",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M813.238 178.656L813.412 178.346",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M816.692 172.677L816.867 172.367",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M815.057 179.149V178.791",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M815.057 172.242V171.884",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M816.867 178.656L816.692 178.346",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M813.412 172.677L813.238 172.367",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M818.192 177.33L817.892 177.156",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M812.213 173.877L811.913 173.702",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M827.953 181.413C827.469 180.59 826.628 180.116 825.738 180.078L825.757 182.815C825.757 182.883 825.699 182.941 825.641 182.941C825.573 182.941 825.525 182.883 825.525 182.825L825.506 180.087C825.09 180.107 824.664 180.223 824.277 180.445C822.99 181.19 822.555 182.845 823.3 184.131C824.045 185.418 825.699 185.853 826.986 185.108C828.272 184.363 828.708 182.709 827.963 181.422L827.953 181.413Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M825.631 179.139V179.497",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M823.812 179.623L823.996 179.932",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M827.266 185.602L827.44 185.911",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M822.487 180.958L822.797 181.132",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M828.466 184.402L828.775 184.586",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M822.003 182.767H822.352",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M828.901 182.767H829.259",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M822.487 184.586L822.797 184.402",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M828.466 181.132L828.775 180.958",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M823.812 185.911L823.987 185.602",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M827.266 179.932L827.44 179.623",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M782.571 215.989C782.087 215.167 781.245 214.693 780.355 214.654L780.375 217.392C780.375 217.459 780.317 217.517 780.259 217.517C780.191 217.517 780.143 217.459 780.143 217.401L780.123 214.663C779.707 214.683 779.282 214.799 778.895 215.021C777.608 215.766 777.172 217.421 777.917 218.707C778.662 219.994 780.317 220.429 781.603 219.684C782.89 218.94 783.325 217.285 782.58 215.999L782.571 215.989Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M780.239 213.725V214.073",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M778.42 214.209L778.604 214.518",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M781.874 220.188L782.058 220.497",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M777.095 215.534L777.405 215.718",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M783.074 218.988L783.383 219.162",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M776.611 217.353H776.96",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M783.509 217.353H783.867",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M777.095 219.162L777.405 218.988",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M783.074 215.718L783.383 215.534",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M778.42 220.497L778.595 220.188",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M781.874 214.518L782.058 214.209",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M800.091 215.989C799.607 215.167 798.765 214.693 797.875 214.654L797.895 217.392C797.895 217.459 797.837 217.517 797.779 217.517C797.711 217.517 797.663 217.459 797.663 217.401L797.643 214.663C797.227 214.683 796.802 214.799 796.415 215.021C795.128 215.766 794.693 217.421 795.437 218.707C796.182 219.994 797.837 220.429 799.123 219.684C800.41 218.94 800.845 217.285 800.1 215.999L800.091 215.989Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M797.759 213.725V214.073",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M795.941 214.209L796.125 214.518",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M799.395 220.188L799.578 220.497",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M794.615 215.534L794.925 215.718",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M800.594 218.988L800.904 219.162",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M794.131 217.353H794.48",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M801.039 217.353H801.387",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M794.615 219.162L794.925 218.988",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M800.594 215.718L800.904 215.534",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M795.941 220.497L796.115 220.188",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M799.395 214.518L799.578 214.209",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M775.828 234.68V237.428C775.828 238.005 776.295 238.472 776.872 238.472H784.08C784.657 238.472 785.125 238.005 785.125 237.428V234.68C785.125 234.103 784.657 233.635 784.08 233.635H776.872C776.295 233.635 775.828 234.103 775.828 234.68Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M778.923 237.457V234.661",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M797.759 238.25C799.01 238.25 800.023 237.236 800.023 235.986C800.023 234.736 799.01 233.722 797.759 233.722C796.509 233.722 795.496 234.736 795.496 235.986C795.496 237.236 796.509 238.25 797.759 238.25Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M797.759 239.595C799.752 239.595 801.368 237.979 801.368 235.986C801.368 233.993 799.752 232.377 797.759 232.377C795.766 232.377 794.151 233.993 794.151 235.986C794.151 237.979 795.766 239.595 797.759 239.595Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M789.362 309.095C789.362 308.515 788.888 308.041 788.307 308.041C787.727 308.041 787.253 308.515 787.253 309.095C787.253 309.676 787.727 310.15 788.307 310.15C788.888 310.15 789.362 309.676 789.362 309.095Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M790.881 309.095C790.881 307.673 789.729 306.522 788.307 306.522C786.885 306.522 785.734 307.673 785.734 309.095C785.734 310.517 786.885 311.669 788.307 311.669C789.729 311.669 790.881 310.517 790.881 309.095Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M789.362 357.864C789.362 357.284 788.888 356.81 788.307 356.81C787.727 356.81 787.253 357.284 787.253 357.864C787.253 358.445 787.727 358.919 788.307 358.919C788.888 358.919 789.362 358.445 789.362 357.864Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M790.881 357.864C790.881 356.442 789.729 355.291 788.307 355.291C786.885 355.291 785.734 356.442 785.734 357.864C785.734 359.286 786.885 360.437 788.307 360.437C789.729 360.437 790.881 359.286 790.881 357.864Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M781.178 357.864C781.178 356.442 780.026 355.291 778.604 355.291C777.182 355.291 776.031 356.442 776.031 357.864C776.031 359.286 777.182 360.437 778.604 360.437C780.026 360.437 781.178 359.286 781.178 357.864Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M824.944 314.242C824.944 313.662 824.47 313.188 823.89 313.188C823.309 313.188 822.835 313.662 822.835 314.242C822.835 314.823 823.309 315.297 823.89 315.297C824.47 315.297 824.944 314.823 824.944 314.242Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.453 314.242C826.453 312.82 825.302 311.669 823.88 311.669C822.458 311.669 821.307 312.82 821.307 314.242C821.307 315.664 822.458 316.815 823.88 316.815C825.302 316.815 826.453 315.664 826.453 314.242Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M816.76 314.242C816.76 312.82 815.608 311.669 814.186 311.669C812.764 311.669 811.613 312.82 811.613 314.242C811.613 315.664 812.764 316.815 814.186 316.815C815.608 316.815 816.76 315.664 816.76 314.242Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M785.657 393.582C785.657 392.46 784.747 391.541 783.616 391.541C782.484 391.541 781.574 392.45 781.574 393.582C781.574 394.714 782.484 395.623 783.616 395.623C784.747 395.623 785.657 394.714 785.657 393.582Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M796.028 393.582C796.028 392.46 795.119 391.541 793.987 391.541C792.855 391.541 791.945 392.45 791.945 393.582C791.945 394.714 792.855 395.623 793.987 395.623C795.119 395.623 796.028 394.714 796.028 393.582Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M799.907 357.864C799.907 357.284 799.433 356.81 798.853 356.81C798.272 356.81 797.798 357.284 797.798 357.864C797.798 358.445 798.272 358.919 798.853 358.919C799.433 358.919 799.907 358.445 799.907 357.864Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M801.426 357.864C801.426 356.442 800.275 355.291 798.853 355.291C797.431 355.291 796.279 356.442 796.279 357.864C796.279 359.286 797.431 360.437 798.853 360.437C800.275 360.437 801.426 359.286 801.426 357.864Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M777.182 319.863C777.24 319.824 777.259 319.756 777.23 319.698C777.191 319.64 777.124 319.621 777.065 319.65C776.108 320.201 775.518 321.237 775.518 322.349C775.518 324.061 776.911 325.464 778.613 325.464C780.316 325.464 781.709 324.071 781.709 322.349C781.709 321.237 781.119 320.211 780.161 319.65C780.103 319.611 780.026 319.64 779.997 319.698C779.958 319.756 779.987 319.834 780.045 319.863C780.926 320.376 781.477 321.324 781.477 322.349C781.477 323.926 780.2 325.213 778.623 325.213C777.046 325.213 775.769 323.926 775.769 322.349C775.769 321.333 776.311 320.376 777.191 319.863H777.182Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M778.73 321.991V319.012C778.73 318.944 778.672 318.886 778.604 318.886C778.536 318.886 778.478 318.944 778.478 319.012V321.991C778.478 322.059 778.536 322.117 778.604 322.117C778.672 322.117 778.73 322.059 778.73 321.991Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M776.233 326.925C774.666 326.055 773.602 324.352 773.602 322.388C773.602 319.805 775.46 317.657 777.878 317.29",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M779.33 317.299C781.758 317.657 783.625 319.805 783.625 322.398C783.625 324.178 782.745 325.745 781.419 326.664",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M795.437 319.863C795.495 319.824 795.515 319.756 795.486 319.698C795.447 319.64 795.379 319.621 795.321 319.65C794.364 320.201 793.773 321.237 793.773 322.349C793.773 324.061 795.167 325.464 796.869 325.464C798.572 325.464 799.965 324.071 799.965 322.349C799.965 321.237 799.375 320.211 798.417 319.65C798.359 319.611 798.282 319.64 798.253 319.698C798.214 319.756 798.243 319.834 798.301 319.863C799.181 320.376 799.733 321.324 799.733 322.349C799.733 323.926 798.456 325.213 796.879 325.213C795.302 325.213 794.025 323.926 794.025 322.349C794.025 321.333 794.567 320.376 795.447 319.863H795.437Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M796.985 321.991V319.012C796.985 318.944 796.927 318.886 796.86 318.886C796.792 318.886 796.734 318.944 796.734 319.012V321.991C796.734 322.059 796.792 322.117 796.86 322.117C796.927 322.117 796.985 322.059 796.985 321.991Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M794.489 326.925C792.922 326.055 791.858 324.352 791.858 322.388C791.858 319.805 793.715 317.657 796.134 317.29",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M797.585 317.299C800.013 317.657 801.88 319.805 801.88 322.398C801.88 324.178 801 325.745 799.675 326.664",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M817.611 295.88C817.669 295.841 817.688 295.774 817.659 295.716C817.62 295.658 817.553 295.638 817.495 295.667C816.537 296.219 815.947 297.254 815.947 298.366C815.947 300.079 817.34 301.482 819.043 301.482C820.745 301.482 822.138 300.088 822.138 298.366C822.138 297.254 821.548 296.228 820.59 295.667C820.532 295.629 820.455 295.658 820.426 295.716C820.387 295.774 820.416 295.851 820.474 295.88C821.355 296.393 821.906 297.341 821.906 298.366C821.906 299.943 820.629 301.23 819.052 301.23C817.475 301.23 816.198 299.943 816.198 298.366C816.198 297.351 816.74 296.393 817.62 295.88H817.611Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M819.159 298.009V295.029C819.159 294.961 819.101 294.903 819.033 294.903C818.965 294.903 818.907 294.961 818.907 295.029V298.009C818.907 298.076 818.965 298.134 819.033 298.134C819.101 298.134 819.159 298.076 819.159 298.009Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M816.663 302.952C815.096 302.081 814.032 300.379 814.032 298.415C814.032 295.832 815.889 293.684 818.308 293.316",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M819.759 293.316C822.187 293.674 824.054 295.822 824.054 298.415C824.054 300.195 823.174 301.762 821.848 302.681",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M777.182 336.89C777.24 336.851 777.259 336.783 777.23 336.725C777.191 336.667 777.124 336.648 777.065 336.677C776.108 337.228 775.518 338.264 775.518 339.376C775.518 341.089 776.911 342.491 778.613 342.491C780.316 342.491 781.709 341.098 781.709 339.376C781.709 338.264 781.119 337.238 780.161 336.677C780.103 336.638 780.026 336.667 779.997 336.725C779.958 336.783 779.987 336.861 780.045 336.89C780.926 337.403 781.477 338.351 781.477 339.376C781.477 340.953 780.2 342.24 778.623 342.24C777.046 342.24 775.769 340.953 775.769 339.376C775.769 338.36 776.311 337.403 777.191 336.89H777.182Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M778.73 339.018V336.039C778.73 335.971 778.672 335.913 778.604 335.913C778.536 335.913 778.478 335.971 778.478 336.039V339.018C778.478 339.086 778.536 339.144 778.604 339.144C778.672 339.144 778.73 339.086 778.73 339.018Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M776.233 343.962C774.666 343.091 773.602 341.388 773.602 339.425C773.602 336.842 775.46 334.694 777.878 334.326",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M779.33 334.326C781.758 334.684 783.625 336.832 783.625 339.425C783.625 341.205 782.745 342.772 781.419 343.691",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M795.437 336.89C795.495 336.851 795.515 336.783 795.486 336.725C795.447 336.667 795.379 336.648 795.321 336.677C794.364 337.228 793.773 338.264 793.773 339.376C793.773 341.089 795.167 342.491 796.869 342.491C798.572 342.491 799.965 341.098 799.965 339.376C799.965 338.264 799.375 337.238 798.417 336.677C798.359 336.638 798.282 336.667 798.253 336.725C798.214 336.783 798.243 336.861 798.301 336.89C799.181 337.403 799.733 338.351 799.733 339.376C799.733 340.953 798.456 342.24 796.879 342.24C795.302 342.24 794.025 340.953 794.025 339.376C794.025 338.36 794.567 337.403 795.447 336.89H795.437Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M796.985 339.018V336.039C796.985 335.971 796.927 335.913 796.86 335.913C796.792 335.913 796.734 335.971 796.734 336.039V339.018C796.734 339.086 796.792 339.144 796.86 339.144C796.927 339.144 796.985 339.086 796.985 339.018Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M794.489 343.962C792.922 343.091 791.858 341.388 791.858 339.425C791.858 336.842 793.715 334.694 796.134 334.326",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M797.585 334.326C800.013 334.684 801.88 336.832 801.88 339.425C801.88 341.205 801 342.772 799.675 343.691",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M777.182 369.909C777.24 369.87 777.259 369.802 777.23 369.744C777.191 369.686 777.124 369.667 777.065 369.696C776.108 370.247 775.518 371.282 775.518 372.395C775.518 374.107 776.911 375.51 778.613 375.51C780.316 375.51 781.709 374.117 781.709 372.395C781.709 371.282 781.119 370.257 780.161 369.696C780.103 369.657 780.026 369.686 779.997 369.744C779.958 369.802 779.987 369.88 780.045 369.909C780.926 370.421 781.477 371.37 781.477 372.395C781.477 373.972 780.2 375.259 778.623 375.259C777.046 375.259 775.769 373.972 775.769 372.395C775.769 371.379 776.311 370.421 777.191 369.909H777.182Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M778.73 372.027V369.048C778.73 368.98 778.672 368.922 778.604 368.922C778.536 368.922 778.478 368.98 778.478 369.048V372.027C778.478 372.095 778.536 372.153 778.604 372.153C778.672 372.153 778.73 372.095 778.73 372.027Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M776.233 376.971C774.666 376.1 773.602 374.398 773.602 372.434C773.602 369.851 775.46 367.703 777.878 367.335",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M779.33 367.335C781.758 367.693 783.625 369.841 783.625 372.434C783.625 374.214 782.745 375.781 781.419 376.7",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M795.437 369.909C795.495 369.87 795.515 369.802 795.486 369.744C795.447 369.686 795.379 369.667 795.321 369.696C794.364 370.247 793.773 371.282 793.773 372.395C793.773 374.107 795.167 375.51 796.869 375.51C798.572 375.51 799.965 374.117 799.965 372.395C799.965 371.282 799.375 370.257 798.417 369.696C798.359 369.657 798.282 369.686 798.253 369.744C798.214 369.802 798.243 369.88 798.301 369.909C799.181 370.421 799.733 371.37 799.733 372.395C799.733 373.972 798.456 375.259 796.879 375.259C795.302 375.259 794.025 373.972 794.025 372.395C794.025 371.379 794.567 370.421 795.447 369.909H795.437Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M796.985 372.027V369.048C796.985 368.98 796.927 368.922 796.86 368.922C796.792 368.922 796.734 368.98 796.734 369.048V372.027C796.734 372.095 796.792 372.153 796.86 372.153C796.927 372.153 796.985 372.095 796.985 372.027Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M794.489 376.971C792.922 376.1 791.858 374.398 791.858 372.434C791.858 369.851 793.715 367.703 796.134 367.335",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M797.585 367.335C800.013 367.693 801.88 369.841 801.88 372.434C801.88 374.214 801 375.781 799.675 376.7",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M786.885 264.768C786.943 264.729 786.963 264.661 786.934 264.603C786.895 264.545 786.827 264.526 786.769 264.555C785.811 265.106 785.221 266.141 785.221 267.254C785.221 268.966 786.614 270.369 788.317 270.369C790.02 270.369 791.413 268.976 791.413 267.254C791.413 266.141 790.823 265.116 789.865 264.555C789.807 264.516 789.729 264.545 789.7 264.603C789.662 264.661 789.691 264.739 789.749 264.768C790.629 265.28 791.181 266.228 791.181 267.254C791.181 268.831 789.904 270.118 788.327 270.118C786.75 270.118 785.473 268.831 785.473 267.254C785.473 266.238 786.014 265.28 786.895 264.768H786.885Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M788.434 266.886V263.907C788.434 263.839 788.376 263.781 788.308 263.781C788.24 263.781 788.182 263.839 788.182 263.907V266.886C788.182 266.954 788.24 267.012 788.308 267.012C788.376 267.012 788.434 266.954 788.434 266.886Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M785.937 271.83C784.37 270.959 783.306 269.256 783.306 267.293C783.306 264.709 785.163 262.562 787.582 262.194",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M789.033 262.194C791.461 262.552 793.329 264.7 793.329 267.293C793.329 269.073 792.448 270.64 791.123 271.559",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M817.611 264.768C817.669 264.729 817.688 264.661 817.659 264.603C817.62 264.545 817.553 264.526 817.495 264.555C816.537 265.106 815.947 266.141 815.947 267.254C815.947 268.966 817.34 270.369 819.043 270.369C820.745 270.369 822.138 268.976 822.138 267.254C822.138 266.141 821.548 265.116 820.59 264.555C820.532 264.516 820.455 264.545 820.426 264.603C820.387 264.661 820.416 264.739 820.474 264.768C821.355 265.28 821.906 266.228 821.906 267.254C821.906 268.831 820.629 270.118 819.052 270.118C817.475 270.118 816.198 268.831 816.198 267.254C816.198 266.238 816.74 265.28 817.62 264.768H817.611Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M819.159 266.886V263.907C819.159 263.839 819.101 263.781 819.033 263.781C818.965 263.781 818.907 263.839 818.907 263.907V266.886C818.907 266.954 818.965 267.012 819.033 267.012C819.101 267.012 819.159 266.954 819.159 266.886Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M816.663 271.83C815.096 270.959 814.032 269.256 814.032 267.293C814.032 264.709 815.889 262.562 818.308 262.194",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M819.759 262.194C822.187 262.552 824.054 264.7 824.054 267.293C824.054 269.073 823.174 270.64 821.848 271.559",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M830.372 153.589V255.412",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M830.372 261.352V272.952",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M830.372 276.831V288.441",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M830.372 292.862V304.471",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M830.372 308.186V347.687",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M830.372 350.792V375.849",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.658 330.331C834.658 330.418 834.725 330.486 834.813 330.486H841.236C841.323 330.486 841.391 330.418 841.391 330.331C841.391 330.244 841.323 330.176 841.236 330.176H834.813C834.725 330.176 834.658 330.244 834.658 330.331Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.798 330.176H843.375C843.287 330.176 843.22 330.244 843.22 330.331C843.22 330.418 843.287 330.486 843.375 330.486H849.798C849.885 330.486 849.953 330.418 849.953 330.331C849.953 330.244 849.885 330.176 849.798 330.176Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.822 332.895H841.246C841.333 332.895 841.4 332.827 841.4 332.74C841.4 332.653 841.333 332.585 841.246 332.585H834.822C834.735 332.585 834.667 332.653 834.667 332.74C834.667 332.827 834.735 332.895 834.822 332.895Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.798 332.585H843.375C843.287 332.585 843.22 332.653 843.22 332.74C843.22 332.827 843.287 332.895 843.375 332.895H849.798C849.885 332.895 849.953 332.827 849.953 332.74C849.953 332.653 849.885 332.585 849.798 332.585Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.822 335.303H841.246C841.333 335.303 841.4 335.236 841.4 335.149C841.4 335.062 841.333 334.994 841.246 334.994H834.822C834.735 334.994 834.667 335.062 834.667 335.149C834.667 335.236 834.735 335.303 834.822 335.303Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.798 334.994H843.375C843.287 334.994 843.22 335.062 843.22 335.149C843.22 335.236 843.287 335.303 843.375 335.303H849.798C849.885 335.303 849.953 335.236 849.953 335.149C849.953 335.062 849.885 334.994 849.798 334.994Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.822 337.712H841.246C841.333 337.712 841.4 337.645 841.4 337.558C841.4 337.471 841.333 337.403 841.246 337.403H834.822C834.735 337.403 834.667 337.471 834.667 337.558C834.667 337.645 834.735 337.712 834.822 337.712Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.798 337.403H843.375C843.287 337.403 843.22 337.471 843.22 337.558C843.22 337.645 843.287 337.712 843.375 337.712H849.798C849.885 337.712 849.953 337.645 849.953 337.558C849.953 337.471 849.885 337.403 849.798 337.403Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.822 340.121H841.246C841.333 340.121 841.4 340.054 841.4 339.967C841.4 339.879 841.333 339.812 841.246 339.812H834.822C834.735 339.812 834.667 339.879 834.667 339.967C834.667 340.054 834.735 340.121 834.822 340.121Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M836.593 342.491H847.602C847.747 342.491 847.873 342.424 847.873 342.337C847.873 342.25 847.757 342.182 847.602 342.182H836.593C836.448 342.182 836.322 342.25 836.322 342.337C836.322 342.424 836.438 342.491 836.593 342.491Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.798 339.802H843.375C843.287 339.802 843.22 339.87 843.22 339.957C843.22 340.044 843.287 340.112 843.375 340.112H849.798C849.885 340.112 849.953 340.044 849.953 339.957C849.953 339.87 849.885 339.802 849.798 339.802Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.822 344.939H841.246C841.333 344.939 841.4 344.871 841.4 344.784C841.4 344.697 841.333 344.629 841.246 344.629H834.822C834.735 344.629 834.667 344.697 834.667 344.784C834.667 344.871 834.735 344.939 834.822 344.939Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.798 344.62H843.375C843.287 344.62 843.22 344.688 843.22 344.775C843.22 344.862 843.287 344.929 843.375 344.929H849.798C849.885 344.929 849.953 344.862 849.953 344.775C849.953 344.688 849.885 344.62 849.798 344.62Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.822 347.338H841.246C841.333 347.338 841.4 347.271 841.4 347.184C841.4 347.097 841.333 347.029 841.246 347.029H834.822C834.735 347.029 834.667 347.097 834.667 347.184C834.667 347.271 834.735 347.338 834.822 347.338Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.798 347.029H843.375C843.287 347.029 843.22 347.097 843.22 347.184C843.22 347.271 843.287 347.338 843.375 347.338H849.798C849.885 347.338 849.953 347.271 849.953 347.184C849.953 347.097 849.885 347.029 849.798 347.029Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.822 349.747H841.246C841.333 349.747 841.4 349.68 841.4 349.593C841.4 349.505 841.333 349.438 841.246 349.438H834.822C834.735 349.438 834.667 349.505 834.667 349.593C834.667 349.68 834.735 349.747 834.822 349.747Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.798 349.438H843.375C843.287 349.438 843.22 349.505 843.22 349.593C843.22 349.68 843.287 349.747 843.375 349.747H849.798C849.885 349.747 849.953 349.68 849.953 349.593C849.953 349.505 849.885 349.438 849.798 349.438Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.822 352.156H841.246C841.333 352.156 841.4 352.089 841.4 352.001C841.4 351.914 841.333 351.847 841.246 351.847H834.822C834.735 351.847 834.667 351.914 834.667 352.001C834.667 352.089 834.735 352.156 834.822 352.156Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.798 351.847H843.375C843.287 351.847 843.22 351.914 843.22 352.001C843.22 352.089 843.287 352.156 843.375 352.156H849.798C849.885 352.156 849.953 352.089 849.953 352.001C849.953 351.914 849.885 351.847 849.798 351.847Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.822 354.507H841.246C841.333 354.507 841.4 354.439 841.4 354.352C841.4 354.265 841.333 354.198 841.246 354.198H834.822C834.735 354.198 834.667 354.265 834.667 354.352C834.667 354.439 834.735 354.507 834.822 354.507Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.798 354.188H843.375C843.287 354.188 843.22 354.256 843.22 354.343C843.22 354.43 843.287 354.498 843.375 354.498H849.798C849.885 354.498 849.953 354.43 849.953 354.343C849.953 354.256 849.885 354.188 849.798 354.188Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M840.849 373.034C840.907 373.034 840.955 372.985 840.955 372.927V371.06C840.955 371.002 840.907 370.954 840.849 370.954C840.791 370.954 840.742 371.002 840.742 371.06V372.927C840.742 372.985 840.791 373.034 840.849 373.034Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M838.198 369.648V374.388C838.198 374.756 838.498 375.055 838.866 375.055H845.754C846.122 375.055 846.421 374.756 846.421 374.388V369.648C846.421 369.28 846.122 368.98 845.754 368.98H838.866C838.498 368.98 838.198 369.28 838.198 369.648ZM846.209 369.648V374.388C846.209 374.639 846.005 374.843 845.754 374.843H838.866C838.614 374.843 838.411 374.639 838.411 374.388V369.648C838.411 369.396 838.614 369.193 838.866 369.193H845.754C846.005 369.193 846.209 369.396 846.209 369.648Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M839.94 373.982H844.68C845.048 373.982 845.347 373.682 845.347 373.314V370.721C845.347 370.354 845.048 370.054 844.68 370.054H839.94C839.572 370.054 839.272 370.354 839.272 370.721V373.314C839.272 373.682 839.572 373.982 839.94 373.982ZM839.485 370.731C839.485 370.479 839.688 370.276 839.94 370.276H844.68C844.931 370.276 845.135 370.479 845.135 370.731V373.324C845.135 373.575 844.931 373.778 844.68 373.778H839.94C839.688 373.778 839.485 373.575 839.485 373.324V370.731Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M834.58 193.457V251.252",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M842.281 159.994C842.281 159.839 842.155 159.723 842 159.752C840.907 159.984 840.085 160.951 840.085 162.112C840.085 163.447 841.168 164.521 842.494 164.521C843.829 164.521 844.903 163.438 844.903 162.112C844.903 160.884 843.984 159.868 842.794 159.713C842.649 159.694 842.533 159.81 842.533 159.955V161.3C842.533 161.367 842.475 161.425 842.407 161.425C842.339 161.425 842.281 161.367 842.281 161.3V159.984V159.994Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M839.166 159.045L840.094 159.974",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M841.265 158.117L841.497 159.278",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M843.587 158.117L843.354 159.278",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M845.444 159.045L844.748 159.974",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M842.31 285.838C844.132 285.838 845.609 284.361 845.609 282.539C845.609 280.717 844.132 279.24 842.31 279.24C840.488 279.24 839.011 280.717 839.011 282.539C839.011 284.361 840.488 285.838 842.31 285.838Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M839.485 173.267C838.624 172.87 837.657 172.967 836.902 173.441L838.479 175.676C838.518 175.734 838.508 175.802 838.45 175.84C838.392 175.879 838.324 175.869 838.286 175.811L836.709 173.577C836.38 173.828 836.099 174.167 835.906 174.573C835.277 175.918 835.867 177.524 837.212 178.153C838.557 178.781 840.162 178.191 840.791 176.847C841.42 175.502 840.83 173.896 839.485 173.267Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M836.273 172.735L836.477 173.025",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M835.064 174.177L835.383 174.322",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M841.313 177.108L841.633 177.253",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M834.735 176.024L835.083 175.995",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M841.613 175.434L841.962 175.405",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M835.374 177.785L835.664 177.582",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M841.033 173.838L841.323 173.635",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M836.806 179.004L836.96 178.675",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M839.737 172.745L839.892 172.425",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M838.654 179.333L838.625 178.985",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M838.073 172.454L838.044 172.096",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M851.355 181.413C850.872 180.59 850.03 180.116 849.14 180.078L849.159 182.815C849.159 182.883 849.101 182.941 849.043 182.941C848.976 182.941 848.927 182.883 848.927 182.825L848.908 180.087C848.492 180.107 848.066 180.223 847.679 180.445C846.393 181.19 845.957 182.845 846.702 184.131C847.447 185.418 849.101 185.853 850.388 185.108C851.675 184.363 852.11 182.709 851.365 181.422L851.355 181.413Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M849.024 179.139V179.497",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M847.215 179.623L847.389 179.932",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M850.669 185.602L850.843 185.911",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M845.89 180.958L846.19 181.132",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M851.868 184.402L852.168 184.586",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M845.396 182.767H845.754",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M852.304 182.767H852.662",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M845.89 184.586L846.19 184.402",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M851.868 181.132L852.168 180.958",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M847.215 185.911L847.389 185.602",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M850.669 179.932L850.843 179.623",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M848.212 314.242C848.212 313.662 847.738 313.188 847.157 313.188C846.577 313.188 846.103 313.662 846.103 314.242C846.103 314.823 846.577 315.297 847.157 315.297C847.738 315.297 848.212 314.823 848.212 314.242Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.73 314.242C849.73 312.82 848.579 311.669 847.157 311.669C845.735 311.669 844.583 312.82 844.583 314.242C844.583 315.664 845.735 316.815 847.157 316.815C848.579 316.815 849.73 315.664 849.73 314.242Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M840.027 314.242C840.027 312.82 838.875 311.669 837.453 311.669C836.031 311.669 834.88 312.82 834.88 314.242C834.88 315.664 836.031 316.815 837.453 316.815C838.875 316.815 840.027 315.664 840.027 314.242Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M840.878 295.88C840.936 295.841 840.956 295.774 840.927 295.716C840.888 295.658 840.82 295.638 840.762 295.667C839.804 296.219 839.214 297.254 839.214 298.366C839.214 300.079 840.607 301.482 842.31 301.482C844.013 301.482 845.406 300.088 845.406 298.366C845.406 297.254 844.816 296.228 843.858 295.667C843.8 295.629 843.723 295.658 843.694 295.716C843.655 295.774 843.684 295.851 843.742 295.88C844.622 296.393 845.174 297.341 845.174 298.366C845.174 299.943 843.897 301.23 842.32 301.23C840.743 301.23 839.466 299.943 839.466 298.366C839.466 297.351 840.008 296.393 840.888 295.88H840.878Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M842.436 298.009V295.029C842.436 294.961 842.378 294.903 842.31 294.903C842.242 294.903 842.184 294.961 842.184 295.029V298.009C842.184 298.076 842.242 298.134 842.31 298.134C842.378 298.134 842.436 298.076 842.436 298.009Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M839.93 302.952C838.363 302.081 837.299 300.379 837.299 298.415C837.299 295.832 839.156 293.684 841.575 293.316",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M843.026 293.316C845.454 293.674 847.321 295.822 847.321 298.415C847.321 300.195 846.441 301.762 845.116 302.681",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M840.878 264.768C840.936 264.729 840.956 264.661 840.927 264.603C840.888 264.545 840.82 264.526 840.762 264.555C839.804 265.106 839.214 266.141 839.214 267.254C839.214 268.966 840.607 270.369 842.31 270.369C844.013 270.369 845.406 268.976 845.406 267.254C845.406 266.141 844.816 265.116 843.858 264.555C843.8 264.516 843.723 264.545 843.694 264.603C843.655 264.661 843.684 264.739 843.742 264.768C844.622 265.28 845.174 266.228 845.174 267.254C845.174 268.831 843.897 270.118 842.32 270.118C840.743 270.118 839.466 268.831 839.466 267.254C839.466 266.238 840.008 265.28 840.888 264.768H840.878Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M842.436 266.886V263.907C842.436 263.839 842.378 263.781 842.31 263.781C842.242 263.781 842.184 263.839 842.184 263.907V266.886C842.184 266.954 842.242 267.012 842.31 267.012C842.378 267.012 842.436 266.954 842.436 266.886Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M839.93 271.83C838.363 270.959 837.299 269.256 837.299 267.293C837.299 264.709 839.156 262.562 841.575 262.194",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M843.026 262.194C845.454 262.552 847.321 264.7 847.321 267.293C847.321 269.073 846.441 270.64 845.116 271.559",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M853.774 153.589V255.412",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M853.774 261.352V272.952",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M853.774 276.831V288.441",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M853.774 292.862V304.471",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M853.774 308.186V347.687",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M853.774 350.792V375.849",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M857.876 330.331C857.876 330.418 857.944 330.486 858.031 330.486H864.455C864.542 330.486 864.609 330.418 864.609 330.331C864.609 330.244 864.542 330.176 864.455 330.176H858.031C857.944 330.176 857.876 330.244 857.876 330.331Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M873.017 330.176H866.593C866.506 330.176 866.438 330.244 866.438 330.331C866.438 330.418 866.506 330.486 866.593 330.486H873.017C873.104 330.486 873.171 330.418 873.171 330.331C873.171 330.244 873.104 330.176 873.017 330.176Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M858.031 332.895H864.455C864.542 332.895 864.609 332.827 864.609 332.74C864.609 332.653 864.542 332.585 864.455 332.585H858.031C857.944 332.585 857.876 332.653 857.876 332.74C857.876 332.827 857.944 332.895 858.031 332.895Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M873.017 332.585H866.593C866.506 332.585 866.438 332.653 866.438 332.74C866.438 332.827 866.506 332.895 866.593 332.895H873.017C873.104 332.895 873.171 332.827 873.171 332.74C873.171 332.653 873.104 332.585 873.017 332.585Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M858.031 335.303H864.455C864.542 335.303 864.609 335.236 864.609 335.149C864.609 335.062 864.542 334.994 864.455 334.994H858.031C857.944 334.994 857.876 335.062 857.876 335.149C857.876 335.236 857.944 335.303 858.031 335.303Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M873.017 334.994H866.593C866.506 334.994 866.438 335.062 866.438 335.149C866.438 335.236 866.506 335.303 866.593 335.303H873.017C873.104 335.303 873.171 335.236 873.171 335.149C873.171 335.062 873.104 334.994 873.017 334.994Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M858.031 337.712H864.455C864.542 337.712 864.609 337.645 864.609 337.558C864.609 337.471 864.542 337.403 864.455 337.403H858.031C857.944 337.403 857.876 337.471 857.876 337.558C857.876 337.645 857.944 337.712 858.031 337.712Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M873.017 337.403H866.593C866.506 337.403 866.438 337.471 866.438 337.558C866.438 337.645 866.506 337.712 866.593 337.712H873.017C873.104 337.712 873.171 337.645 873.171 337.558C873.171 337.471 873.104 337.403 873.017 337.403Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M858.031 340.121H864.455C864.542 340.121 864.609 340.054 864.609 339.967C864.609 339.879 864.542 339.812 864.455 339.812H858.031C857.944 339.812 857.876 339.879 857.876 339.967C857.876 340.054 857.944 340.121 858.031 340.121Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M859.811 342.491H870.821C870.966 342.491 871.092 342.424 871.092 342.337C871.092 342.25 870.976 342.182 870.821 342.182H859.811C859.666 342.182 859.541 342.25 859.541 342.337C859.541 342.424 859.657 342.491 859.811 342.491Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M873.017 339.802H866.593C866.506 339.802 866.438 339.87 866.438 339.957C866.438 340.044 866.506 340.112 866.593 340.112H873.017C873.104 340.112 873.171 340.044 873.171 339.957C873.171 339.87 873.104 339.802 873.017 339.802Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M858.031 344.939H864.455C864.542 344.939 864.609 344.871 864.609 344.784C864.609 344.697 864.542 344.629 864.455 344.629H858.031C857.944 344.629 857.876 344.697 857.876 344.784C857.876 344.871 857.944 344.939 858.031 344.939Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M873.017 344.62H866.593C866.506 344.62 866.438 344.688 866.438 344.775C866.438 344.862 866.506 344.929 866.593 344.929H873.017C873.104 344.929 873.171 344.862 873.171 344.775C873.171 344.688 873.104 344.62 873.017 344.62Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M858.031 347.338H864.455C864.542 347.338 864.609 347.271 864.609 347.184C864.609 347.097 864.542 347.029 864.455 347.029H858.031C857.944 347.029 857.876 347.097 857.876 347.184C857.876 347.271 857.944 347.338 858.031 347.338Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M873.017 347.029H866.593C866.506 347.029 866.438 347.097 866.438 347.184C866.438 347.271 866.506 347.338 866.593 347.338H873.017C873.104 347.338 873.171 347.271 873.171 347.184C873.171 347.097 873.104 347.029 873.017 347.029Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M858.031 349.747H864.455C864.542 349.747 864.609 349.68 864.609 349.593C864.609 349.505 864.542 349.438 864.455 349.438H858.031C857.944 349.438 857.876 349.505 857.876 349.593C857.876 349.68 857.944 349.747 858.031 349.747Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M873.017 349.438H866.593C866.506 349.438 866.438 349.505 866.438 349.593C866.438 349.68 866.506 349.747 866.593 349.747H873.017C873.104 349.747 873.171 349.68 873.171 349.593C873.171 349.505 873.104 349.438 873.017 349.438Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M858.031 352.156H864.455C864.542 352.156 864.609 352.089 864.609 352.001C864.609 351.914 864.542 351.847 864.455 351.847H858.031C857.944 351.847 857.876 351.914 857.876 352.001C857.876 352.089 857.944 352.156 858.031 352.156Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M873.017 351.847H866.593C866.506 351.847 866.438 351.914 866.438 352.001C866.438 352.089 866.506 352.156 866.593 352.156H873.017C873.104 352.156 873.171 352.089 873.171 352.001C873.171 351.914 873.104 351.847 873.017 351.847Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M858.031 354.507H864.455C864.542 354.507 864.609 354.439 864.609 354.352C864.609 354.265 864.542 354.198 864.455 354.198H858.031C857.944 354.198 857.876 354.265 857.876 354.352C857.876 354.439 857.944 354.507 858.031 354.507Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M873.017 354.188H866.593C866.506 354.188 866.438 354.256 866.438 354.343C866.438 354.43 866.506 354.498 866.593 354.498H873.017C873.104 354.498 873.171 354.43 873.171 354.343C873.171 354.256 873.104 354.188 873.017 354.188Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M864.067 373.034C864.125 373.034 864.174 372.985 864.174 372.927V371.06C864.174 371.002 864.125 370.954 864.067 370.954C864.009 370.954 863.961 371.002 863.961 371.06V372.927C863.961 372.985 864.009 373.034 864.067 373.034Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M861.417 369.648V374.388C861.417 374.756 861.716 375.055 862.084 375.055H868.972C869.34 375.055 869.64 374.756 869.64 374.388V369.648C869.64 369.28 869.34 368.98 868.972 368.98H862.084C861.716 368.98 861.417 369.28 861.417 369.648ZM869.427 369.648V374.388C869.427 374.639 869.224 374.843 868.972 374.843H862.084C861.832 374.843 861.629 374.639 861.629 374.388V369.648C861.629 369.396 861.832 369.193 862.084 369.193H868.972C869.224 369.193 869.427 369.396 869.427 369.648Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M863.158 373.982H867.898C868.266 373.982 868.566 373.682 868.566 373.314V370.721C868.566 370.354 868.266 370.054 867.898 370.054H863.158C862.79 370.054 862.49 370.354 862.49 370.721V373.314C862.49 373.682 862.79 373.982 863.158 373.982ZM862.703 370.731C862.703 370.479 862.906 370.276 863.158 370.276H867.898C868.15 370.276 868.353 370.479 868.353 370.731V373.324C868.353 373.575 868.15 373.778 867.898 373.778H863.158C862.906 373.778 862.703 373.575 862.703 373.324V370.731Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M857.982 193.457V251.252",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M865.499 159.994C865.499 159.839 865.374 159.723 865.219 159.752C864.126 159.984 863.303 160.951 863.303 162.112C863.303 163.447 864.387 164.521 865.712 164.521C867.047 164.521 868.121 163.438 868.121 162.112C868.121 160.884 867.202 159.868 866.012 159.713C865.867 159.694 865.751 159.81 865.751 159.955V161.3C865.751 161.367 865.693 161.425 865.625 161.425C865.557 161.425 865.499 161.367 865.499 161.3V159.984V159.994Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M862.384 159.045L863.313 159.974",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M864.483 158.117L864.716 159.278",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M866.805 158.117L866.573 159.278",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M868.663 159.045L867.966 159.974",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M865.528 285.838C867.35 285.838 868.827 284.361 868.827 282.539C868.827 280.717 867.35 279.24 865.528 279.24C863.706 279.24 862.229 280.717 862.229 282.539C862.229 284.361 863.706 285.838 865.528 285.838Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M863.835 174.215C863.294 173.431 862.404 173.035 861.523 173.064L861.755 175.792C861.755 175.86 861.717 175.918 861.649 175.927C861.581 175.927 861.523 175.879 861.523 175.821L861.291 173.093C860.875 173.141 860.469 173.296 860.101 173.547C858.882 174.399 858.572 176.072 859.424 177.301C860.275 178.52 861.949 178.82 863.177 177.978C864.406 177.137 864.706 175.453 863.855 174.225L863.835 174.215Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M861.339 172.135L861.368 172.493",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M859.569 172.764L859.772 173.064",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M863.487 178.452L863.69 178.743",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M858.35 174.196L858.669 174.35",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M864.589 177.166L864.909 177.311",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M858.011 176.043L858.36 176.014",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M864.89 175.492L865.248 175.463",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M858.64 177.814L858.93 177.62",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M864.329 173.896L864.619 173.693",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M860.072 179.033L860.217 178.714",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M863.032 172.803L863.187 172.474",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.864 174.215C959.322 173.431 958.432 173.035 957.551 173.064L957.784 175.792C957.784 175.86 957.745 175.918 957.677 175.927C957.61 175.927 957.551 175.879 957.551 175.821L957.319 173.093C956.903 173.141 956.497 173.296 956.129 173.547C954.91 174.399 954.601 176.072 955.452 177.301C956.303 178.52 957.977 178.82 959.206 177.978C960.425 177.127 960.734 175.453 959.883 174.225L959.864 174.215Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M957.368 172.135L957.397 172.493",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M955.597 172.764L955.791 173.064",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M959.515 178.452L959.718 178.743",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M954.378 174.196L954.698 174.35",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M960.608 177.166L960.937 177.311",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M954.04 176.043L954.388 176.014",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M960.918 175.492L961.276 175.463",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M954.668 177.814L954.958 177.62",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M960.347 173.896L960.647 173.693",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M956.1 179.033L956.245 178.714",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M959.061 172.803L959.215 172.474",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M874.758 181.413C874.275 180.59 873.433 180.116 872.543 180.078L872.562 182.815C872.562 182.883 872.504 182.941 872.446 182.941C872.378 182.941 872.33 182.883 872.33 182.825L872.311 180.087C871.895 180.107 871.469 180.223 871.082 180.445C869.795 181.19 869.36 182.845 870.105 184.131C870.85 185.418 872.504 185.853 873.791 185.108C875.078 184.363 875.513 182.709 874.768 181.422L874.758 181.413Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M872.426 179.139V179.497",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M870.617 179.623L870.791 179.932",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M874.062 185.602L874.245 185.911",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M869.282 180.958L869.592 181.132",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M875.261 184.402L875.571 184.586",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M868.798 182.767H869.156",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M875.706 182.767H876.054",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M869.282 184.586L869.592 184.402",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M875.261 181.132L875.571 180.958",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M870.617 185.911L870.782 185.602",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M874.062 179.932L874.245 179.623",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M871.43 314.242C871.43 313.662 870.956 313.188 870.376 313.188C869.795 313.188 869.321 313.662 869.321 314.242C869.321 314.823 869.795 315.297 870.376 315.297C870.956 315.297 871.43 314.823 871.43 314.242Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M872.949 314.242C872.949 312.82 871.797 311.669 870.375 311.669C868.953 311.669 867.802 312.82 867.802 314.242C867.802 315.664 868.953 316.815 870.375 316.815C871.797 316.815 872.949 315.664 872.949 314.242Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M863.245 314.242C863.245 312.82 862.094 311.669 860.672 311.669C859.25 311.669 858.099 312.82 858.099 314.242C858.099 315.664 859.25 316.815 860.672 316.815C862.094 316.815 863.245 315.664 863.245 314.242Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M864.097 295.88C864.155 295.841 864.174 295.774 864.145 295.716C864.106 295.658 864.039 295.638 863.981 295.667C863.023 296.219 862.433 297.254 862.433 298.366C862.433 300.079 863.826 301.482 865.528 301.482C867.231 301.482 868.624 300.088 868.624 298.366C868.624 297.254 868.034 296.228 867.076 295.667C867.018 295.629 866.941 295.658 866.912 295.716C866.873 295.774 866.902 295.851 866.96 295.88C867.841 296.393 868.392 297.341 868.392 298.366C868.392 299.943 867.115 301.23 865.538 301.23C863.961 301.23 862.684 299.943 862.684 298.366C862.684 297.351 863.226 296.393 864.106 295.88H864.097Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M865.654 298.009V295.029C865.654 294.961 865.596 294.903 865.528 294.903C865.46 294.903 865.402 294.961 865.402 295.029V298.009C865.402 298.076 865.46 298.134 865.528 298.134C865.596 298.134 865.654 298.076 865.654 298.009Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M863.149 302.952C861.582 302.081 860.518 300.379 860.518 298.415C860.518 295.832 862.375 293.684 864.794 293.316",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M866.245 293.316C868.673 293.674 870.54 295.822 870.54 298.415C870.54 300.195 869.66 301.762 868.334 302.681",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M864.097 264.768C864.155 264.729 864.174 264.661 864.145 264.603C864.106 264.545 864.039 264.526 863.981 264.555C863.023 265.106 862.433 266.141 862.433 267.254C862.433 268.966 863.826 270.369 865.528 270.369C867.231 270.369 868.624 268.976 868.624 267.254C868.624 266.141 868.034 265.116 867.076 264.555C867.018 264.516 866.941 264.545 866.912 264.603C866.873 264.661 866.902 264.739 866.96 264.768C867.841 265.28 868.392 266.228 868.392 267.254C868.392 268.831 867.115 270.118 865.538 270.118C863.961 270.118 862.684 268.831 862.684 267.254C862.684 266.238 863.226 265.28 864.106 264.768H864.097Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M865.654 266.886V263.907C865.654 263.839 865.596 263.781 865.528 263.781C865.46 263.781 865.402 263.839 865.402 263.907V266.886C865.402 266.954 865.46 267.012 865.528 267.012C865.596 267.012 865.654 266.954 865.654 266.886Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M863.149 271.83C861.582 270.959 860.518 269.256 860.518 267.293C860.518 264.709 862.375 262.562 864.794 262.194",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M866.245 262.194C868.673 262.552 870.54 264.7 870.54 267.293C870.54 269.073 869.66 270.64 868.334 271.559",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M877.167 153.589V255.412",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M877.167 261.352V272.952",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M877.167 276.831V288.441",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M877.167 292.862V304.471",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M877.167 308.186V347.687",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M877.167 350.792V375.849",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M881.095 330.331C881.095 330.418 881.162 330.486 881.25 330.486H887.673C887.76 330.486 887.828 330.418 887.828 330.331C887.828 330.244 887.76 330.176 887.673 330.176H881.25C881.162 330.176 881.095 330.244 881.095 330.331Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M896.235 330.176H889.811C889.724 330.176 889.656 330.244 889.656 330.331C889.656 330.418 889.724 330.486 889.811 330.486H896.235C896.322 330.486 896.39 330.418 896.39 330.331C896.39 330.244 896.322 330.176 896.235 330.176Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M881.25 332.895H887.673C887.76 332.895 887.828 332.827 887.828 332.74C887.828 332.653 887.76 332.585 887.673 332.585H881.25C881.162 332.585 881.095 332.653 881.095 332.74C881.095 332.827 881.162 332.895 881.25 332.895Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M896.235 332.585H889.811C889.724 332.585 889.656 332.653 889.656 332.74C889.656 332.827 889.724 332.895 889.811 332.895H896.235C896.322 332.895 896.39 332.827 896.39 332.74C896.39 332.653 896.322 332.585 896.235 332.585Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M881.25 335.303H887.673C887.76 335.303 887.828 335.236 887.828 335.149C887.828 335.062 887.76 334.994 887.673 334.994H881.25C881.162 334.994 881.095 335.062 881.095 335.149C881.095 335.236 881.162 335.303 881.25 335.303Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M896.235 334.994H889.811C889.724 334.994 889.656 335.062 889.656 335.149C889.656 335.236 889.724 335.303 889.811 335.303H896.235C896.322 335.303 896.39 335.236 896.39 335.149C896.39 335.062 896.322 334.994 896.235 334.994Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M881.25 337.712H887.673C887.76 337.712 887.828 337.645 887.828 337.558C887.828 337.471 887.76 337.403 887.673 337.403H881.25C881.162 337.403 881.095 337.471 881.095 337.558C881.095 337.645 881.162 337.712 881.25 337.712Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M896.235 337.403H889.811C889.724 337.403 889.656 337.471 889.656 337.558C889.656 337.645 889.724 337.712 889.811 337.712H896.235C896.322 337.712 896.39 337.645 896.39 337.558C896.39 337.471 896.322 337.403 896.235 337.403Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M881.25 340.121H887.673C887.76 340.121 887.828 340.054 887.828 339.967C887.828 339.879 887.76 339.812 887.673 339.812H881.25C881.162 339.812 881.095 339.879 881.095 339.967C881.095 340.054 881.162 340.121 881.25 340.121Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M883.03 342.491H894.039C894.184 342.491 894.31 342.424 894.31 342.337C894.31 342.25 894.194 342.182 894.039 342.182H883.03C882.885 342.182 882.759 342.25 882.759 342.337C882.759 342.424 882.875 342.491 883.03 342.491Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M896.235 339.802H889.811C889.724 339.802 889.656 339.87 889.656 339.957C889.656 340.044 889.724 340.112 889.811 340.112H896.235C896.322 340.112 896.39 340.044 896.39 339.957C896.39 339.87 896.322 339.802 896.235 339.802Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M881.25 344.939H887.673C887.76 344.939 887.828 344.872 887.828 344.784C887.828 344.697 887.76 344.63 887.673 344.63H881.25C881.162 344.63 881.095 344.697 881.095 344.784C881.095 344.872 881.162 344.939 881.25 344.939Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M896.235 344.62H889.811C889.724 344.62 889.656 344.688 889.656 344.775C889.656 344.862 889.724 344.929 889.811 344.929H896.235C896.322 344.929 896.39 344.862 896.39 344.775C896.39 344.688 896.322 344.62 896.235 344.62Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M881.25 347.338H887.673C887.76 347.338 887.828 347.271 887.828 347.184C887.828 347.097 887.76 347.029 887.673 347.029H881.25C881.162 347.029 881.095 347.097 881.095 347.184C881.095 347.271 881.162 347.338 881.25 347.338Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M896.235 347.029H889.811C889.724 347.029 889.656 347.097 889.656 347.184C889.656 347.271 889.724 347.338 889.811 347.338H896.235C896.322 347.338 896.39 347.271 896.39 347.184C896.39 347.097 896.322 347.029 896.235 347.029Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M881.25 349.747H887.673C887.76 349.747 887.828 349.68 887.828 349.593C887.828 349.505 887.76 349.438 887.673 349.438H881.25C881.162 349.438 881.095 349.505 881.095 349.593C881.095 349.68 881.162 349.747 881.25 349.747Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M896.235 349.438H889.811C889.724 349.438 889.656 349.505 889.656 349.593C889.656 349.68 889.724 349.747 889.811 349.747H896.235C896.322 349.747 896.39 349.68 896.39 349.593C896.39 349.505 896.322 349.438 896.235 349.438Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M881.25 352.156H887.673C887.76 352.156 887.828 352.089 887.828 352.001C887.828 351.914 887.76 351.847 887.673 351.847H881.25C881.162 351.847 881.095 351.914 881.095 352.001C881.095 352.089 881.162 352.156 881.25 352.156Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M896.235 351.847H889.811C889.724 351.847 889.656 351.914 889.656 352.001C889.656 352.089 889.724 352.156 889.811 352.156H896.235C896.322 352.156 896.39 352.089 896.39 352.001C896.39 351.914 896.322 351.847 896.235 351.847Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M881.25 354.507H887.673C887.76 354.507 887.828 354.439 887.828 354.352C887.828 354.265 887.76 354.198 887.673 354.198H881.25C881.162 354.198 881.095 354.265 881.095 354.352C881.095 354.439 881.162 354.507 881.25 354.507Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M896.235 354.188H889.811C889.724 354.188 889.656 354.256 889.656 354.343C889.656 354.43 889.724 354.498 889.811 354.498H896.235C896.322 354.498 896.39 354.43 896.39 354.343C896.39 354.256 896.322 354.188 896.235 354.188Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M887.286 373.034C887.344 373.034 887.393 372.985 887.393 372.927V371.06C887.393 371.002 887.344 370.954 887.286 370.954C887.228 370.954 887.18 371.002 887.18 371.06V372.927C887.18 372.985 887.228 373.034 887.286 373.034Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.635 369.648V374.388C884.635 374.756 884.935 375.055 885.303 375.055H892.191C892.559 375.055 892.858 374.756 892.858 374.388V369.648C892.858 369.28 892.559 368.98 892.191 368.98H885.303C884.935 368.98 884.635 369.28 884.635 369.648ZM892.646 369.648V374.388C892.646 374.639 892.442 374.843 892.191 374.843H885.303C885.051 374.843 884.848 374.639 884.848 374.388V369.648C884.848 369.396 885.051 369.193 885.303 369.193H892.191C892.442 369.193 892.646 369.396 892.646 369.648Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M886.377 373.982H891.117C891.485 373.982 891.785 373.682 891.785 373.314V370.721C891.785 370.354 891.485 370.054 891.117 370.054H886.377C886.009 370.054 885.709 370.354 885.709 370.721V373.314C885.709 373.682 886.009 373.982 886.377 373.982ZM885.922 370.731C885.922 370.479 886.125 370.276 886.377 370.276H891.117C891.369 370.276 891.572 370.479 891.572 370.731V373.324C891.572 373.575 891.369 373.778 891.117 373.778H886.377C886.125 373.778 885.922 373.575 885.922 373.324V370.731Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M881.375 193.457V251.252",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M888.718 159.994C888.718 159.839 888.592 159.723 888.438 159.752C887.344 159.984 886.522 160.951 886.522 162.112C886.522 163.447 887.606 164.521 888.931 164.521C890.266 164.521 891.34 163.438 891.34 162.112C891.34 160.884 890.421 159.868 889.231 159.713C889.086 159.694 888.97 159.81 888.97 159.955V161.3C888.97 161.367 888.912 161.425 888.844 161.425C888.776 161.425 888.718 161.367 888.718 161.3V159.984V159.994Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M885.603 159.045L886.531 159.974",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M887.702 158.117L887.934 159.278",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M890.024 158.117L889.792 159.278",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M891.881 159.045L891.185 159.974",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M888.747 285.838C890.569 285.838 892.046 284.361 892.046 282.539C892.046 280.717 890.569 279.24 888.747 279.24C886.925 279.24 885.448 280.717 885.448 282.539C885.448 284.361 886.925 285.838 888.747 285.838Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M883.891 173.189C883.068 173.673 882.594 174.515 882.556 175.405L885.294 175.385C885.361 175.385 885.419 175.444 885.419 175.502C885.419 175.569 885.361 175.627 885.303 175.627L882.565 175.647C882.585 176.063 882.701 176.488 882.923 176.875C883.668 178.162 885.323 178.597 886.609 177.852C887.896 177.108 888.331 175.453 887.586 174.167C886.841 172.88 885.187 172.444 883.9 173.189H883.891Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M881.617 175.511H881.975",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M882.11 177.33L882.41 177.156",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M888.089 173.877L888.399 173.702",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M883.436 178.656L883.61 178.346",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M886.89 172.677L887.064 172.367",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M885.254 179.149V178.791",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M885.254 172.242V171.884",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M887.064 178.656L886.89 178.346",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M883.61 172.677L883.436 172.367",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M888.399 177.33L888.089 177.156",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M882.41 173.877L882.11 173.702",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M898.15 181.413C897.667 180.59 896.825 180.116 895.935 180.078L895.954 182.815C895.954 182.883 895.896 182.941 895.838 182.941C895.77 182.941 895.722 182.883 895.722 182.825L895.703 180.087C895.287 180.107 894.861 180.223 894.474 180.445C893.187 181.19 892.752 182.845 893.497 184.131C894.242 185.418 895.896 185.853 897.183 185.108C898.47 184.363 898.905 182.709 898.16 181.422L898.15 181.413Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M895.829 179.139V179.497",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M894.01 179.623L894.194 179.932",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M897.464 185.602L897.638 185.911",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M892.685 180.958L892.994 181.132",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M898.664 184.402L898.973 184.586",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M892.201 182.767H892.549",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M899.099 182.767H899.457",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M892.685 184.586L892.994 184.402",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M898.664 181.132L898.973 180.958",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M894.01 185.911L894.184 185.602",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M897.464 179.932L897.638 179.623",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M894.649 314.242C894.649 313.662 894.175 313.188 893.594 313.188C893.014 313.188 892.54 313.662 892.54 314.242C892.54 314.823 893.014 315.297 893.594 315.297C894.175 315.297 894.649 314.823 894.649 314.242Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M896.167 314.242C896.167 312.82 895.016 311.669 893.594 311.669C892.172 311.669 891.021 312.82 891.021 314.242C891.021 315.664 892.172 316.815 893.594 316.815C895.016 316.815 896.167 315.664 896.167 314.242Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M886.464 314.242C886.464 312.82 885.313 311.669 883.891 311.669C882.469 311.669 881.317 312.82 881.317 314.242C881.317 315.664 882.469 316.815 883.891 316.815C885.313 316.815 886.464 315.664 886.464 314.242Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M887.315 295.88C887.373 295.841 887.393 295.774 887.364 295.716C887.325 295.658 887.257 295.638 887.199 295.667C886.242 296.219 885.651 297.254 885.651 298.366C885.651 300.079 887.044 301.482 888.747 301.482C890.45 301.482 891.843 300.088 891.843 298.366C891.843 297.254 891.253 296.228 890.295 295.667C890.237 295.629 890.16 295.658 890.131 295.716C890.092 295.774 890.121 295.851 890.179 295.88C891.059 296.393 891.611 297.341 891.611 298.366C891.611 299.943 890.334 301.23 888.757 301.23C887.18 301.23 885.903 299.943 885.903 298.366C885.903 297.351 886.445 296.393 887.325 295.88H887.315Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M888.863 298.009V295.029C888.863 294.961 888.805 294.903 888.738 294.903C888.67 294.903 888.612 294.961 888.612 295.029V298.009C888.612 298.076 888.67 298.134 888.738 298.134C888.805 298.134 888.863 298.076 888.863 298.009Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M886.367 302.952C884.8 302.081 883.736 300.379 883.736 298.415C883.736 295.832 885.593 293.684 888.012 293.316",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M889.463 293.316C891.891 293.674 893.758 295.822 893.758 298.415C893.758 300.195 892.878 301.762 891.553 302.681",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M887.315 264.312C887.373 264.274 887.393 264.206 887.364 264.148C887.325 264.09 887.257 264.071 887.199 264.1C886.242 264.651 885.651 265.686 885.651 266.799C885.651 268.511 887.044 269.914 888.747 269.914C890.45 269.914 891.843 268.521 891.843 266.799C891.843 265.686 891.253 264.661 890.295 264.1C890.237 264.061 890.16 264.09 890.131 264.148C890.092 264.206 890.121 264.283 890.179 264.312C891.059 264.825 891.611 265.773 891.611 266.799C891.611 268.376 890.334 269.662 888.757 269.662C887.18 269.662 885.903 268.376 885.903 266.799C885.903 265.783 886.445 264.825 887.325 264.312H887.315Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M888.863 266.441V263.461C888.863 263.394 888.805 263.335 888.738 263.335C888.67 263.335 888.612 263.394 888.612 263.461V266.441C888.612 266.509 888.67 266.567 888.738 266.567C888.805 266.567 888.863 266.509 888.863 266.441Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M886.367 271.375C884.8 270.504 883.736 268.802 883.736 266.838C883.736 264.255 885.593 262.107 888.012 261.739",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M889.463 261.749C891.891 262.107 893.758 264.255 893.758 266.847C893.758 268.628 892.878 270.195 891.553 271.114",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M900.569 153.589V255.412",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M900.569 261.352V272.952",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M900.569 276.831V288.441",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M900.569 292.862V304.471",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M900.569 308.186V347.687",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M900.569 350.792V375.849",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.313 330.331C904.313 330.418 904.381 330.486 904.468 330.486H910.892C910.979 330.486 911.046 330.418 911.046 330.331C911.046 330.244 910.979 330.176 910.892 330.176H904.468C904.381 330.176 904.313 330.244 904.313 330.331Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M919.454 330.176H913.03C912.943 330.176 912.875 330.244 912.875 330.331C912.875 330.418 912.943 330.486 913.03 330.486H919.454C919.541 330.486 919.609 330.418 919.609 330.331C919.609 330.244 919.541 330.176 919.454 330.176Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.468 332.895H910.892C910.979 332.895 911.046 332.827 911.046 332.74C911.046 332.653 910.979 332.585 910.892 332.585H904.468C904.381 332.585 904.313 332.653 904.313 332.74C904.313 332.827 904.381 332.895 904.468 332.895Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M919.454 332.585H913.03C912.943 332.585 912.875 332.653 912.875 332.74C912.875 332.827 912.943 332.895 913.03 332.895H919.454C919.541 332.895 919.609 332.827 919.609 332.74C919.609 332.653 919.541 332.585 919.454 332.585Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.468 335.303H910.892C910.979 335.303 911.046 335.236 911.046 335.149C911.046 335.062 910.979 334.994 910.892 334.994H904.468C904.381 334.994 904.313 335.062 904.313 335.149C904.313 335.236 904.381 335.303 904.468 335.303Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M919.454 334.994H913.03C912.943 334.994 912.875 335.062 912.875 335.149C912.875 335.236 912.943 335.303 913.03 335.303H919.454C919.541 335.303 919.609 335.236 919.609 335.149C919.609 335.062 919.541 334.994 919.454 334.994Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.468 337.712H910.892C910.979 337.712 911.046 337.645 911.046 337.558C911.046 337.471 910.979 337.403 910.892 337.403H904.468C904.381 337.403 904.313 337.471 904.313 337.558C904.313 337.645 904.381 337.712 904.468 337.712Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M919.454 337.403H913.03C912.943 337.403 912.875 337.471 912.875 337.558C912.875 337.645 912.943 337.712 913.03 337.712H919.454C919.541 337.712 919.609 337.645 919.609 337.558C919.609 337.471 919.541 337.403 919.454 337.403Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.468 340.121H910.892C910.979 340.121 911.046 340.054 911.046 339.967C911.046 339.879 910.979 339.812 910.892 339.812H904.468C904.381 339.812 904.313 339.879 904.313 339.967C904.313 340.054 904.381 340.121 904.468 340.121Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M906.248 342.491H917.258C917.403 342.491 917.529 342.424 917.529 342.337C917.529 342.25 917.413 342.182 917.258 342.182H906.248C906.103 342.182 905.978 342.25 905.978 342.337C905.978 342.424 906.094 342.491 906.248 342.491Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M919.454 339.802H913.03C912.943 339.802 912.875 339.87 912.875 339.957C912.875 340.044 912.943 340.112 913.03 340.112H919.454C919.541 340.112 919.609 340.044 919.609 339.957C919.609 339.87 919.541 339.802 919.454 339.802Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.468 344.939H910.892C910.979 344.939 911.046 344.871 911.046 344.784C911.046 344.697 910.979 344.629 910.892 344.629H904.468C904.381 344.629 904.313 344.697 904.313 344.784C904.313 344.871 904.381 344.939 904.468 344.939Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M919.454 344.62H913.03C912.943 344.62 912.875 344.688 912.875 344.775C912.875 344.862 912.943 344.929 913.03 344.929H919.454C919.541 344.929 919.609 344.862 919.609 344.775C919.609 344.688 919.541 344.62 919.454 344.62Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.468 347.338H910.892C910.979 347.338 911.046 347.271 911.046 347.184C911.046 347.097 910.979 347.029 910.892 347.029H904.468C904.381 347.029 904.313 347.097 904.313 347.184C904.313 347.271 904.381 347.338 904.468 347.338Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M919.454 347.029H913.03C912.943 347.029 912.875 347.097 912.875 347.184C912.875 347.271 912.943 347.338 913.03 347.338H919.454C919.541 347.338 919.609 347.271 919.609 347.184C919.609 347.097 919.541 347.029 919.454 347.029Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.468 349.747H910.892C910.979 349.747 911.046 349.68 911.046 349.593C911.046 349.505 910.979 349.438 910.892 349.438H904.468C904.381 349.438 904.313 349.505 904.313 349.593C904.313 349.68 904.381 349.747 904.468 349.747Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M919.454 349.438H913.03C912.943 349.438 912.875 349.505 912.875 349.593C912.875 349.68 912.943 349.747 913.03 349.747H919.454C919.541 349.747 919.609 349.68 919.609 349.593C919.609 349.505 919.541 349.438 919.454 349.438Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.468 352.156H910.892C910.979 352.156 911.046 352.089 911.046 352.001C911.046 351.914 910.979 351.847 910.892 351.847H904.468C904.381 351.847 904.313 351.914 904.313 352.001C904.313 352.089 904.381 352.156 904.468 352.156Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M919.454 351.847H913.03C912.943 351.847 912.875 351.914 912.875 352.001C912.875 352.089 912.943 352.156 913.03 352.156H919.454C919.541 352.156 919.609 352.089 919.609 352.001C919.609 351.914 919.541 351.847 919.454 351.847Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.468 354.507H910.892C910.979 354.507 911.046 354.439 911.046 354.352C911.046 354.265 910.979 354.198 910.892 354.198H904.468C904.381 354.198 904.313 354.265 904.313 354.352C904.313 354.439 904.381 354.507 904.468 354.507Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M919.454 354.188H913.03C912.943 354.188 912.875 354.256 912.875 354.343C912.875 354.43 912.943 354.498 913.03 354.498H919.454C919.541 354.498 919.609 354.43 919.609 354.343C919.609 354.256 919.541 354.188 919.454 354.188Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M910.504 373.034C910.562 373.034 910.611 372.985 910.611 372.927V371.06C910.611 371.002 910.562 370.954 910.504 370.954C910.446 370.954 910.398 371.002 910.398 371.06V372.927C910.398 372.985 910.446 373.034 910.504 373.034Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M907.854 369.648V374.388C907.854 374.756 908.153 375.055 908.521 375.055H915.409C915.777 375.055 916.077 374.756 916.077 374.388V369.648C916.077 369.28 915.777 368.98 915.409 368.98H908.521C908.153 368.98 907.854 369.28 907.854 369.648ZM915.864 369.648V374.388C915.864 374.639 915.661 374.843 915.409 374.843H908.521C908.27 374.843 908.066 374.639 908.066 374.388V369.648C908.066 369.396 908.27 369.193 908.521 369.193H915.409C915.661 369.193 915.864 369.396 915.864 369.648Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M909.595 373.982H914.336C914.703 373.982 915.003 373.682 915.003 373.314V370.721C915.003 370.354 914.703 370.054 914.336 370.054H909.595C909.228 370.054 908.928 370.354 908.928 370.721V373.314C908.928 373.682 909.228 373.982 909.595 373.982ZM909.141 370.731C909.141 370.479 909.344 370.276 909.595 370.276H914.336C914.587 370.276 914.79 370.479 914.79 370.731V373.324C914.79 373.575 914.587 373.778 914.336 373.778H909.595C909.344 373.778 909.141 373.575 909.141 373.324V370.731Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M904.778 193.457V251.252",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M911.937 159.994C911.937 159.839 911.811 159.723 911.656 159.752C910.563 159.984 909.741 160.951 909.741 162.112C909.741 163.447 910.824 164.521 912.15 164.521C913.485 164.521 914.559 163.438 914.559 162.112C914.559 160.884 913.64 159.868 912.45 159.713C912.304 159.694 912.188 159.81 912.188 159.955V161.3C912.188 161.367 912.13 161.425 912.063 161.425C911.995 161.425 911.937 161.367 911.937 161.3V159.984V159.994Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M908.821 159.045L909.75 159.974",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M910.92 158.117L911.153 159.278",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M913.242 158.117L913.01 159.278",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M915.1 159.045L914.403 159.974",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M911.965 285.838C913.787 285.838 915.264 284.361 915.264 282.539C915.264 280.717 913.787 279.24 911.965 279.24C910.144 279.24 908.667 280.717 908.667 282.539C908.667 284.361 910.144 285.838 911.965 285.838Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M910.437 173.915C909.789 173.219 908.86 172.948 907.98 173.103L908.599 175.773C908.618 175.84 908.57 175.898 908.512 175.918C908.444 175.937 908.386 175.889 908.367 175.831L907.748 173.161C907.341 173.267 906.954 173.47 906.625 173.78C905.532 174.796 905.474 176.498 906.48 177.591C907.496 178.685 909.199 178.743 910.292 177.737C911.385 176.73 911.443 175.018 910.437 173.935V173.915Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M907.661 172.212L907.748 172.561",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M905.996 173.083L906.238 173.344",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M910.679 178.162L910.921 178.423",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M905 174.67L905.339 174.776",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M911.588 176.73L911.927 176.837",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M904.923 176.547L905.261 176.469",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M911.656 175.037L912.005 174.96",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M905.793 178.21L906.055 177.969",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M910.872 173.528L911.133 173.296",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M907.38 179.217L907.477 178.878",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M909.44 172.628L909.547 172.29",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M921.553 181.413C921.069 180.59 920.227 180.116 919.337 180.078L919.357 182.815C919.357 182.883 919.299 182.941 919.241 182.941C919.173 182.941 919.124 182.883 919.124 182.825L919.105 180.087C918.689 180.107 918.263 180.223 917.876 180.445C916.59 181.19 916.154 182.845 916.899 184.131C917.644 185.418 919.299 185.853 920.585 185.108C921.872 184.363 922.307 182.709 921.562 181.422L921.553 181.413Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M919.23 179.139V179.497",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M917.412 179.623L917.586 179.932",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M920.866 185.602L921.04 185.911",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M916.086 180.958L916.386 181.132",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M922.065 184.402L922.365 184.586",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M915.593 182.767H915.951",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M922.501 182.767H922.859",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M916.086 184.586L916.386 184.402",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M922.065 181.132L922.365 180.958",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M917.412 185.911L917.586 185.602",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M920.866 179.932L921.04 179.623",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M917.867 314.242C917.867 313.662 917.393 313.188 916.813 313.188C916.232 313.188 915.758 313.662 915.758 314.242C915.758 314.823 916.232 315.297 916.813 315.297C917.393 315.297 917.867 314.823 917.867 314.242Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M919.386 314.242C919.386 312.82 918.235 311.669 916.813 311.669C915.391 311.669 914.239 312.82 914.239 314.242C914.239 315.664 915.391 316.815 916.813 316.815C918.235 316.815 919.386 315.664 919.386 314.242Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M909.682 314.242C909.682 312.82 908.531 311.669 907.109 311.669C905.687 311.669 904.536 312.82 904.536 314.242C904.536 315.664 905.687 316.815 907.109 316.815C908.531 316.815 909.682 315.664 909.682 314.242Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M910.534 295.88C910.592 295.841 910.611 295.774 910.582 295.716C910.544 295.658 910.476 295.638 910.418 295.667C909.46 296.219 908.87 297.254 908.87 298.366C908.87 300.079 910.263 301.482 911.966 301.482C913.669 301.482 915.062 300.088 915.062 298.366C915.062 297.254 914.472 296.228 913.514 295.667C913.456 295.629 913.378 295.658 913.349 295.716C913.311 295.774 913.34 295.851 913.398 295.88C914.278 296.393 914.83 297.341 914.83 298.366C914.83 299.943 913.553 301.23 911.976 301.23C910.399 301.23 909.122 299.943 909.122 298.366C909.122 297.351 909.663 296.393 910.544 295.88H910.534Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M912.082 298.009V295.029C912.082 294.961 912.024 294.903 911.956 294.903C911.889 294.903 911.831 294.961 911.831 295.029V298.009C911.831 298.076 911.889 298.134 911.956 298.134C912.024 298.134 912.082 298.076 912.082 298.009Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M909.586 302.952C908.018 302.081 906.954 300.379 906.954 298.415C906.954 295.832 908.812 293.684 911.23 293.316",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M912.682 293.316C915.11 293.674 916.977 295.822 916.977 298.415C916.977 300.195 916.097 301.762 914.771 302.681",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M910.534 264.768C910.592 264.729 910.611 264.661 910.582 264.603C910.544 264.545 910.476 264.526 910.418 264.555C909.46 265.106 908.87 266.141 908.87 267.254C908.87 268.966 910.263 270.369 911.966 270.369C913.669 270.369 915.062 268.976 915.062 267.254C915.062 266.141 914.472 265.116 913.514 264.555C913.456 264.516 913.378 264.545 913.349 264.603C913.311 264.661 913.34 264.739 913.398 264.768C914.278 265.28 914.83 266.228 914.83 267.254C914.83 268.831 913.553 270.118 911.976 270.118C910.399 270.118 909.122 268.831 909.122 267.254C909.122 266.238 909.663 265.28 910.544 264.768H910.534Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M912.082 266.886V263.907C912.082 263.839 912.024 263.781 911.956 263.781C911.889 263.781 911.831 263.839 911.831 263.907V266.886C911.831 266.954 911.889 267.012 911.956 267.012C912.024 267.012 912.082 266.954 912.082 266.886Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M909.586 271.83C908.018 270.959 906.954 269.256 906.954 267.293C906.954 264.709 908.812 262.562 911.23 262.194",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M912.682 262.194C915.11 262.552 916.977 264.7 916.977 267.293C916.977 269.073 916.097 270.64 914.771 271.559",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M923.971 153.589V255.412",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M994.236 153.589V251.252",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M947.954 153.589V395.623",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M967.97 153.589V395.623",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M923.971 261.352V272.952",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M923.971 276.831V288.441",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M923.971 292.862V304.471",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M923.971 308.186V347.687",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M923.971 350.792V375.849",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.532 330.331C927.532 330.418 927.599 330.486 927.687 330.486H934.11C934.197 330.486 934.265 330.418 934.265 330.331C934.265 330.244 934.197 330.176 934.11 330.176H927.687C927.599 330.176 927.532 330.244 927.532 330.331Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.672 330.176H936.249C936.161 330.176 936.094 330.244 936.094 330.331C936.094 330.418 936.161 330.486 936.249 330.486H942.672C942.759 330.486 942.827 330.418 942.827 330.331C942.827 330.244 942.759 330.176 942.672 330.176Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.687 332.895H934.11C934.197 332.895 934.265 332.827 934.265 332.74C934.265 332.653 934.197 332.585 934.11 332.585H927.687C927.599 332.585 927.532 332.653 927.532 332.74C927.532 332.827 927.599 332.895 927.687 332.895Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.672 332.585H936.249C936.161 332.585 936.094 332.653 936.094 332.74C936.094 332.827 936.161 332.895 936.249 332.895H942.672C942.759 332.895 942.827 332.827 942.827 332.74C942.827 332.653 942.759 332.585 942.672 332.585Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.687 335.303H934.11C934.197 335.303 934.265 335.236 934.265 335.149C934.265 335.062 934.197 334.994 934.11 334.994H927.687C927.599 334.994 927.532 335.062 927.532 335.149C927.532 335.236 927.599 335.303 927.687 335.303Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.672 334.994H936.249C936.161 334.994 936.094 335.062 936.094 335.149C936.094 335.236 936.161 335.303 936.249 335.303H942.672C942.759 335.303 942.827 335.236 942.827 335.149C942.827 335.062 942.759 334.994 942.672 334.994Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.687 337.712H934.11C934.197 337.712 934.265 337.645 934.265 337.558C934.265 337.471 934.197 337.403 934.11 337.403H927.687C927.599 337.403 927.532 337.471 927.532 337.558C927.532 337.645 927.599 337.712 927.687 337.712Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.672 337.403H936.249C936.161 337.403 936.094 337.471 936.094 337.558C936.094 337.645 936.161 337.712 936.249 337.712H942.672C942.759 337.712 942.827 337.645 942.827 337.558C942.827 337.471 942.759 337.403 942.672 337.403Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.687 340.121H934.11C934.197 340.121 934.265 340.054 934.265 339.967C934.265 339.879 934.197 339.812 934.11 339.812H927.687C927.599 339.812 927.532 339.879 927.532 339.967C927.532 340.054 927.599 340.121 927.687 340.121Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M929.467 342.491H940.476C940.621 342.491 940.747 342.424 940.747 342.337C940.747 342.25 940.631 342.182 940.476 342.182H929.467C929.322 342.182 929.196 342.25 929.196 342.337C929.196 342.424 929.312 342.491 929.467 342.491Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.672 339.802H936.249C936.161 339.802 936.094 339.87 936.094 339.957C936.094 340.044 936.161 340.112 936.249 340.112H942.672C942.759 340.112 942.827 340.044 942.827 339.957C942.827 339.87 942.759 339.802 942.672 339.802Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.687 344.939H934.11C934.197 344.939 934.265 344.871 934.265 344.784C934.265 344.697 934.197 344.629 934.11 344.629H927.687C927.599 344.629 927.532 344.697 927.532 344.784C927.532 344.871 927.599 344.939 927.687 344.939Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.672 344.62H936.249C936.161 344.62 936.094 344.688 936.094 344.775C936.094 344.862 936.161 344.929 936.249 344.929H942.672C942.759 344.929 942.827 344.862 942.827 344.775C942.827 344.688 942.759 344.62 942.672 344.62Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.687 347.338H934.11C934.197 347.338 934.265 347.271 934.265 347.184C934.265 347.097 934.197 347.029 934.11 347.029H927.687C927.599 347.029 927.532 347.097 927.532 347.184C927.532 347.271 927.599 347.338 927.687 347.338Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.672 347.029H936.249C936.161 347.029 936.094 347.097 936.094 347.184C936.094 347.271 936.161 347.338 936.249 347.338H942.672C942.759 347.338 942.827 347.271 942.827 347.184C942.827 347.097 942.759 347.029 942.672 347.029Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.687 349.747H934.11C934.197 349.747 934.265 349.68 934.265 349.593C934.265 349.505 934.197 349.438 934.11 349.438H927.687C927.599 349.438 927.532 349.505 927.532 349.593C927.532 349.68 927.599 349.747 927.687 349.747Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.672 349.438H936.249C936.161 349.438 936.094 349.505 936.094 349.593C936.094 349.68 936.161 349.747 936.249 349.747H942.672C942.759 349.747 942.827 349.68 942.827 349.593C942.827 349.505 942.759 349.438 942.672 349.438Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.687 352.156H934.11C934.197 352.156 934.265 352.089 934.265 352.001C934.265 351.914 934.197 351.847 934.11 351.847H927.687C927.599 351.847 927.532 351.914 927.532 352.001C927.532 352.089 927.599 352.156 927.687 352.156Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.672 351.847H936.249C936.161 351.847 936.094 351.914 936.094 352.001C936.094 352.089 936.161 352.156 936.249 352.156H942.672C942.759 352.156 942.827 352.089 942.827 352.001C942.827 351.914 942.759 351.847 942.672 351.847Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.687 354.507H934.11C934.197 354.507 934.265 354.439 934.265 354.352C934.265 354.265 934.197 354.198 934.11 354.198H927.687C927.599 354.198 927.532 354.265 927.532 354.352C927.532 354.439 927.599 354.507 927.687 354.507Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.672 354.188H936.249C936.161 354.188 936.094 354.256 936.094 354.343C936.094 354.43 936.161 354.498 936.249 354.498H942.672C942.759 354.498 942.827 354.43 942.827 354.343C942.827 354.256 942.759 354.188 942.672 354.188Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M933.713 373.034C933.771 373.034 933.82 372.985 933.82 372.927V371.06C933.82 371.002 933.771 370.954 933.713 370.954C933.655 370.954 933.607 371.002 933.607 371.06V372.927C933.607 372.985 933.655 373.034 933.713 373.034Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M931.072 369.648V374.388C931.072 374.756 931.372 375.055 931.74 375.055H938.628C938.996 375.055 939.295 374.756 939.295 374.388V369.648C939.295 369.28 938.996 368.98 938.628 368.98H931.74C931.372 368.98 931.072 369.28 931.072 369.648ZM939.083 369.648V374.388C939.083 374.639 938.879 374.843 938.628 374.843H931.74C931.488 374.843 931.285 374.639 931.285 374.388V369.648C931.285 369.396 931.488 369.193 931.74 369.193H938.628C938.879 369.193 939.083 369.396 939.083 369.648Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M932.814 373.982H937.554C937.922 373.982 938.222 373.682 938.222 373.314V370.721C938.222 370.354 937.922 370.054 937.554 370.054H932.814C932.446 370.054 932.146 370.354 932.146 370.721V373.314C932.146 373.682 932.446 373.982 932.814 373.982ZM932.359 370.731C932.359 370.479 932.562 370.276 932.814 370.276H937.554C937.806 370.276 938.009 370.479 938.009 370.731V373.324C938.009 373.575 937.806 373.778 937.554 373.778H932.814C932.562 373.778 932.359 373.575 932.359 373.324V370.731Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M928.18 193.457V251.252",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M952.646 194.657V252.452",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M961.847 194.657V252.452",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.962 159.994C934.962 159.839 934.836 159.723 934.681 159.752C933.588 159.984 932.766 160.951 932.766 162.112C932.766 163.447 933.849 164.521 935.175 164.521C936.51 164.521 937.583 163.438 937.583 162.112C937.583 160.884 936.664 159.868 935.474 159.713C935.329 159.694 935.213 159.81 935.213 159.955V161.3C935.213 161.367 935.155 161.425 935.087 161.425C935.02 161.425 934.962 161.367 934.962 161.3V159.984V159.994Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M932.04 159.045L932.969 159.974",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M934.14 158.117L934.372 159.278",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M936.461 158.117L936.229 159.278",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M938.319 159.045L937.623 159.974",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M935.184 285.838C937.006 285.838 938.483 284.361 938.483 282.539C938.483 280.717 937.006 279.24 935.184 279.24C933.362 279.24 931.885 280.717 931.885 282.539C931.885 284.361 933.362 285.838 935.184 285.838Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M957.658 285.838C959.48 285.838 960.957 284.361 960.957 282.539C960.957 280.717 959.48 279.24 957.658 279.24C955.836 279.24 954.359 280.717 954.359 282.539C954.359 284.361 955.836 285.838 957.658 285.838Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.14 248.534C1006.96 248.534 1008.44 247.057 1008.44 245.235C1008.44 243.413 1006.96 241.936 1005.14 241.936C1003.32 241.936 1001.84 243.413 1001.84 245.235C1001.84 247.057 1003.32 248.534 1005.14 248.534Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M930.695 173.189C929.873 173.673 929.399 174.515 929.36 175.405L932.098 175.385C932.166 175.385 932.224 175.444 932.224 175.502C932.224 175.569 932.166 175.627 932.108 175.627L929.37 175.647C929.389 176.063 929.505 176.488 929.728 176.875C930.473 178.162 932.127 178.597 933.414 177.852C934.701 177.108 935.136 175.453 934.391 174.167C933.646 172.88 931.992 172.444 930.705 173.189H930.695Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M928.422 175.511H928.77",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M928.906 177.33L929.215 177.156",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M934.884 173.877L935.194 173.702",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M930.231 178.656L930.415 178.346",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M933.685 172.677L933.868 172.367",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M932.049 179.149V178.791",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M932.049 172.242V171.884",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M933.868 178.656L933.685 178.346",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M930.415 172.677L930.231 172.367",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M935.194 177.33L934.884 177.156",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M929.215 173.877L928.906 173.702",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M944.956 181.413C944.472 180.59 943.63 180.116 942.74 180.078L942.759 182.815C942.759 182.883 942.701 182.941 942.643 182.941C942.576 182.941 942.527 182.883 942.527 182.825L942.508 180.087C942.092 180.107 941.666 180.223 941.279 180.445C939.993 181.19 939.557 182.845 940.302 184.131C941.047 185.418 942.701 185.853 943.988 185.108C945.275 184.363 945.71 182.709 944.965 181.422L944.956 181.413Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M942.624 179.139V179.497",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M940.814 179.623L940.989 179.932",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M944.259 185.602L944.443 185.911",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M939.48 180.958L939.79 181.132",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M945.458 184.402L945.768 184.586",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M938.996 182.767H939.354",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M945.904 182.767H946.252",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M939.48 184.586L939.79 184.402",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M945.458 181.132L945.768 180.958",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M940.814 185.911L940.979 185.602",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M944.259 179.932L944.443 179.623",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M937.506 193.564C937.022 192.741 936.18 192.267 935.29 192.229L935.31 194.967C935.31 195.034 935.252 195.092 935.194 195.092C935.126 195.092 935.078 195.034 935.078 194.976L935.058 192.238C934.642 192.258 934.217 192.374 933.83 192.596C932.543 193.341 932.108 194.996 932.852 196.282C933.597 197.569 935.252 198.004 936.538 197.259C937.825 196.515 938.26 194.86 937.516 193.573L937.506 193.564Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M935.184 191.3V191.648",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M933.365 191.784L933.539 192.093",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M936.819 197.763L936.993 198.072",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M932.04 193.109L932.339 193.293",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M938.019 196.563L938.328 196.747",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M931.547 194.928H931.905",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M938.454 194.928H938.812",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M932.04 196.747L932.339 196.563",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M938.019 193.293L938.328 193.109",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M933.365 198.072L933.539 197.763",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M936.819 192.093L936.993 191.784",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M937.506 211.616C937.022 210.794 936.18 210.32 935.29 210.281L935.31 213.019C935.31 213.087 935.252 213.145 935.194 213.145C935.126 213.145 935.078 213.087 935.078 213.029L935.058 210.291C934.642 210.31 934.217 210.426 933.83 210.649C932.543 211.394 932.108 213.048 932.852 214.335C933.597 215.622 935.252 216.057 936.538 215.312C937.825 214.567 938.26 212.913 937.516 211.626L937.506 211.616Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M935.184 209.343V209.691",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M933.365 209.826L933.539 210.136",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M936.819 215.805L936.993 216.115",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M932.04 211.152L932.339 211.336",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M938.019 214.605L938.328 214.789",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M931.547 212.971H931.905",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M938.454 212.971H938.812",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M932.04 214.789L932.339 214.605",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M938.019 211.336L938.328 211.152",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M933.365 216.115L933.539 215.805",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M936.819 210.136L936.993 209.826",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M937.506 229.659C937.022 228.837 936.18 228.363 935.29 228.324L935.31 231.062C935.31 231.13 935.252 231.188 935.194 231.188C935.126 231.188 935.078 231.13 935.078 231.072L935.058 228.334C934.642 228.353 934.217 228.469 933.83 228.692C932.543 229.437 932.108 231.091 932.852 232.378C933.597 233.664 935.252 234.1 936.538 233.355C937.825 232.61 938.26 230.955 937.516 229.669L937.506 229.659Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M935.184 227.385V227.743",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M933.365 227.869L933.539 228.179",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M936.819 233.848L936.993 234.158",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M932.04 229.204L932.339 229.378",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M938.019 232.648L938.328 232.832",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M931.547 231.013H931.905",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M938.454 231.013H938.812",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M932.04 232.832L932.339 232.648",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M938.019 229.378L938.328 229.204",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M933.365 234.158L933.539 233.848",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M936.819 228.179L936.993 227.869",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M937.506 247.702C937.022 246.879 936.18 246.405 935.29 246.367L935.31 249.105C935.31 249.172 935.252 249.23 935.194 249.23C935.126 249.23 935.078 249.172 935.078 249.114L935.058 246.376C934.642 246.396 934.217 246.512 933.83 246.734C932.543 247.479 932.108 249.134 932.852 250.42C933.597 251.707 935.252 252.142 936.538 251.397C937.825 250.652 938.26 248.998 937.516 247.711L937.506 247.702Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M935.184 245.428V245.786",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M933.365 245.912L933.539 246.221",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M936.819 251.891L936.993 252.2",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M932.04 247.247L932.339 247.421",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M938.019 250.701L938.328 250.875",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M931.547 249.056H931.905",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M938.454 249.056H938.812",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M932.04 250.875L932.339 250.701",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M938.019 247.421L938.328 247.247",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M933.365 252.2L933.539 251.891",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M936.819 246.221L936.993 245.912",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.288 193.564C913.804 192.741 912.962 192.267 912.072 192.229L912.092 194.967C912.092 195.034 912.033 195.092 911.975 195.092C911.908 195.092 911.859 195.034 911.859 194.976L911.84 192.238C911.424 192.258 910.998 192.374 910.611 192.596C909.325 193.341 908.889 194.996 909.634 196.282C910.379 197.569 912.033 198.004 913.32 197.259C914.607 196.515 915.042 194.86 914.297 193.573L914.288 193.564Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M911.965 191.3V191.648",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M910.147 191.784L910.321 192.093",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M913.601 197.763L913.775 198.072",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M908.821 193.109L909.121 193.293",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M914.8 196.563L915.109 196.747",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M908.328 194.928H908.686",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M915.236 194.928H915.594",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M908.821 196.747L909.121 196.563",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M914.8 193.293L915.109 193.109",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M910.147 198.072L910.321 197.763",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M913.601 192.093L913.775 191.784",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.288 211.616C913.804 210.794 912.962 210.32 912.072 210.281L912.092 213.019C912.092 213.087 912.033 213.145 911.975 213.145C911.908 213.145 911.859 213.087 911.859 213.029L911.84 210.291C911.424 210.31 910.998 210.426 910.611 210.649C909.325 211.394 908.889 213.048 909.634 214.335C910.379 215.622 912.033 216.057 913.32 215.312C914.607 214.567 915.042 212.913 914.297 211.626L914.288 211.616Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M911.965 209.343V209.691",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M910.147 209.826L910.321 210.136",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M913.601 215.805L913.775 216.115",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M908.821 211.152L909.121 211.336",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M914.8 214.605L915.109 214.789",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M908.328 212.971H908.686",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M915.236 212.971H915.594",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M908.821 214.789L909.121 214.605",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M914.8 211.336L915.109 211.152",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M910.147 216.115L910.321 215.805",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M913.601 210.136L913.775 209.826",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.288 229.659C913.804 228.837 912.962 228.363 912.072 228.324L912.092 231.062C912.092 231.13 912.033 231.188 911.975 231.188C911.908 231.188 911.859 231.13 911.859 231.072L911.84 228.334C911.424 228.353 910.998 228.469 910.611 228.692C909.325 229.437 908.889 231.091 909.634 232.378C910.379 233.664 912.033 234.1 913.32 233.355C914.607 232.61 915.042 230.955 914.297 229.669L914.288 229.659Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M911.965 227.385V227.743",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M910.147 227.869L910.321 228.179",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M913.601 233.848L913.775 234.158",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M908.821 229.204L909.121 229.378",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M914.8 232.648L915.109 232.832",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M908.328 231.013H908.686",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M915.236 231.013H915.594",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M908.821 232.832L909.121 232.648",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M914.8 229.378L915.109 229.204",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M910.147 234.158L910.321 233.848",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M913.601 228.179L913.775 227.869",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.288 247.702C913.804 246.879 912.962 246.405 912.072 246.367L912.092 249.105C912.092 249.172 912.033 249.23 911.975 249.23C911.908 249.23 911.859 249.172 911.859 249.114L911.84 246.376C911.424 246.396 910.998 246.512 910.611 246.734C909.325 247.479 908.889 249.134 909.634 250.42C910.379 251.707 912.033 252.142 913.32 251.397C914.607 250.652 915.042 248.998 914.297 247.711L914.288 247.702Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M911.965 245.428V245.786",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M910.147 245.912L910.321 246.221",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M913.601 251.891L913.775 252.2",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M908.821 247.247L909.121 247.421",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M914.8 250.701L915.109 250.875",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M908.328 249.056H908.686",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M915.236 249.056H915.594",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M908.821 250.875L909.121 250.701",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M914.8 247.421L915.109 247.247",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M910.147 252.2L910.321 251.891",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M913.601 246.221L913.775 245.912",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M891.068 193.564C890.585 192.741 889.743 192.267 888.853 192.229L888.872 194.967C888.872 195.034 888.814 195.092 888.756 195.092C888.688 195.092 888.64 195.034 888.64 194.976L888.621 192.238C888.205 192.258 887.779 192.374 887.392 192.596C886.105 193.341 885.67 194.996 886.415 196.282C887.16 197.569 888.814 198.004 890.101 197.259C891.388 196.515 891.823 194.86 891.078 193.573L891.068 193.564Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M888.747 191.3V191.648",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M886.928 191.784L887.102 192.093",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M890.382 197.763L890.556 198.072",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M885.603 193.109L885.912 193.293",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M891.582 196.563L891.891 196.747",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M885.119 194.928H885.467",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M892.017 194.928H892.375",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M885.603 196.747L885.912 196.563",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M891.582 193.293L891.891 193.109",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M886.928 198.072L887.102 197.763",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M890.382 192.093L890.556 191.784",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M891.068 211.616C890.585 210.794 889.743 210.32 888.853 210.281L888.872 213.019C888.872 213.087 888.814 213.145 888.756 213.145C888.688 213.145 888.64 213.087 888.64 213.029L888.621 210.291C888.205 210.31 887.779 210.426 887.392 210.649C886.105 211.394 885.67 213.048 886.415 214.335C887.16 215.622 888.814 216.057 890.101 215.312C891.388 214.567 891.823 212.913 891.078 211.626L891.068 211.616Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M888.747 209.343V209.691",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M886.928 209.826L887.102 210.136",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M890.382 215.805L890.556 216.115",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M885.603 211.152L885.912 211.336",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M891.582 214.605L891.891 214.789",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M885.119 212.971H885.467",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M892.017 212.971H892.375",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M885.603 214.789L885.912 214.605",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M891.582 211.336L891.891 211.152",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M886.928 216.115L887.102 215.805",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M890.382 210.136L890.556 209.826",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M891.068 229.659C890.585 228.837 889.743 228.363 888.853 228.324L888.872 231.062C888.872 231.13 888.814 231.188 888.756 231.188C888.688 231.188 888.64 231.13 888.64 231.072L888.621 228.334C888.205 228.353 887.779 228.469 887.392 228.692C886.105 229.437 885.67 231.091 886.415 232.378C887.16 233.664 888.814 234.1 890.101 233.355C891.388 232.61 891.823 230.955 891.078 229.669L891.068 229.659Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M888.747 227.385V227.743",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M886.928 227.869L887.102 228.179",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M890.382 233.848L890.556 234.158",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M885.603 229.204L885.912 229.378",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M891.582 232.648L891.891 232.832",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M885.119 231.013H885.467",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M892.017 231.013H892.375",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M885.603 232.832L885.912 232.648",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M891.582 229.378L891.891 229.204",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M886.928 234.158L887.102 233.848",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M890.382 228.179L890.556 227.869",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M891.068 247.702C890.585 246.879 889.743 246.405 888.853 246.367L888.872 249.105C888.872 249.172 888.814 249.23 888.756 249.23C888.688 249.23 888.64 249.172 888.64 249.114L888.621 246.376C888.205 246.396 887.779 246.512 887.392 246.734C886.105 247.479 885.67 249.134 886.415 250.42C887.16 251.707 888.814 252.142 890.101 251.397C891.388 250.652 891.823 248.998 891.078 247.711L891.068 247.702Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M888.747 245.428V245.786",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M886.928 245.912L887.102 246.221",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M890.382 251.891L890.556 252.2",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M885.603 247.247L885.912 247.421",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M891.582 250.701L891.891 250.875",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M885.119 249.056H885.467",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M892.017 249.056H892.375",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M885.603 250.875L885.912 250.701",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M891.582 247.421L891.891 247.247",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M886.928 252.2L887.102 251.891",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M890.382 246.221L890.556 245.912",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M867.85 193.564C867.366 192.741 866.525 192.267 865.635 192.229L865.654 194.967C865.654 195.034 865.596 195.092 865.538 195.092C865.47 195.092 865.422 195.034 865.422 194.976L865.402 192.238C864.986 192.258 864.561 192.374 864.174 192.596C862.887 193.341 862.452 194.996 863.197 196.282C863.942 197.569 865.596 198.004 866.883 197.259C868.169 196.515 868.605 194.86 867.86 193.573L867.85 193.564Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M865.528 191.3V191.648",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M863.709 191.784L863.893 192.093",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M867.163 197.763L867.337 198.072",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M862.384 193.109L862.694 193.293",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M868.363 196.563L868.673 196.747",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M861.9 194.928H862.249",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M868.798 194.928H869.156",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M862.384 196.747L862.694 196.563",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M868.363 193.293L868.673 193.109",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M863.709 198.072L863.884 197.763",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M867.163 192.093L867.337 191.784",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M867.85 211.616C867.366 210.794 866.525 210.32 865.635 210.281L865.654 213.019C865.654 213.087 865.596 213.145 865.538 213.145C865.47 213.145 865.422 213.087 865.422 213.029L865.402 210.291C864.986 210.31 864.561 210.426 864.174 210.649C862.887 211.394 862.452 213.048 863.197 214.335C863.942 215.622 865.596 216.057 866.883 215.312C868.169 214.567 868.605 212.913 867.86 211.626L867.85 211.616Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M865.528 209.343V209.691",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M863.709 209.826L863.893 210.136",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M867.163 215.805L867.337 216.115",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M862.384 211.152L862.694 211.336",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M868.363 214.605L868.673 214.789",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M861.9 212.971H862.249",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M868.798 212.971H869.156",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M862.384 214.789L862.694 214.605",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M868.363 211.336L868.673 211.152",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M863.709 216.115L863.884 215.805",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M867.163 210.136L867.337 209.826",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M867.85 229.659C867.366 228.837 866.525 228.363 865.635 228.324L865.654 231.062C865.654 231.13 865.596 231.188 865.538 231.188C865.47 231.188 865.422 231.13 865.422 231.072L865.402 228.334C864.986 228.353 864.561 228.469 864.174 228.692C862.887 229.437 862.452 231.091 863.197 232.378C863.942 233.664 865.596 234.1 866.883 233.355C868.169 232.61 868.605 230.955 867.86 229.669L867.85 229.659Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M865.528 227.385V227.743",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M863.709 227.869L863.893 228.179",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M867.163 233.848L867.337 234.158",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M862.384 229.204L862.694 229.378",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M868.363 232.648L868.673 232.832",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M861.9 231.013H862.249",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M868.798 231.013H869.156",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M862.384 232.832L862.694 232.648",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M868.363 229.378L868.673 229.204",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M863.709 234.158L863.884 233.848",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M867.163 228.179L867.337 227.869",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M867.85 247.702C867.366 246.879 866.525 246.405 865.635 246.367L865.654 249.105C865.654 249.172 865.596 249.23 865.538 249.23C865.47 249.23 865.422 249.172 865.422 249.114L865.402 246.376C864.986 246.396 864.561 246.512 864.174 246.734C862.887 247.479 862.452 249.134 863.197 250.42C863.942 251.707 865.596 252.142 866.883 251.397C868.169 250.652 868.605 248.998 867.86 247.711L867.85 247.702Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M865.528 245.428V245.786",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M863.709 245.912L863.893 246.221",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M867.163 251.891L867.337 252.2",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M862.384 247.247L862.694 247.421",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M868.363 250.701L868.673 250.875",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M861.9 249.056H862.249",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M868.798 249.056H869.156",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M862.384 250.875L862.694 250.701",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M868.363 247.421L868.673 247.247",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M863.709 252.2L863.884 251.891",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M867.163 246.221L867.337 245.912",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.631 193.564C844.148 192.741 843.306 192.267 842.416 192.229L842.435 194.967C842.435 195.034 842.377 195.092 842.319 195.092C842.251 195.092 842.203 195.034 842.203 194.976L842.184 192.238C841.768 192.258 841.342 192.374 840.955 192.596C839.668 193.341 839.233 194.996 839.978 196.282C840.723 197.569 842.377 198.004 843.664 197.259C844.951 196.515 845.386 194.86 844.641 193.573L844.631 193.564Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M842.31 191.3V191.648",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M840.491 191.784L840.675 192.093",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M843.945 197.763L844.119 198.072",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M839.166 193.109L839.475 193.293",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M845.145 196.563L845.454 196.747",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M838.682 194.928H839.03",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M845.58 194.928H845.938",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M839.166 196.747L839.475 196.563",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M845.145 193.293L845.454 193.109",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M840.491 198.072L840.665 197.763",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M843.945 192.093L844.119 191.784",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.631 211.616C844.148 210.794 843.306 210.32 842.416 210.281L842.435 213.019C842.435 213.087 842.377 213.145 842.319 213.145C842.251 213.145 842.203 213.087 842.203 213.029L842.184 210.291C841.768 210.31 841.342 210.426 840.955 210.649C839.668 211.394 839.233 213.048 839.978 214.335C840.723 215.622 842.377 216.057 843.664 215.312C844.951 214.567 845.386 212.913 844.641 211.626L844.631 211.616Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M842.31 209.343V209.691",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M840.491 209.826L840.675 210.136",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M843.945 215.805L844.119 216.115",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M839.166 211.152L839.475 211.336",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M845.145 214.605L845.454 214.789",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M838.682 212.971H839.03",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M845.58 212.971H845.938",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M839.166 214.789L839.475 214.605",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M845.145 211.336L845.454 211.152",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M840.491 216.115L840.665 215.805",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M843.945 210.136L844.119 209.826",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.631 229.659C844.148 228.837 843.306 228.363 842.416 228.324L842.435 231.062C842.435 231.13 842.377 231.188 842.319 231.188C842.251 231.188 842.203 231.13 842.203 231.072L842.184 228.334C841.768 228.353 841.342 228.469 840.955 228.692C839.668 229.437 839.233 231.091 839.978 232.378C840.723 233.664 842.377 234.1 843.664 233.355C844.951 232.61 845.386 230.955 844.641 229.669L844.631 229.659Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M842.31 227.385V227.743",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M840.491 227.869L840.675 228.179",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M843.945 233.848L844.119 234.158",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M839.166 229.204L839.475 229.378",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M845.145 232.648L845.454 232.832",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M838.682 231.013H839.03",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M845.58 231.013H845.938",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M839.166 232.832L839.475 232.648",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M845.145 229.378L845.454 229.204",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M840.491 234.158L840.665 233.848",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M843.945 228.179L844.119 227.869",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.631 247.702C844.148 246.879 843.306 246.405 842.416 246.367L842.435 249.105C842.435 249.172 842.377 249.23 842.319 249.23C842.251 249.23 842.203 249.172 842.203 249.114L842.184 246.376C841.768 246.396 841.342 246.512 840.955 246.734C839.668 247.479 839.233 249.134 839.978 250.42C840.723 251.707 842.377 252.142 843.664 251.397C844.951 250.652 845.386 248.998 844.641 247.711L844.631 247.702Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M842.31 245.428V245.786",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M840.491 245.912L840.675 246.221",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M843.945 251.891L844.119 252.2",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M839.166 247.247L839.475 247.421",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M845.145 250.701L845.454 250.875",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M838.682 249.056H839.03",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M845.58 249.056H845.938",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M839.166 250.875L839.475 250.701",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M845.145 247.421L845.454 247.247",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M840.491 252.2L840.665 251.891",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M843.945 246.221L844.119 245.912",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.593 193.68C822.148 192.838 821.326 192.326 820.436 192.258L820.329 194.996C820.329 195.064 820.271 195.112 820.204 195.112C820.136 195.112 820.088 195.054 820.088 194.986L820.194 192.248C819.778 192.248 819.352 192.345 818.956 192.548C817.64 193.245 817.137 194.87 817.824 196.186C818.52 197.501 820.146 198.005 821.461 197.318C822.777 196.621 823.28 194.996 822.593 193.68Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M820.368 191.31L820.349 191.668",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M818.53 191.716L818.695 192.036",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M821.723 197.84L821.887 198.159",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M817.147 192.983L817.447 193.177",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M822.971 196.698L823.271 196.882",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M816.585 194.783L816.934 194.793",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M823.483 195.083L823.832 195.092",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M816.992 196.611L817.301 196.447",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M823.116 193.429L823.425 193.264",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M818.259 197.995L818.443 197.705",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M821.965 192.171L822.158 191.871",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M821.81 211.704C821.365 210.862 820.543 210.349 819.653 210.281L819.546 213.019C819.546 213.087 819.488 213.135 819.42 213.135C819.353 213.135 819.304 213.077 819.304 213.01L819.411 210.272C818.995 210.272 818.569 210.368 818.172 210.572C816.857 211.268 816.354 212.893 817.041 214.209C817.737 215.525 819.362 216.028 820.678 215.341C821.994 214.654 822.497 213.019 821.81 211.704Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M819.585 209.333L819.565 209.691",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M817.747 209.749L817.911 210.059",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M820.939 215.873L821.103 216.183",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M816.363 211.017L816.663 211.21",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M822.187 214.722L822.487 214.915",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M815.802 212.806L816.151 212.826",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M822.7 213.106L823.058 213.126",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M816.208 214.644L816.518 214.48",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M822.333 211.452L822.642 211.288",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M817.476 216.028L817.659 215.728",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M821.181 210.204L821.375 209.904",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M821.026 229.736C820.581 228.895 819.758 228.382 818.868 228.314L818.762 231.052C818.762 231.12 818.704 231.168 818.636 231.168C818.569 231.168 818.52 231.11 818.52 231.043L818.627 228.305C818.211 228.305 817.785 228.401 817.388 228.605C816.073 229.301 815.569 230.926 816.256 232.242C816.953 233.558 818.578 234.061 819.894 233.374C821.21 232.687 821.713 231.052 821.026 229.736Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M818.801 227.366L818.782 227.714",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M816.962 227.773L817.127 228.082",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M820.156 233.896L820.32 234.206",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M815.58 229.04L815.879 229.233",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M821.403 232.755L821.703 232.939",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M815.019 230.83L815.377 230.849",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M821.916 231.13L822.274 231.149",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M815.425 232.668L815.744 232.503",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M821.548 229.475L821.868 229.311",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M816.692 234.051L816.876 233.751",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M820.407 228.227L820.591 227.927",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M820.242 247.76C819.797 246.918 818.975 246.406 818.085 246.338L817.978 249.076C817.978 249.143 817.92 249.192 817.853 249.192C817.785 249.192 817.736 249.134 817.736 249.066L817.843 246.328C817.427 246.328 817.001 246.425 816.605 246.628C815.289 247.325 814.786 248.95 815.473 250.266C816.169 251.581 817.795 252.084 819.11 251.398C820.426 250.701 820.929 249.076 820.242 247.76Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M818.017 245.39L818.007 245.748",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M816.189 245.796L816.353 246.115",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M819.372 251.92L819.536 252.239",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M814.796 247.073L815.096 247.257",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M820.629 250.778L820.92 250.972",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M814.234 248.863L814.592 248.872",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M821.132 249.163L821.49 249.172",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M814.641 250.691L814.96 250.527",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M820.765 247.508L821.084 247.344",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M815.908 252.084L816.102 251.784",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M819.623 246.251L819.817 245.96",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M941.086 314.242C941.086 313.662 940.612 313.188 940.031 313.188C939.451 313.188 938.977 313.662 938.977 314.242C938.977 314.823 939.451 315.297 940.031 315.297C940.612 315.297 941.086 314.823 941.086 314.242Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.604 314.242C942.604 312.82 941.453 311.669 940.031 311.669C938.609 311.669 937.458 312.82 937.458 314.242C937.458 315.664 938.609 316.815 940.031 316.815C941.453 316.815 942.604 315.664 942.604 314.242Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M932.901 314.242C932.901 312.82 931.75 311.669 930.328 311.669C928.906 311.669 927.754 312.82 927.754 314.242C927.754 315.664 928.906 316.815 930.328 316.815C931.75 316.815 932.901 315.664 932.901 314.242Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M963.559 294.371C963.559 293.79 963.085 293.316 962.505 293.316C961.924 293.316 961.45 293.79 961.45 294.371C961.45 294.951 961.924 295.425 962.505 295.425C963.085 295.425 963.559 294.951 963.559 294.371Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M965.078 294.371C965.078 292.949 963.927 291.798 962.505 291.798C961.082 291.798 959.931 292.949 959.931 294.371C959.931 295.793 961.082 296.944 962.505 296.944C963.927 296.944 965.078 295.793 965.078 294.371Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M955.375 294.371C955.375 292.949 954.224 291.798 952.801 291.798C951.379 291.798 950.228 292.949 950.228 294.371C950.228 295.793 951.379 296.944 952.801 296.944C954.224 296.944 955.375 295.793 955.375 294.371Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M933.752 295.88C933.81 295.841 933.83 295.774 933.801 295.716C933.762 295.658 933.694 295.638 933.636 295.667C932.679 296.219 932.088 297.254 932.088 298.366C932.088 300.079 933.481 301.482 935.184 301.482C936.887 301.482 938.28 300.088 938.28 298.366C938.28 297.254 937.69 296.228 936.732 295.667C936.674 295.629 936.597 295.658 936.568 295.716C936.529 295.774 936.558 295.851 936.616 295.88C937.496 296.393 938.048 297.341 938.048 298.366C938.048 299.943 936.771 301.23 935.194 301.23C933.617 301.23 932.34 299.943 932.34 298.366C932.34 297.351 932.882 296.393 933.762 295.88H933.752Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M935.3 298.009V295.029C935.3 294.961 935.242 294.903 935.175 294.903C935.107 294.903 935.049 294.961 935.049 295.029V298.009C935.049 298.076 935.107 298.134 935.175 298.134C935.242 298.134 935.3 298.076 935.3 298.009Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M932.804 302.952C931.237 302.081 930.173 300.379 930.173 298.415C930.173 295.832 932.03 293.684 934.449 293.316",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M935.9 293.316C938.328 293.674 940.195 295.822 940.195 298.415C940.195 300.195 939.315 301.762 937.99 302.681",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M956.226 369.744C956.284 369.706 956.303 369.638 956.274 369.58C956.236 369.522 956.168 369.503 956.11 369.532C955.152 370.083 954.562 371.118 954.562 372.231C954.562 373.943 955.955 375.346 957.658 375.346C959.361 375.346 960.754 373.953 960.754 372.231C960.754 371.118 960.163 370.093 959.206 369.532C959.148 369.493 959.07 369.522 959.041 369.58C959.003 369.638 959.032 369.715 959.09 369.744C959.97 370.257 960.521 371.205 960.521 372.231C960.521 373.808 959.244 375.094 957.667 375.094C956.091 375.094 954.814 373.808 954.814 372.231C954.814 371.215 955.355 370.257 956.236 369.744H956.226Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M957.774 371.873V368.893C957.774 368.825 957.716 368.767 957.648 368.767C957.581 368.767 957.522 368.825 957.522 368.893V371.873C957.522 371.94 957.581 371.998 957.648 371.998C957.716 371.998 957.774 371.94 957.774 371.873Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M955.278 376.807C953.711 375.936 952.646 374.233 952.646 372.269C952.646 369.686 954.504 367.539 956.923 367.171",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M958.374 367.181C960.802 367.539 962.669 369.686 962.669 372.279C962.669 374.059 961.789 375.626 960.463 376.545",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M990.231 369.744C990.289 369.706 990.309 369.638 990.28 369.58C990.241 369.522 990.173 369.503 990.115 369.532C989.158 370.083 988.567 371.118 988.567 372.231C988.567 373.943 989.96 375.346 991.663 375.346C993.366 375.346 994.759 373.953 994.759 372.231C994.759 371.118 994.169 370.093 993.211 369.532C993.153 369.493 993.076 369.522 993.047 369.58C993.008 369.638 993.037 369.715 993.095 369.744C993.975 370.257 994.527 371.205 994.527 372.231C994.527 373.808 993.25 375.094 991.673 375.094C990.096 375.094 988.819 373.808 988.819 372.231C988.819 371.215 989.361 370.257 990.241 369.744H990.231Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M991.789 371.873V368.893C991.789 368.825 991.731 368.767 991.663 368.767C991.596 368.767 991.538 368.825 991.538 368.893V371.873C991.538 371.94 991.596 371.998 991.663 371.998C991.731 371.998 991.789 371.94 991.789 371.873Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M989.283 376.807C987.716 375.936 986.652 374.233 986.652 372.269C986.652 369.686 988.509 367.539 990.928 367.171",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M992.379 367.181C994.807 367.539 996.674 369.686 996.674 372.279C996.674 374.059 995.794 375.626 994.469 376.545",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M956.226 389.122C956.284 389.083 956.303 389.016 956.274 388.958C956.236 388.9 956.168 388.88 956.11 388.909C955.152 389.461 954.562 390.496 954.562 391.608C954.562 393.321 955.955 394.724 957.658 394.724C959.361 394.724 960.754 393.33 960.754 391.608C960.754 390.496 960.163 389.47 959.206 388.909C959.148 388.871 959.07 388.9 959.041 388.958C959.003 389.016 959.032 389.093 959.09 389.122C959.97 389.635 960.521 390.583 960.521 391.608C960.521 393.185 959.244 394.472 957.667 394.472C956.091 394.472 954.814 393.185 954.814 391.608C954.814 390.593 955.355 389.635 956.236 389.122H956.226Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M957.774 391.241V388.261C957.774 388.193 957.716 388.135 957.648 388.135C957.581 388.135 957.522 388.193 957.522 388.261V391.241C957.522 391.308 957.581 391.366 957.648 391.366C957.716 391.366 957.774 391.308 957.774 391.241Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M955.278 396.184C953.711 395.314 952.646 393.611 952.646 391.647C952.646 389.064 954.504 386.916 956.923 386.549",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M958.374 386.549C960.802 386.907 962.669 389.054 962.669 391.647C962.669 393.427 961.789 394.994 960.463 395.913",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M933.752 264.768C933.81 264.729 933.83 264.661 933.801 264.603C933.762 264.545 933.694 264.526 933.636 264.555C932.679 265.106 932.088 266.141 932.088 267.254C932.088 268.966 933.481 270.369 935.184 270.369C936.887 270.369 938.28 268.976 938.28 267.254C938.28 266.141 937.69 265.116 936.732 264.555C936.674 264.516 936.597 264.545 936.568 264.603C936.529 264.661 936.558 264.739 936.616 264.768C937.496 265.28 938.048 266.228 938.048 267.254C938.048 268.831 936.771 270.118 935.194 270.118C933.617 270.118 932.34 268.831 932.34 267.254C932.34 266.238 932.882 265.28 933.762 264.768H933.752Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M935.3 266.886V263.907C935.3 263.839 935.242 263.781 935.175 263.781C935.107 263.781 935.049 263.839 935.049 263.907V266.886C935.049 266.954 935.107 267.012 935.175 267.012C935.242 267.012 935.3 266.954 935.3 266.886Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M932.804 271.83C931.237 270.959 930.173 269.256 930.173 267.293C930.173 264.709 932.03 262.562 934.449 262.194",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M935.9 262.194C938.328 262.552 940.195 264.7 940.195 267.293C940.195 269.073 939.315 270.64 937.99 271.559",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M956.226 264.903C956.284 264.864 956.303 264.796 956.274 264.738C956.236 264.68 956.168 264.661 956.11 264.69C955.152 265.241 954.562 266.276 954.562 267.389C954.562 269.101 955.955 270.504 957.658 270.504C959.361 270.504 960.754 269.111 960.754 267.389C960.754 266.276 960.163 265.251 959.206 264.69C959.148 264.651 959.07 264.68 959.041 264.738C959.003 264.796 959.032 264.874 959.09 264.903C959.97 265.415 960.521 266.363 960.521 267.389C960.521 268.966 959.244 270.253 957.667 270.253C956.091 270.253 954.814 268.966 954.814 267.389C954.814 266.373 955.355 265.415 956.236 264.903H956.226Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M957.774 267.031V264.051C957.774 263.984 957.716 263.926 957.648 263.926C957.581 263.926 957.522 263.984 957.522 264.051V267.031C957.522 267.099 957.581 267.157 957.648 267.157C957.716 267.157 957.774 267.099 957.774 267.031Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M955.278 271.965C953.711 271.094 952.646 269.392 952.646 267.428C952.646 264.845 954.504 262.697 956.923 262.329",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M958.374 262.339C960.802 262.697 962.669 264.845 962.669 267.438C962.669 269.218 961.789 270.785 960.463 271.704",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1003.72 221.31C1003.78 221.271 1003.79 221.204 1003.77 221.146C1003.73 221.088 1003.66 221.068 1003.6 221.097C1002.64 221.649 1002.05 222.684 1002.05 223.796C1002.05 225.509 1003.45 226.912 1005.15 226.912C1006.85 226.912 1008.24 225.518 1008.24 223.796C1008.24 222.684 1007.65 221.658 1006.7 221.097C1006.64 221.059 1006.56 221.088 1006.53 221.146C1006.49 221.204 1006.52 221.281 1006.58 221.31C1007.46 221.823 1008.01 222.771 1008.01 223.796C1008.01 225.373 1006.74 226.66 1005.16 226.66C1003.58 226.66 1002.3 225.373 1002.3 223.796C1002.3 222.781 1002.85 221.823 1003.73 221.31H1003.72Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1005.27 223.438V220.459C1005.27 220.391 1005.21 220.333 1005.14 220.333C1005.07 220.333 1005.01 220.391 1005.01 220.459V223.438C1005.01 223.506 1005.07 223.564 1005.14 223.564C1005.21 223.564 1005.27 223.506 1005.27 223.438Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.77 228.372C1001.2 227.502 1000.14 225.799 1000.14 223.835C1000.14 221.252 1002 219.104 1004.41 218.737",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.86 218.746C1008.28 219.104 1010.15 221.252 1010.15 223.845C1010.15 225.625 1009.27 227.192 1007.95 228.111",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M801.997 159.568H792.487C792.274 159.568 792.11 159.742 792.11 159.945V172.696C792.11 172.909 792.284 173.073 792.487 173.073H801.997C802.21 173.073 802.374 172.899 802.374 172.696V159.945C802.374 159.732 802.2 159.568 801.997 159.568ZM800.13 168.7C800.13 168.884 799.985 169.039 799.791 169.039H794.683C794.499 169.039 794.345 168.894 794.345 168.7V165.015C794.345 164.927 794.383 164.84 794.441 164.773L795.36 163.873C795.419 163.815 795.506 163.776 795.593 163.776H798.853C798.94 163.776 799.027 163.815 799.085 163.873L800.004 164.773C800.072 164.831 800.101 164.918 800.101 165.015V168.7H800.13Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M784.989 159.568H775.479C775.267 159.568 775.102 159.742 775.102 159.945V172.696C775.102 172.909 775.276 173.073 775.479 173.073H784.989C785.202 173.073 785.367 172.899 785.367 172.696V159.945C785.367 159.732 785.192 159.568 784.989 159.568ZM783.132 168.7C783.132 168.884 782.987 169.039 782.793 169.039H777.685C777.501 169.039 777.347 168.894 777.347 168.7V165.015C777.347 164.927 777.385 164.84 777.443 164.773L778.362 163.873C778.42 163.815 778.507 163.776 778.595 163.776H781.855C781.942 163.776 782.029 163.815 782.087 163.873L783.006 164.773C783.074 164.831 783.103 164.918 783.103 165.015V168.7H783.132Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M894.367 391.366H859.975C859.825 391.366 859.704 391.488 859.704 391.637V393.243C859.704 393.393 859.825 393.514 859.975 393.514H894.367C894.517 393.514 894.638 393.393 894.638 393.243V391.637C894.638 391.488 894.517 391.366 894.367 391.366Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M877.012 386.935V397.945C877.012 398.09 877.08 398.216 877.167 398.216C877.254 398.216 877.322 398.1 877.322 397.945V386.935C877.322 386.79 877.254 386.665 877.167 386.665C877.08 386.665 877.012 386.781 877.012 386.935Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.98 309.037C959.496 308.215 958.655 307.741 957.765 307.702L957.784 310.44C957.784 310.508 957.726 310.566 957.668 310.566C957.6 310.566 957.552 310.508 957.552 310.45L957.532 307.712C957.116 307.731 956.691 307.848 956.304 308.07C955.017 308.815 954.582 310.469 955.327 311.756C956.072 313.043 957.726 313.478 959.013 312.733C960.299 311.988 960.735 310.334 959.99 309.047L959.98 309.037Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M957.658 306.764V307.122",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M955.839 307.248L956.014 307.557",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M959.293 313.236L959.467 313.536",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M954.514 308.583L954.814 308.757",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M960.493 312.036L960.802 312.211",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M954.021 310.392H954.378",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M960.928 310.392H961.286",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M954.514 312.211L954.814 312.036",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M960.493 308.757L960.802 308.583",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M955.839 313.536L956.014 313.236",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M959.293 307.557L959.467 307.248",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.98 322.775C959.496 321.953 958.655 321.479 957.765 321.44L957.784 324.178C957.784 324.246 957.726 324.304 957.668 324.304C957.6 324.304 957.552 324.246 957.552 324.187L957.532 321.45C957.116 321.469 956.691 321.585 956.304 321.808C955.017 322.553 954.582 324.207 955.327 325.494C956.072 326.78 957.726 327.216 959.013 326.471C960.299 325.726 960.735 324.071 959.99 322.785L959.98 322.775Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M957.658 320.501V320.85",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M955.839 320.985L956.014 321.295",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M959.293 326.964L959.467 327.274",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M954.514 322.311L954.814 322.494",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M960.493 325.764L960.802 325.948",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M954.021 324.129H954.378",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M960.928 324.129H961.286",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M954.514 325.948L954.814 325.764",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M960.493 322.494L960.802 322.311",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M955.839 327.274L956.014 326.964",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M959.293 321.295L959.467 320.985",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M960.221 355.184C960.221 353.762 959.07 352.611 957.648 352.611C956.225 352.611 955.074 353.762 955.074 355.184C955.074 356.606 956.225 357.758 957.648 357.758C959.07 357.758 960.221 356.606 960.221 355.184Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M950.073 275.796H966.423",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M950.073 259.176H966.423",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M950.073 289.708H966.423",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M950.073 299.789H966.423",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M981.931 172.822C981.931 172.241 981.457 171.767 980.876 171.767C980.296 171.767 979.822 172.241 979.822 172.822C979.822 173.402 980.296 173.876 980.876 173.876C981.457 173.876 981.931 173.402 981.931 172.822Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M983.45 172.822C983.45 171.4 982.299 170.249 980.877 170.249C979.454 170.249 978.303 171.4 978.303 172.822C978.303 174.244 979.454 175.395 980.877 175.395C982.299 175.395 983.45 174.244 983.45 172.822Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1007.71 189.607C1007.71 188.185 1006.56 187.034 1005.14 187.034C1003.72 187.034 1002.57 188.185 1002.57 189.607C1002.57 191.029 1003.72 192.18 1005.14 192.18C1006.56 192.18 1007.71 191.029 1007.71 189.607Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1006.48 200.761C1005.66 200.287 1004.69 200.307 1003.9 200.713L1005.28 203.083C1005.31 203.141 1005.29 203.219 1005.25 203.248C1005.19 203.277 1005.11 203.257 1005.08 203.209L1003.7 200.839C1003.34 201.061 1003.04 201.371 1002.82 201.758C1002.07 203.045 1002.52 204.699 1003.81 205.434C1005.1 206.179 1006.76 205.734 1007.49 204.438C1008.24 203.151 1007.79 201.497 1006.49 200.761H1006.48Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.33 199.949L1003.5 200.258",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M1002 201.274L1002.3 201.458",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.97 204.738L1008.28 204.921",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.51 203.093H1001.87",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.42 203.103H1008.77",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M1002 204.912L1002.3 204.728",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.98 201.468L1008.28 201.284",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.32 206.237L1003.49 205.928",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.78 200.268L1006.96 199.958",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.14 206.731L1005.13 206.373",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.15 199.823V199.465",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M982.288 304.471C982.288 303.049 981.137 301.898 979.715 301.898C978.293 301.898 977.142 303.049 977.142 304.471C977.142 305.893 978.293 307.044 979.715 307.044C981.137 307.044 982.288 305.893 982.288 304.471Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M994.237 304.471C994.237 303.049 993.085 301.898 991.663 301.898C990.241 301.898 989.09 303.049 989.09 304.471C989.09 305.893 990.241 307.044 991.663 307.044C993.085 307.044 994.237 305.893 994.237 304.471Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1006.18 304.471C1006.18 303.049 1005.03 301.898 1003.61 301.898C1002.19 301.898 1001.04 303.049 1001.04 304.471C1001.04 305.893 1002.19 307.044 1003.61 307.044C1005.03 307.044 1006.18 305.893 1006.18 304.471Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M982.288 318.189C982.288 316.767 981.137 315.616 979.715 315.616C978.293 315.616 977.142 316.767 977.142 318.189C977.142 319.611 978.293 320.763 979.715 320.763C981.137 320.763 982.288 319.611 982.288 318.189Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M994.237 318.189C994.237 316.767 993.085 315.616 991.663 315.616C990.241 315.616 989.09 316.767 989.09 318.189C989.09 319.611 990.241 320.763 991.663 320.763C993.085 320.763 994.237 319.611 994.237 318.189Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1006.18 318.189C1006.18 316.767 1005.03 315.616 1003.61 315.616C1002.19 315.616 1001.04 316.767 1001.04 318.189C1001.04 319.611 1002.19 320.763 1003.61 320.763C1005.03 320.763 1006.18 319.611 1006.18 318.189Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M991.615 393.901C993.41 393.901 994.865 392.446 994.865 390.651C994.865 388.855 993.41 387.4 991.615 387.4C989.82 387.4 988.364 388.855 988.364 390.651C988.364 392.446 989.82 393.901 991.615 393.901Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M991.615 395.836C994.479 395.836 996.8 393.514 996.8 390.651C996.8 387.787 994.479 385.465 991.615 385.465C988.751 385.465 986.429 387.787 986.429 390.651C986.429 393.514 988.751 395.836 991.615 395.836Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M416.033 88.0942C416.293 88.0942 416.504 87.8828 416.504 87.622C416.504 87.3613 416.293 87.1499 416.033 87.1499C415.773 87.1499 415.562 87.3613 415.562 87.622C415.562 87.8828 415.773 88.0942 416.033 88.0942Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M435.004 88.0942C435.264 88.0942 435.475 87.8828 435.475 87.622C435.475 87.3613 435.264 87.1499 435.004 87.1499C434.744 87.1499 434.533 87.3613 434.533 87.622C434.533 87.8828 434.744 88.0942 435.004 88.0942Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M453.973 88.0942C454.233 88.0942 454.444 87.8828 454.444 87.622C454.444 87.3613 454.233 87.1499 453.973 87.1499C453.713 87.1499 453.502 87.3613 453.502 87.622C453.502 87.8828 453.713 88.0942 453.973 88.0942Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M472.944 88.0942C473.204 88.0942 473.415 87.8828 473.415 87.622C473.415 87.3613 473.204 87.1499 472.944 87.1499C472.684 87.1499 472.473 87.3613 472.473 87.622C472.473 87.8828 472.684 88.0942 472.944 88.0942Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M488.27 92.3529H488.215C487.966 92.3529 487.763 92.1486 487.763 91.8989V89.7789C487.763 89.7153 487.713 89.6654 487.65 89.6654H484.136C484.073 89.6654 484.023 89.6155 484.023 89.5519V87.8541C484.023 87.7905 483.973 87.7406 483.91 87.7406H482.696C482.633 87.7406 482.583 87.6906 482.583 87.6271V86.1789C482.583 86.1154 482.533 86.0654 482.47 86.0654H477.49C477.426 86.0654 477.377 86.1154 477.377 86.1789V87.6271C477.377 87.6906 477.327 87.7406 477.263 87.7406H476.05C475.987 87.7406 475.937 87.7905 475.937 87.8541V89.5519C475.937 89.6155 475.887 89.6654 475.824 89.6654H472.31C472.247 89.6654 472.197 89.7153 472.197 89.7789V91.8989C472.197 92.1486 471.993 92.3529 471.744 92.3529H471.69C471.441 92.3529 471.237 92.5572 471.237 92.8069V95.4489C471.237 95.6986 471.441 95.9029 471.69 95.9029H471.744C471.993 95.9029 472.197 96.1072 472.197 96.3569V98.7311C472.197 98.7947 472.247 98.8446 472.31 98.8446H475.158V95.1856C475.158 94.9768 475.326 94.8089 475.534 94.8089C475.742 94.8089 475.91 94.9768 475.91 95.1856V98.8446H476.639V95.1856C476.639 94.9768 476.806 94.8089 477.014 94.8089C477.223 94.8089 477.39 94.9768 477.39 95.1856V98.8446H478.119V95.1856C478.119 94.9768 478.287 94.8089 478.495 94.8089C478.703 94.8089 478.871 94.9768 478.871 95.1856V98.8446H479.6V95.1856C479.6 94.9768 479.767 94.8089 479.975 94.8089C480.184 94.8089 480.351 94.9768 480.351 95.1856V98.8446H481.08V95.1856C481.08 94.9768 481.248 94.8089 481.456 94.8089C481.664 94.8089 481.832 94.9768 481.832 95.1856V98.8446H482.561V95.1856C482.561 94.9768 482.728 94.8089 482.936 94.8089C483.145 94.8089 483.312 94.9768 483.312 95.1856V98.8446H484.041V95.1856C484.041 94.9768 484.209 94.8089 484.417 94.8089C484.625 94.8089 484.793 94.9768 484.793 95.1856V98.8446H487.64C487.704 98.8446 487.754 98.7947 487.754 98.7311V96.3569C487.754 96.1072 487.957 95.9029 488.206 95.9029H488.261C488.51 95.9029 488.714 95.6986 488.714 95.4489V92.8069C488.714 92.5572 488.51 92.3529 488.261 92.3529H488.27Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M469.3 92.3529H469.245C468.996 92.3529 468.793 92.1486 468.793 91.8989V89.7789C468.793 89.7153 468.743 89.6654 468.679 89.6654H465.166C465.103 89.6654 465.053 89.6155 465.053 89.5519V87.8541C465.053 87.7905 465.003 87.7406 464.94 87.7406H463.726C463.663 87.7406 463.613 87.6906 463.613 87.6271V86.1789C463.613 86.1154 463.563 86.0654 463.5 86.0654H458.52C458.456 86.0654 458.406 86.1154 458.406 86.1789V87.6271C458.406 87.6906 458.357 87.7406 458.293 87.7406H457.08C457.016 87.7406 456.967 87.7905 456.967 87.8541V89.5519C456.967 89.6155 456.917 89.6654 456.853 89.6654H453.34C453.277 89.6654 453.227 89.7153 453.227 89.7789V91.8989C453.227 92.1486 453.023 92.3529 452.774 92.3529H452.72C452.471 92.3529 452.267 92.5572 452.267 92.8069V95.4489C452.267 95.6986 452.471 95.9029 452.72 95.9029H452.774C453.023 95.9029 453.227 96.1072 453.227 96.3569V98.7311C453.227 98.7947 453.277 98.8446 453.34 98.8446H456.188V95.1856C456.188 94.9768 456.355 94.8089 456.564 94.8089C456.772 94.8089 456.939 94.9768 456.939 95.1856V98.8446H457.668V95.1856C457.668 94.9768 457.836 94.8089 458.044 94.8089C458.252 94.8089 458.42 94.9768 458.42 95.1856V98.8446H459.149V95.1856C459.149 94.9768 459.316 94.8089 459.525 94.8089C459.733 94.8089 459.9 94.9768 459.9 95.1856V98.8446H460.629V95.1856C460.629 94.9768 460.797 94.8089 461.005 94.8089C461.213 94.8089 461.381 94.9768 461.381 95.1856V98.8446H462.11V95.1856C462.11 94.9768 462.277 94.8089 462.486 94.8089C462.694 94.8089 462.861 94.9768 462.861 95.1856V98.8446H463.59V95.1856C463.59 94.9768 463.758 94.8089 463.966 94.8089C464.174 94.8089 464.342 94.9768 464.342 95.1856V98.8446H465.071V95.1856C465.071 94.9768 465.238 94.8089 465.447 94.8089C465.655 94.8089 465.822 94.9768 465.822 95.1856V98.8446H468.67C468.734 98.8446 468.783 98.7947 468.783 98.7311V96.3569C468.783 96.1072 468.987 95.9029 469.236 95.9029H469.291C469.54 95.9029 469.743 95.6986 469.743 95.4489V92.8069C469.743 92.5572 469.54 92.3529 469.291 92.3529H469.3Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M450.329 92.3529H450.275C450.026 92.3529 449.822 92.1486 449.822 91.8989V89.7789C449.822 89.7153 449.772 89.6654 449.709 89.6654H446.195C446.132 89.6654 446.082 89.6155 446.082 89.5519V87.8541C446.082 87.7905 446.032 87.7406 445.969 87.7406H444.756C444.692 87.7406 444.642 87.6906 444.642 87.6271V86.1789C444.642 86.1154 444.593 86.0654 444.529 86.0654H439.549C439.485 86.0654 439.436 86.1154 439.436 86.1789V87.6271C439.436 87.6906 439.386 87.7406 439.323 87.7406H438.109C438.046 87.7406 437.996 87.7905 437.996 87.8541V89.5519C437.996 89.6155 437.946 89.6654 437.883 89.6654H434.369C434.306 89.6654 434.256 89.7153 434.256 89.7789V91.8989C434.256 92.1486 434.052 92.3529 433.803 92.3529H433.749C433.5 92.3529 433.296 92.5572 433.296 92.8069V95.4489C433.296 95.6986 433.5 95.9029 433.749 95.9029H433.803C434.052 95.9029 434.256 96.1072 434.256 96.3569V98.7311C434.256 98.7947 434.306 98.8446 434.369 98.8446H437.217V95.1856C437.217 94.9768 437.385 94.8089 437.593 94.8089C437.801 94.8089 437.969 94.9768 437.969 95.1856V98.8446H438.698V95.1856C438.698 94.9768 438.865 94.8089 439.073 94.8089C439.282 94.8089 439.449 94.9768 439.449 95.1856V98.8446H440.178V95.1856C440.178 94.9768 440.346 94.8089 440.554 94.8089C440.762 94.8089 440.93 94.9768 440.93 95.1856V98.8446H441.659V95.1856C441.659 94.9768 441.826 94.8089 442.034 94.8089C442.243 94.8089 442.41 94.9768 442.41 95.1856V98.8446H443.139V95.1856C443.139 94.9768 443.307 94.8089 443.515 94.8089C443.723 94.8089 443.891 94.9768 443.891 95.1856V98.8446H444.62V95.1856C444.62 94.9768 444.787 94.8089 444.995 94.8089C445.204 94.8089 445.371 94.9768 445.371 95.1856V98.8446H446.1V95.1856C446.1 94.9768 446.268 94.8089 446.476 94.8089C446.684 94.8089 446.852 94.9768 446.852 95.1856V98.8446H449.7C449.763 98.8446 449.813 98.7947 449.813 98.7311V96.3569C449.813 96.1072 450.017 95.9029 450.266 95.9029H450.32C450.569 95.9029 450.773 95.6986 450.773 95.4489V92.8069C450.773 92.5572 450.569 92.3529 450.32 92.3529H450.329Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M431.359 92.3529H431.305C431.056 92.3529 430.852 92.1486 430.852 91.8989V89.7789C430.852 89.7153 430.802 89.6654 430.739 89.6654H427.226C427.162 89.6654 427.112 89.6155 427.112 89.5519V87.8541C427.112 87.7905 427.063 87.7406 426.999 87.7406H425.786C425.722 87.7406 425.673 87.6906 425.673 87.6271V86.1789C425.673 86.1154 425.623 86.0654 425.559 86.0654H420.579C420.516 86.0654 420.466 86.1154 420.466 86.1789V87.6271C420.466 87.6906 420.416 87.7406 420.353 87.7406H419.139C419.076 87.7406 419.026 87.7905 419.026 87.8541V89.5519C419.026 89.6155 418.976 89.6654 418.913 89.6654H415.4C415.336 89.6654 415.286 89.7153 415.286 89.7789V91.8989C415.286 92.1486 415.083 92.3529 414.834 92.3529H414.779C414.53 92.3529 414.327 92.5572 414.327 92.8069V95.4489C414.327 95.6986 414.53 95.9029 414.779 95.9029H414.834C415.083 95.9029 415.286 96.1072 415.286 96.3569V98.7311C415.286 98.7947 415.336 98.8446 415.4 98.8446H418.247V95.1856C418.247 94.9768 418.415 94.8089 418.623 94.8089C418.832 94.8089 418.999 94.9768 418.999 95.1856V98.8446H419.728V95.1856C419.728 94.9768 419.896 94.8089 420.104 94.8089C420.312 94.8089 420.48 94.9768 420.48 95.1856V98.8446H421.208V95.1856C421.208 94.9768 421.376 94.8089 421.584 94.8089C421.793 94.8089 421.96 94.9768 421.96 95.1856V98.8446H422.689V95.1856C422.689 94.9768 422.857 94.8089 423.065 94.8089C423.273 94.8089 423.441 94.9768 423.441 95.1856V98.8446H424.169V95.1856C424.169 94.9768 424.337 94.8089 424.545 94.8089C424.754 94.8089 424.921 94.9768 424.921 95.1856V98.8446H425.65V95.1856C425.65 94.9768 425.817 94.8089 426.026 94.8089C426.234 94.8089 426.402 94.9768 426.402 95.1856V98.8446H427.13V95.1856C427.13 94.9768 427.298 94.8089 427.506 94.8089C427.715 94.8089 427.882 94.9768 427.882 95.1856V98.8446H430.73C430.793 98.8446 430.843 98.7947 430.843 98.7311V96.3569C430.843 96.1072 431.047 95.9029 431.296 95.9029H431.35C431.599 95.9029 431.803 95.6986 431.803 95.4489V92.8069C431.803 92.5572 431.599 92.3529 431.35 92.3529H431.359Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M359.046 88.0942C359.306 88.0942 359.516 87.8828 359.516 87.622C359.516 87.3613 359.306 87.1499 359.046 87.1499C358.786 87.1499 358.575 87.3613 358.575 87.622C358.575 87.8828 358.786 88.0942 359.046 88.0942Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M340.009 88.0942C340.269 88.0942 340.48 87.8828 340.48 87.622C340.48 87.3613 340.269 87.1499 340.009 87.1499C339.749 87.1499 339.539 87.3613 339.539 87.622C339.539 87.8828 339.749 88.0942 340.009 88.0942Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M378.016 88.0942C378.276 88.0942 378.487 87.8828 378.487 87.622C378.487 87.3613 378.276 87.1499 378.016 87.1499C377.756 87.1499 377.545 87.3613 377.545 87.622C377.545 87.8828 377.756 88.0942 378.016 88.0942Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M396.986 88.0942C397.246 88.0942 397.456 87.8828 397.456 87.622C397.456 87.3613 397.246 87.1499 396.986 87.1499C396.725 87.1499 396.515 87.3613 396.515 87.622C396.515 87.8828 396.725 88.0942 396.986 88.0942Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M412.312 92.3529H412.257C412.008 92.3529 411.805 92.1486 411.805 91.8989V89.7789C411.805 89.7153 411.755 89.6654 411.692 89.6654H408.178C408.115 89.6654 408.065 89.6155 408.065 89.5519V87.8541C408.065 87.7905 408.015 87.7406 407.952 87.7406H406.738C406.675 87.7406 406.625 87.6906 406.625 87.6271V86.1789C406.625 86.1154 406.575 86.0654 406.512 86.0654H401.532C401.468 86.0654 401.419 86.1154 401.419 86.1789V87.6271C401.419 87.6906 401.369 87.7406 401.305 87.7406H400.092C400.029 87.7406 399.979 87.7905 399.979 87.8541V89.5519C399.979 89.6155 399.929 89.6654 399.866 89.6654H396.352C396.289 89.6654 396.239 89.7153 396.239 89.7789V91.8989C396.239 92.1486 396.035 92.3529 395.786 92.3529H395.732C395.483 92.3529 395.279 92.5572 395.279 92.8069V95.4489C395.279 95.6986 395.483 95.9029 395.732 95.9029H395.786C396.035 95.9029 396.239 96.1072 396.239 96.3569V98.7311C396.239 98.7947 396.289 98.8446 396.352 98.8446H399.2V95.1856C399.2 94.9768 399.368 94.8089 399.576 94.8089C399.784 94.8089 399.952 94.9768 399.952 95.1856V98.8446H400.681V95.1856C400.681 94.9768 400.848 94.8089 401.056 94.8089C401.265 94.8089 401.432 94.9768 401.432 95.1856V98.8446H402.161V95.1856C402.161 94.9768 402.329 94.8089 402.537 94.8089C402.745 94.8089 402.913 94.9768 402.913 95.1856V98.8446H403.642V95.1856C403.642 94.9768 403.809 94.8089 404.017 94.8089C404.226 94.8089 404.393 94.9768 404.393 95.1856V98.8446H405.122V95.1856C405.122 94.9768 405.29 94.8089 405.498 94.8089C405.706 94.8089 405.874 94.9768 405.874 95.1856V98.8446H406.603V95.1856C406.603 94.9768 406.77 94.8089 406.978 94.8089C407.187 94.8089 407.354 94.9768 407.354 95.1856V98.8446H408.083V95.1856C408.083 94.9768 408.251 94.8089 408.459 94.8089C408.667 94.8089 408.835 94.9768 408.835 95.1856V98.8446H411.682C411.746 98.8446 411.796 98.7947 411.796 98.7311V96.3569C411.796 96.1072 411.999 95.9029 412.248 95.9029H412.303C412.552 95.9029 412.756 95.6986 412.756 95.4489V92.8069C412.756 92.5572 412.552 92.3529 412.303 92.3529H412.312Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M393.341 92.3529H393.287C393.038 92.3529 392.834 92.1486 392.834 91.8989V89.7789C392.834 89.7153 392.784 89.6654 392.721 89.6654H389.207C389.144 89.6654 389.094 89.6155 389.094 89.5519V87.8541C389.094 87.7905 389.044 87.7406 388.981 87.7406H387.768C387.704 87.7406 387.655 87.6906 387.655 87.6271V86.1789C387.655 86.1154 387.605 86.0654 387.541 86.0654H382.561C382.498 86.0654 382.448 86.1154 382.448 86.1789V87.6271C382.448 87.6906 382.398 87.7406 382.335 87.7406H381.121C381.058 87.7406 381.008 87.7905 381.008 87.8541V89.5519C381.008 89.6155 380.958 89.6654 380.895 89.6654H377.382C377.318 89.6654 377.268 89.7153 377.268 89.7789V91.8989C377.268 92.1486 377.065 92.3529 376.816 92.3529H376.761C376.512 92.3529 376.309 92.5572 376.309 92.8069V95.4489C376.309 95.6986 376.512 95.9029 376.761 95.9029H376.816C377.065 95.9029 377.268 96.1072 377.268 96.3569V98.7311C377.268 98.7947 377.318 98.8446 377.382 98.8446H380.229V95.1856C380.229 94.9768 380.397 94.8089 380.605 94.8089C380.813 94.8089 380.981 94.9768 380.981 95.1856V98.8446H381.71V95.1856C381.71 94.9768 381.877 94.8089 382.086 94.8089C382.294 94.8089 382.461 94.9768 382.461 95.1856V98.8446H383.19V95.1856C383.19 94.9768 383.358 94.8089 383.566 94.8089C383.774 94.8089 383.942 94.9768 383.942 95.1856V98.8446H384.671V95.1856C384.671 94.9768 384.838 94.8089 385.047 94.8089C385.255 94.8089 385.422 94.9768 385.422 95.1856V98.8446H386.151V95.1856C386.151 94.9768 386.319 94.8089 386.527 94.8089C386.735 94.8089 386.903 94.9768 386.903 95.1856V98.8446H387.632V95.1856C387.632 94.9768 387.799 94.8089 388.008 94.8089C388.216 94.8089 388.383 94.9768 388.383 95.1856V98.8446H389.112V95.1856C389.112 94.9768 389.28 94.8089 389.488 94.8089C389.696 94.8089 389.864 94.9768 389.864 95.1856V98.8446H392.712C392.775 98.8446 392.825 98.7947 392.825 98.7311V96.3569C392.825 96.1072 393.029 95.9029 393.278 95.9029H393.332C393.581 95.9029 393.785 95.6986 393.785 95.4489V92.8069C393.785 92.5572 393.581 92.3529 393.332 92.3529H393.341Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M374.371 92.3529H374.317C374.068 92.3529 373.864 92.1486 373.864 91.8989V89.7789C373.864 89.7153 373.814 89.6654 373.751 89.6654H370.237C370.174 89.6654 370.124 89.6155 370.124 89.5519V87.8541C370.124 87.7905 370.074 87.7406 370.011 87.7406H368.798C368.734 87.7406 368.684 87.6906 368.684 87.6271V86.1789C368.684 86.1154 368.635 86.0654 368.571 86.0654H363.591C363.527 86.0654 363.478 86.1154 363.478 86.1789V87.6271C363.478 87.6906 363.428 87.7406 363.365 87.7406H362.151C362.088 87.7406 362.038 87.7905 362.038 87.8541V89.5519C362.038 89.6155 361.988 89.6654 361.925 89.6654H358.411C358.348 89.6654 358.298 89.7153 358.298 89.7789V91.8989C358.298 92.1486 358.094 92.3529 357.845 92.3529H357.791C357.542 92.3529 357.338 92.5572 357.338 92.8069V95.4489C357.338 95.6986 357.542 95.9029 357.791 95.9029H357.845C358.094 95.9029 358.298 96.1072 358.298 96.3569V98.7311C358.298 98.7947 358.348 98.8446 358.411 98.8446H361.259V95.1856C361.259 94.9768 361.427 94.8089 361.635 94.8089C361.843 94.8089 362.011 94.9768 362.011 95.1856V98.8446H362.74V95.1856C362.74 94.9768 362.907 94.8089 363.115 94.8089C363.324 94.8089 363.491 94.9768 363.491 95.1856V98.8446H364.22V95.1856C364.22 94.9768 364.388 94.8089 364.596 94.8089C364.804 94.8089 364.972 94.9768 364.972 95.1856V98.8446H365.701V95.1856C365.701 94.9768 365.868 94.8089 366.076 94.8089C366.285 94.8089 366.452 94.9768 366.452 95.1856V98.8446H367.181V95.1856C367.181 94.9768 367.349 94.8089 367.557 94.8089C367.765 94.8089 367.933 94.9768 367.933 95.1856V98.8446H368.662V95.1856C368.662 94.9768 368.829 94.8089 369.037 94.8089C369.246 94.8089 369.413 94.9768 369.413 95.1856V98.8446H370.142V95.1856C370.142 94.9768 370.31 94.8089 370.518 94.8089C370.726 94.8089 370.894 94.9768 370.894 95.1856V98.8446H373.742C373.805 98.8446 373.855 98.7947 373.855 98.7311V96.3569C373.855 96.1072 374.058 95.9029 374.308 95.9029H374.362C374.611 95.9029 374.815 95.6986 374.815 95.4489V92.8069C374.815 92.5572 374.611 92.3529 374.362 92.3529H374.371Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M355.401 92.3529H355.347C355.098 92.3529 354.894 92.1486 354.894 91.8989V89.7789C354.894 89.7153 354.844 89.6654 354.781 89.6654H351.268C351.204 89.6654 351.154 89.6155 351.154 89.5519V87.8541C351.154 87.7905 351.105 87.7406 351.041 87.7406H349.828C349.764 87.7406 349.715 87.6906 349.715 87.6271V86.1789C349.715 86.1154 349.665 86.0654 349.601 86.0654H344.621C344.558 86.0654 344.508 86.1154 344.508 86.1789V87.6271C344.508 87.6906 344.458 87.7406 344.395 87.7406H343.181C343.118 87.7406 343.068 87.7905 343.068 87.8541V89.5519C343.068 89.6155 343.018 89.6654 342.955 89.6654H339.442C339.378 89.6654 339.328 89.7153 339.328 89.7789V91.8989C339.328 92.1486 339.125 92.3529 338.876 92.3529H338.821C338.572 92.3529 338.369 92.5572 338.369 92.8069V95.4489C338.369 95.6986 338.572 95.9029 338.821 95.9029H338.876C339.125 95.9029 339.328 96.1072 339.328 96.3569V98.7311C339.328 98.7947 339.378 98.8446 339.442 98.8446H342.289V95.1856C342.289 94.9768 342.457 94.8089 342.665 94.8089C342.874 94.8089 343.041 94.9768 343.041 95.1856V98.8446H343.77V95.1856C343.77 94.9768 343.937 94.8089 344.146 94.8089C344.354 94.8089 344.522 94.9768 344.522 95.1856V98.8446H345.25V95.1856C345.25 94.9768 345.418 94.8089 345.626 94.8089C345.835 94.8089 346.002 94.9768 346.002 95.1856V98.8446H346.731V95.1856C346.731 94.9768 346.898 94.8089 347.107 94.8089C347.315 94.8089 347.483 94.9768 347.483 95.1856V98.8446H348.211V95.1856C348.211 94.9768 348.379 94.8089 348.587 94.8089C348.796 94.8089 348.963 94.9768 348.963 95.1856V98.8446H349.692V95.1856C349.692 94.9768 349.859 94.8089 350.068 94.8089C350.276 94.8089 350.444 94.9768 350.444 95.1856V98.8446H351.172V95.1856C351.172 94.9768 351.34 94.8089 351.548 94.8089C351.757 94.8089 351.924 94.9768 351.924 95.1856V98.8446H354.772C354.835 98.8446 354.885 98.7947 354.885 98.7311V96.3569C354.885 96.1072 355.089 95.9029 355.338 95.9029H355.392C355.641 95.9029 355.845 95.6986 355.845 95.4489V92.8069C355.845 92.5572 355.641 92.3529 355.392 92.3529H355.401Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 320.25,
    y: 79.25,
    width: 186.5,
    height: 29.75,
    rx: 1.75,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 83.375,
    width: 159,
    height: 18.75,
    rx: 0.75,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5 40.5369L391.067 40.5369C403.196 40.5369 413.028 50.3679 413.028 62.4974V79.5857",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M655.5 40.5369H593.961C581.831 40.5369 572 50.3679 572 62.4974L571.913 165.158",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M696 40.5369H758.032C770.162 40.5369 779.993 50.3679 779.993 62.4974V135.661",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M434.987 332.513C422.858 332.513 413.028 322.683 413.028 310.554L413.028 108.5",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M434.99 332.513C447.119 332.513 455.594 322.683 455.594 310.554L455.594 284.82",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M551.331 332.513C563.46 332.513 571.937 322.682 571.937 310.554L571.937 165.165",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M551.33 332.513C539.201 332.513 529.371 322.683 529.371 310.554L529.371 284.82",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M243.5 40.1406H118.459C106.33 40.1406 96.4999 49.9712 96.4999 62.1002L96.5 137.029",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeMiterlimit: 10
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M777.971 162.302H782.49C782.608 162.302 782.704 162.206 782.704 162.088V155.279C782.704 155.161 782.608 155.065 782.49 155.065H777.971C777.853 155.065 777.758 155.161 777.758 155.279V162.088C777.758 162.206 777.853 162.302 777.971 162.302Z",
    fill: "#101011",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M776.598 140.134L777.926 137.828C777.926 137.828 778.002 137.721 778.002 137.63V133.95C778.018 133.828 778.079 133.737 778.155 133.737H782.201C782.201 133.737 782.338 133.828 782.338 133.95V137.63C782.338 137.706 782.384 137.782 782.43 137.828L783.758 140.134C783.758 140.134 783.834 140.24 783.834 140.332V155.233C783.834 155.355 783.728 155.462 783.605 155.462H776.75C776.628 155.462 776.521 155.355 776.521 155.233V140.332C776.521 140.256 776.552 140.179 776.598 140.134Z",
    fill: "#9E9E9E"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59179 155.89H188.547C190.457 155.89 192 157.432 192 159.343V402.744C192 404.654 190.457 406.197 188.547 406.197H5.59179C3.05712 406.197 1 404.14 1 401.605V160.5C1 157.965 3.05712 155.908 5.59179 155.908V155.89Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 326.171C169.887 326.171 169.777 326.263 169.777 326.373C169.777 326.484 169.869 326.575 169.997 326.575H174.424C174.534 326.575 174.644 326.484 174.644 326.373C174.644 326.263 174.552 326.171 174.424 326.171H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 326.392C175.69 326.282 175.782 326.19 175.911 326.19H180.337C180.448 326.19 180.558 326.282 180.558 326.392C180.558 326.502 180.466 326.594 180.337 326.594H175.911C175.801 326.594 175.69 326.502 175.69 326.392Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 328.743C169.887 328.743 169.777 328.835 169.777 328.945C169.777 329.055 169.869 329.147 169.997 329.147H174.424C174.534 329.147 174.644 329.055 174.644 328.945C174.644 328.835 174.552 328.743 174.424 328.743H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 328.964C175.69 328.853 175.782 328.761 175.911 328.761H180.337C180.448 328.761 180.558 328.853 180.558 328.964C180.558 329.074 180.466 329.166 180.337 329.166H175.911C175.801 329.166 175.69 329.074 175.69 328.964Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 331.333C169.887 331.333 169.777 331.425 169.777 331.535C169.777 331.645 169.869 331.737 169.997 331.737H174.424C174.534 331.737 174.644 331.645 174.644 331.535C174.644 331.425 174.552 331.333 174.424 331.333H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 331.535C175.69 331.425 175.782 331.333 175.911 331.333H180.337C180.448 331.333 180.558 331.425 180.558 331.535C180.558 331.645 180.466 331.737 180.337 331.737H175.911C175.801 331.737 175.69 331.645 175.69 331.535Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 333.904C169.887 333.904 169.777 333.996 169.777 334.106C169.777 334.217 169.869 334.308 169.997 334.308H174.424C174.534 334.308 174.644 334.217 174.644 334.106C174.644 333.996 174.552 333.904 174.424 333.904H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 334.106C175.69 333.996 175.782 333.904 175.911 333.904H180.337C180.448 333.904 180.558 333.996 180.558 334.106C180.558 334.217 180.466 334.308 180.337 334.308H175.911C175.801 334.308 175.69 334.217 175.69 334.106Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 336.476C169.887 336.476 169.777 336.567 169.777 336.678C169.777 336.788 169.869 336.88 169.997 336.88H174.424C174.534 336.88 174.644 336.788 174.644 336.678C174.644 336.567 174.552 336.476 174.424 336.476H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 336.678C175.69 336.567 175.782 336.476 175.911 336.476H180.337C180.448 336.476 180.558 336.567 180.558 336.678C180.558 336.788 180.466 336.88 180.337 336.88H175.911C175.801 336.88 175.69 336.788 175.69 336.678Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 339.047C169.887 339.047 169.777 339.139 169.777 339.249C169.777 339.359 169.869 339.451 169.997 339.451H171.099C171.209 339.451 171.32 339.359 171.32 339.249C171.32 339.139 171.228 339.047 171.099 339.047H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.014 339.249C179.014 339.139 179.106 339.047 179.235 339.047H179.969C180.079 339.047 180.19 339.139 180.19 339.249C180.19 339.359 180.098 339.451 179.969 339.451H179.235C179.124 339.451 179.014 339.359 179.014 339.249Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 341.618C169.887 341.618 169.777 341.71 169.777 341.82C169.777 341.931 169.869 342.022 169.997 342.022H174.424C174.534 342.022 174.644 341.931 174.644 341.82C174.644 341.71 174.552 341.618 174.424 341.618H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 341.839C175.69 341.729 175.782 341.637 175.911 341.637H180.337C180.448 341.637 180.558 341.729 180.558 341.839C180.558 341.949 180.466 342.041 180.337 342.041H175.911C175.801 342.041 175.69 341.949 175.69 341.839Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 344.19C169.887 344.19 169.777 344.282 169.777 344.392C169.777 344.502 169.869 344.594 169.997 344.594H174.424C174.534 344.594 174.644 344.502 174.644 344.392C174.644 344.282 174.552 344.19 174.424 344.19H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 344.41C175.69 344.3 175.782 344.208 175.911 344.208H180.337C180.448 344.208 180.558 344.3 180.558 344.41C180.558 344.52 180.466 344.612 180.337 344.612H175.911C175.801 344.612 175.69 344.52 175.69 344.41Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 346.761C169.887 346.761 169.777 346.853 169.777 346.963C169.777 347.073 169.869 347.165 169.997 347.165H174.424C174.534 347.165 174.644 347.073 174.644 346.963C174.644 346.853 174.552 346.761 174.424 346.761H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 346.982C175.69 346.872 175.782 346.78 175.911 346.78H180.337C180.448 346.78 180.558 346.872 180.558 346.982C180.558 347.092 180.466 347.184 180.337 347.184H175.911C175.801 347.184 175.69 347.092 175.69 346.982Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 349.351C169.887 349.351 169.777 349.443 169.777 349.553C169.777 349.663 169.869 349.755 169.997 349.755H174.424C174.534 349.755 174.644 349.663 174.644 349.553C174.644 349.443 174.552 349.351 174.424 349.351H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 349.553C175.69 349.443 175.782 349.351 175.911 349.351H180.337C180.448 349.351 180.558 349.443 180.558 349.553C180.558 349.663 180.466 349.755 180.337 349.755H175.911C175.801 349.755 175.69 349.663 175.69 349.553Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.777 354.842C169.777 354.732 169.979 354.64 170.254 354.64H180.081C180.338 354.64 180.558 354.732 180.558 354.842C180.558 354.953 180.356 355.044 180.081 355.044H170.254C169.997 355.044 169.777 354.953 169.777 354.842Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 359.967C169.887 359.967 169.777 360.059 169.777 360.169C169.777 360.28 169.869 360.371 169.997 360.371H174.424C174.534 360.371 174.644 360.28 174.644 360.169C174.644 360.059 174.552 359.967 174.424 359.967H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 360.188C175.69 360.077 175.782 359.986 175.911 359.986H180.337C180.448 359.986 180.558 360.077 180.558 360.188C180.558 360.298 180.466 360.39 180.337 360.39H175.911C175.801 360.39 175.69 360.298 175.69 360.188Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 362.557C169.887 362.557 169.777 362.649 169.777 362.759C169.777 362.869 169.869 362.961 169.997 362.961H174.424C174.534 362.961 174.644 362.869 174.644 362.759C174.644 362.649 174.552 362.557 174.424 362.557H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 362.759C175.69 362.649 175.782 362.557 175.911 362.557H180.337C180.448 362.557 180.558 362.649 180.558 362.759C180.558 362.869 180.466 362.961 180.337 362.961H175.911C175.801 362.961 175.69 362.869 175.69 362.759Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 365.128C169.887 365.128 169.777 365.22 169.777 365.33C169.777 365.441 169.869 365.532 169.997 365.532H174.424C174.534 365.532 174.644 365.441 174.644 365.33C174.644 365.22 174.552 365.128 174.424 365.128H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 365.33C175.69 365.22 175.782 365.128 175.911 365.128H180.337C180.448 365.128 180.558 365.22 180.558 365.33C180.558 365.441 180.466 365.532 180.337 365.532H175.911C175.801 365.532 175.69 365.441 175.69 365.33Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 367.7C169.887 367.7 169.777 367.792 169.777 367.902C169.777 368.012 169.869 368.104 169.997 368.104H174.424C174.534 368.104 174.644 368.012 174.644 367.902C174.644 367.792 174.552 367.7 174.424 367.7H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 367.902C175.69 367.792 175.782 367.7 175.911 367.7H180.337C180.448 367.7 180.558 367.792 180.558 367.902C180.558 368.012 180.466 368.104 180.337 368.104H175.911C175.801 368.104 175.69 368.012 175.69 367.902Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 370.271C169.887 370.271 169.777 370.363 169.777 370.473C169.777 370.583 169.869 370.675 169.997 370.675H174.424C174.534 370.675 174.644 370.583 174.644 370.473C174.644 370.363 174.552 370.271 174.424 370.271H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 370.473C175.69 370.363 175.782 370.271 175.911 370.271H180.337C180.448 370.271 180.558 370.363 180.558 370.473C180.558 370.583 180.466 370.675 180.337 370.675H175.911C175.801 370.675 175.69 370.583 175.69 370.473Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 372.843C169.887 372.843 169.777 372.934 169.777 373.045C169.777 373.155 169.869 373.247 169.997 373.247H171.099C171.209 373.247 171.32 373.155 171.32 373.045C171.32 372.934 171.228 372.843 171.099 372.843H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.014 373.063C179.014 372.953 179.106 372.861 179.235 372.861H179.969C180.079 372.861 180.19 372.953 180.19 373.063C180.19 373.173 180.098 373.265 179.969 373.265H179.235C179.124 373.265 179.014 373.173 179.014 373.063Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 375.414C169.887 375.414 169.777 375.506 169.777 375.616C169.777 375.726 169.869 375.818 169.997 375.818H174.424C174.534 375.818 174.644 375.726 174.644 375.616C174.644 375.506 174.552 375.414 174.424 375.414H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 375.634C175.69 375.524 175.782 375.432 175.911 375.432H180.337C180.448 375.432 180.558 375.524 180.558 375.634C180.558 375.744 180.466 375.836 180.337 375.836H175.911C175.801 375.836 175.69 375.744 175.69 375.634Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 377.986C169.887 377.986 169.777 378.077 169.777 378.188C169.777 378.298 169.869 378.39 169.997 378.39H174.424C174.534 378.39 174.644 378.298 174.644 378.188C174.644 378.077 174.552 377.986 174.424 377.986H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 378.206C175.69 378.096 175.782 378.004 175.911 378.004H180.337C180.448 378.004 180.558 378.096 180.558 378.206C180.558 378.316 180.466 378.408 180.337 378.408H175.911C175.801 378.408 175.69 378.316 175.69 378.206Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 380.575C169.887 380.575 169.777 380.667 169.777 380.777C169.777 380.887 169.869 380.979 169.997 380.979H174.424C174.534 380.979 174.644 380.887 174.644 380.777C174.644 380.667 174.552 380.575 174.424 380.575H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 380.777C175.69 380.667 175.782 380.575 175.911 380.575H180.337C180.448 380.575 180.558 380.667 180.558 380.777C180.558 380.887 180.466 380.979 180.337 380.979H175.911C175.801 380.979 175.69 380.887 175.69 380.777Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 383.146C169.887 383.146 169.777 383.238 169.777 383.348C169.777 383.458 169.869 383.55 169.997 383.55H174.424C174.534 383.55 174.644 383.458 174.644 383.348C174.644 383.238 174.552 383.146 174.424 383.146H169.997Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.69 383.348C175.69 383.238 175.782 383.146 175.911 383.146H180.337C180.448 383.146 180.558 383.238 180.558 383.348C180.558 383.458 180.466 383.55 180.337 383.55H175.911C175.801 383.55 175.69 383.458 175.69 383.348Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.163 355.026C152.163 353.079 153.743 351.518 155.671 351.518C157.6 351.518 159.179 353.098 159.179 355.026C159.179 356.955 157.6 358.534 155.671 358.534C153.743 358.534 152.163 356.955 152.163 355.026Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77832 358.057C7.77832 352.528 12.2599 348.047 17.7884 348.047C23.3169 348.047 27.7985 352.528 27.7985 358.057C27.7985 363.586 23.3169 368.067 17.7884 368.067C12.2599 368.067 7.77832 363.586 7.77832 358.057Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7884 374.092C12.2599 374.092 7.77832 378.573 7.77832 384.102C7.77832 389.63 12.2599 394.112 17.7884 394.112C23.3169 394.112 27.7985 389.63 27.7985 384.102C27.7985 378.573 23.3169 374.092 17.7884 374.092Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6495 358.057C25.6495 362.392 22.1414 365.918 17.7884 365.918C13.4354 365.918 9.92725 362.41 9.92725 358.057C9.92725 353.704 13.4354 350.196 17.7884 350.196C22.1414 350.196 25.6495 353.704 25.6495 358.057Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7884 391.963C22.123 391.963 25.6495 388.454 25.6495 384.101C25.6495 379.748 22.1414 376.24 17.7884 376.24C13.4354 376.24 9.92725 379.748 9.92725 384.101C9.92725 388.454 13.4354 391.963 17.7884 391.963Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M155.671 357.139C156.837 357.139 157.783 356.193 157.783 355.026C157.783 353.86 156.837 352.914 155.671 352.914C154.504 352.914 153.559 353.86 153.559 355.026C153.559 356.193 154.504 357.139 155.671 357.139Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2293 336.751C27.2293 338.698 25.6497 340.278 23.7028 340.278C21.7558 340.278 20.1763 338.698 20.1763 336.751C20.1763 334.804 21.7558 333.225 23.7028 333.225C25.6497 333.225 27.2293 334.804 27.2293 336.751Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6878 340.274C14.6342 340.207 16.1579 338.575 16.0909 336.628C16.024 334.682 14.3918 333.158 12.4453 333.225C10.4988 333.292 8.97517 334.924 9.04213 336.871C9.10908 338.817 10.7413 340.341 12.6878 340.274Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5362 331.737C9.76277 331.737 7.52197 333.978 7.52197 336.751C7.52197 339.524 9.76277 341.765 12.5362 341.765H23.7034C26.4769 341.765 28.7177 339.524 28.7177 336.751C28.7177 333.978 26.4769 331.737 23.7034 331.737H12.5362Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6847 326.153C25.6316 326.153 27.2112 324.574 27.2112 322.627C27.2112 320.68 25.6316 319.1 23.6847 319.1C21.7378 319.1 20.1582 320.68 20.1582 322.627C20.1582 324.574 21.7378 326.153 23.6847 326.153Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0618 322.627C16.0618 324.574 14.4822 326.153 12.5353 326.153C10.5884 326.153 9.00879 324.574 9.00879 322.627C9.00879 320.68 10.5884 319.1 12.5353 319.1C14.4822 319.1 16.0618 320.68 16.0618 322.627Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46631 322.627C7.46631 319.853 9.7071 317.613 12.4805 317.613H23.6478C26.4212 317.613 28.662 319.853 28.662 322.627C28.662 325.4 26.4212 327.641 23.6478 327.641H12.4805C9.7071 327.641 7.46631 325.4 7.46631 322.627Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7315 304.425C15.7315 304.995 15.3641 305.472 14.9233 305.472H8.60503C8.16422 305.472 7.79688 305.013 7.79688 304.425V298.272C7.79688 297.703 8.16422 297.225 8.60503 297.225H14.9233C15.3641 297.225 15.7315 297.685 15.7315 298.272V304.425Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1288 305.876C28.1288 306.721 27.5962 307.419 26.9166 307.419H7.33723C6.67601 307.419 6.125 306.739 6.125 305.876V296.821C6.125 295.976 6.65765 295.278 7.33723 295.278H26.8982C27.5595 295.278 28.1105 295.958 28.1105 296.821V305.876H28.1288Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.437 391.375C180.135 391.375 180.704 390.806 180.704 390.108V385.681H169.592V390.126C169.592 390.824 170.162 391.393 170.86 391.393H179.419L179.437 391.375Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.879 318.366C170.181 318.366 169.612 318.935 169.612 319.633V324.06H180.724V319.615C180.724 318.917 180.155 318.347 179.457 318.347H170.898L170.879 318.366Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.399 306.923C177.399 308.447 176.168 309.696 174.625 309.696C173.083 309.696 171.852 308.465 171.852 306.923C171.852 305.38 173.083 304.149 174.625 304.149C176.168 304.149 177.399 305.38 177.399 306.923Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.399 296.325C177.399 297.85 176.168 299.099 174.625 299.099C173.083 299.099 171.852 297.868 171.852 296.325C171.852 294.782 173.083 293.552 174.625 293.552C176.168 293.552 177.399 294.782 177.399 296.325Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M111.658 379.255C144.656 370.967 164.687 337.498 156.398 304.5C148.11 271.503 114.641 251.472 81.6434 259.761C48.6458 268.049 28.6151 301.518 36.9035 334.515C45.1919 367.513 78.6609 387.544 111.658 379.255Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6392 264.624C66.315 264.624 41.7397 289.199 41.7397 319.523C41.7397 349.847 66.315 374.422 96.6392 374.422C126.963 374.422 151.539 349.847 151.539 319.523C151.539 289.199 126.963 264.624 96.6392 264.624ZM96.6392 365.606C71.2006 365.606 50.556 344.98 50.556 319.523C50.556 294.066 71.1823 273.44 96.6392 273.44C122.096 273.44 142.722 294.066 142.722 319.523C142.722 344.98 122.096 365.606 96.6392 365.606Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M121.934 325.376C125.182 311.406 116.49 297.447 102.519 294.198C88.5485 290.95 74.5895 299.642 71.341 313.612C68.0924 327.583 76.7845 341.542 90.7553 344.791C104.726 348.039 118.685 339.347 121.934 325.376Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M182.578 315.574H167.756C167.37 315.574 167.058 315.886 167.058 316.272V393.396C167.058 393.781 167.37 394.094 167.756 394.094H182.578C182.963 394.094 183.276 393.781 183.276 393.396V316.272C183.276 315.886 182.963 315.574 182.578 315.574Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4707 268.48C11.4707 270.005 10.2401 271.254 8.69727 271.254C7.15443 271.254 5.92383 270.023 5.92383 268.48C5.92383 266.937 7.15443 265.707 8.69727 265.707C10.2401 265.707 11.4707 266.937 11.4707 268.48Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8394 268.48H20.9842",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1284 268.48C28.1284 270.005 26.8978 271.254 25.355 271.254C23.8121 271.254 22.5815 270.023 22.5815 268.48C22.5815 266.938 23.8121 265.707 25.355 265.707C26.8978 265.707 28.1284 266.938 28.1284 268.48Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M30.479 268.48H37.6238",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M13.983 254.673C14.1058 252.454 12.4073 250.557 10.1892 250.434C7.97104 250.311 6.07331 252.01 5.95046 254.228C5.82761 256.446 7.52617 258.343 9.74428 258.466C11.9624 258.589 13.8601 256.891 13.983 254.673Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6015 210.526C19.7008 208.733 18.328 207.2 16.5352 207.1C14.7425 207.001 13.2087 208.374 13.1095 210.167C13.0102 211.959 14.383 213.493 16.1757 213.592C17.9684 213.692 19.5022 212.319 19.6015 210.526Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0695 174.156C26.1335 173.001 25.2493 172.013 24.0947 171.949C22.9401 171.885 21.9522 172.769 21.8882 173.924C21.8243 175.079 22.7085 176.066 23.8631 176.13C25.0177 176.194 26.0056 175.31 26.0695 174.156Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6467 174.243C27.7589 172.217 26.2077 170.484 24.182 170.372C22.1563 170.26 20.4232 171.811 20.311 173.837C20.1989 175.863 21.75 177.596 23.7757 177.708C25.8014 177.82 27.5345 176.269 27.6467 174.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3193 258.47C27.5417 258.47 29.3417 256.67 29.3417 254.448C29.3417 252.225 27.5417 250.425 25.3193 250.425C23.0969 250.425 21.2969 252.225 21.2969 254.448C21.2969 256.67 23.0969 258.47 25.3193 258.47Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2025 254.448C46.2025 256.67 44.4025 258.47 42.1801 258.47C39.9577 258.47 38.1577 256.67 38.1577 254.448C38.1577 252.225 39.9577 250.425 42.1801 250.425C44.4025 250.425 46.2025 252.225 46.2025 254.448Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7314 254.448H19.6253",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4326 239.938H27.5223",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8467 254.466H36.6323",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.746 231.948C172.532 231.948 169.924 234.556 169.924 237.771C169.924 239.846 171.026 241.683 172.661 242.711L175.471 237.697C175.471 237.697 175.618 237.587 175.709 237.624C175.801 237.679 175.82 237.771 175.783 237.862L172.973 242.895C173.799 243.354 174.754 243.593 175.746 243.593C178.96 243.593 181.569 240.985 181.569 237.771C181.569 234.556 178.96 231.948 175.746 231.948Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M183.13 183V171.208C183.13 170.841 182.91 170.492 182.561 170.345C179.548 169.041 176.206 168.324 172.716 168.324C169.226 168.324 165.791 169.077 162.724 170.4",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M162.724 203.534V216.098C165.773 217.438 169.153 218.173 172.716 218.173C176.279 218.173 179.53 217.457 182.561 216.153C182.91 216.006 183.13 215.675 183.13 215.289V203.534",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M180.22 193.672C180.449 189.529 177.277 185.985 173.135 185.756C168.992 185.526 165.448 188.698 165.219 192.841C164.989 196.983 168.161 200.528 172.304 200.757C176.446 200.986 179.991 197.814 180.22 193.672Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M178.569 193.58C178.748 190.349 176.274 187.585 173.043 187.406C169.812 187.227 167.048 189.701 166.869 192.932C166.69 196.163 169.164 198.928 172.395 199.106C175.626 199.285 178.39 196.811 178.569 193.58Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M172.715 168.324V178.922",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M172.715 207.593V218.173",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M157.361 146.651H141.143C140.757 146.651 140.445 146.963 140.445 147.349V151.335C140.445 151.72 140.757 152.032 141.143 152.032H157.361C157.746 152.032 158.059 151.72 158.059 151.335V147.349C158.059 146.963 157.746 146.651 157.361 146.651Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M136.11 146.651H119.892C119.506 146.651 119.194 146.963 119.194 147.349V151.335C119.194 151.72 119.506 152.032 119.892 152.032H136.11C136.495 152.032 136.808 151.72 136.808 151.335V147.349C136.808 146.963 136.495 146.651 136.11 146.651Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M114.878 146.651H98.6599C98.2744 146.651 97.9619 146.963 97.9619 147.349V151.335C97.9619 151.72 98.2744 152.032 98.6599 152.032H114.878C115.264 152.032 115.576 151.72 115.576 151.335V147.349C115.576 146.963 115.264 146.651 114.878 146.651Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6266 146.651H77.4084C77.0229 146.651 76.7104 146.963 76.7104 147.349V151.335C76.7104 151.72 77.0229 152.032 77.4084 152.032H93.6266C94.0121 152.032 94.3245 151.72 94.3245 151.335V147.349C94.3245 146.963 94.0121 146.651 93.6266 146.651Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3952 146.651H56.177C55.7915 146.651 55.479 146.963 55.479 147.349V151.335C55.479 151.72 55.7915 152.032 56.177 152.032H72.3952C72.7806 152.032 73.0931 151.72 73.0931 151.335V147.349C73.0931 146.963 72.7806 146.651 72.3952 146.651Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1437 146.651H34.9255C34.54 146.651 34.2275 146.963 34.2275 147.349V151.335C34.2275 151.72 34.54 152.032 34.9255 152.032H51.1437C51.5292 152.032 51.8416 151.72 51.8416 151.335V147.349C51.8416 146.963 51.5292 146.651 51.1437 146.651Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M162.54 215.95V230.368C162.54 230.626 162.338 230.828 162.081 230.828H30.737C30.4799 230.828 30.2778 230.626 30.2778 230.368V155.908M162.54 155.908V183.091",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M162.54 155.89V140.773C162.54 139.231 161.291 138 159.766 138H33.2717C31.6186 138 30.2778 139.341 30.2778 140.994V155.89",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M151.943 161.216H41.354V226.401H151.943V161.216Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7019 226.273L30.4429 230.718",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2778 155.89L41.592 161.455",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M162.356 230.717L151.281 226.144",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M151.171 161.565L162.541 155.89",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3659 185.755H6.47432C6.08885 185.755 5.77637 186.067 5.77637 186.453V196.114C5.77637 196.499 6.08885 196.812 6.47432 196.812H26.3659C26.7514 196.812 27.0639 196.499 27.0639 196.114V186.453C27.0639 186.067 26.7514 185.755 26.3659 185.755Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M17.164 161.253H6.47432C6.08885 161.253 5.77637 161.566 5.77637 161.951V171.612C5.77637 171.998 6.08885 172.31 6.47432 172.31H17.164C17.5495 172.31 17.862 171.998 17.862 171.612V161.951C17.862 161.566 17.5495 161.253 17.164 161.253Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7028 219.734H6.47432C6.08885 219.734 5.77637 220.046 5.77637 220.432V223.591C5.77637 223.976 6.08885 224.289 6.47432 224.289H14.7028C15.0883 224.289 15.4008 223.976 15.4008 223.591V220.432C15.4008 220.046 15.0883 219.734 14.7028 219.734Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5867 236.926H6.93379C6.54832 236.926 6.23584 237.238 6.23584 237.624V242.252C6.23584 242.638 6.54832 242.95 6.93379 242.95H17.5867C17.9722 242.95 18.2847 242.638 18.2847 242.252V237.624C18.2847 237.238 17.9722 236.926 17.5867 236.926Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9328 236.301H30.9758C30.5903 236.301 30.2778 236.614 30.2778 236.999V242.84C30.2778 243.225 30.5903 243.538 30.9758 243.538H42.9328C43.3183 243.538 43.6307 243.225 43.6307 242.84V236.999C43.6307 236.614 43.3183 236.301 42.9328 236.301Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3835 219.734H18.155C17.7695 219.734 17.457 220.046 17.457 220.432V223.591C17.457 223.976 17.7695 224.289 18.155 224.289H26.3835C26.7689 224.289 27.0814 223.976 27.0814 223.591V220.432C27.0814 220.046 26.7689 219.734 26.3835 219.734Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M186.692 265.229H164.615C164.229 265.229 163.917 265.542 163.917 265.927V282.605C163.917 282.99 164.229 283.303 164.615 283.303H186.692C187.078 283.303 187.39 282.99 187.39 282.605V265.927C187.39 265.542 187.078 265.229 186.692 265.229Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M186.692 249.525H164.615C164.229 249.525 163.917 249.838 163.917 250.223V256.266C163.917 256.652 164.229 256.964 164.615 256.964H186.692C187.078 256.964 187.39 256.652 187.39 256.266V250.223C187.39 249.838 187.078 249.525 186.692 249.525Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M172.696 267.396H166.304C165.919 267.396 165.606 267.709 165.606 268.094V273.403C165.606 273.788 165.919 274.1 166.304 274.1H172.696C173.082 274.1 173.394 273.788 173.394 273.403V268.094C173.394 267.709 173.082 267.396 172.696 267.396Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M185.02 267.396H178.629C178.243 267.396 177.931 267.709 177.931 268.094V273.403C177.931 273.788 178.243 274.1 178.629 274.1H185.02C185.406 274.1 185.718 273.788 185.718 273.403V268.094C185.718 267.709 185.406 267.396 185.02 267.396Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M181.88 276.966H169.446C169.06 276.966 168.748 277.279 168.748 277.664V279.96C168.748 280.345 169.06 280.658 169.446 280.658H181.88C182.266 280.658 182.578 280.345 182.578 279.96V277.664C182.578 277.279 182.266 276.966 181.88 276.966Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.885 264.77V268.719C149.885 268.811 149.811 268.884 149.719 268.884C149.627 268.884 149.554 268.811 149.554 268.719V264.77C147.405 264.862 145.697 266.625 145.697 268.792C145.697 270.96 147.497 272.815 149.719 272.815C151.942 272.815 153.742 271.015 153.742 268.792C153.742 266.57 152.033 264.862 149.885 264.77Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.979 253.144C151.979 251.62 153.209 250.371 154.752 250.371C156.295 250.371 157.525 251.601 157.525 253.144C157.525 254.687 156.295 255.917 154.752 255.917C153.209 255.917 151.979 254.687 151.979 253.144Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.684 253.144C140.684 251.62 141.914 250.371 143.457 250.371C145 250.371 146.23 251.601 146.23 253.144C146.23 254.687 145 255.917 143.457 255.917C141.914 255.917 140.684 254.687 140.684 253.144Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.387 253.144C129.387 251.62 130.618 250.371 132.161 250.371C133.703 250.371 134.934 251.601 134.934 253.144C134.934 254.687 133.703 255.917 132.161 255.917C130.618 255.917 129.387 254.687 129.387 253.144Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M171.834 230.975L172.22 231.636",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M179.291 243.887L179.676 244.548",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M168.968 233.84L169.629 234.226",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M181.88 241.297L182.542 241.683",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M167.902 237.752H168.674",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M182.817 237.752H183.588",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M168.968 241.683L169.629 241.297",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M181.88 234.226L182.542 233.84",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M171.834 244.548L172.202 243.887",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M179.291 231.636L179.676 230.975",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M149.72 263.154V263.797",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M147.552 263.576L147.772 264.109",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M145.735 264.807L146.121 265.193",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M153.3 272.374L154.384 273.458",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M144.504 266.625L145.037 266.846",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M154.385 270.721L154.918 270.941",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M144.081 268.792H144.65",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M154.771 268.792H155.34",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M144.504 270.941L145.037 270.721",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M154.385 266.846L154.918 266.625",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M145.055 273.44L146.12 272.374",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M153.3 265.193L153.686 264.807",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M151.648 264.109L151.869 263.576",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M187.042 194.05C187.48 186.139 181.423 179.372 173.512 178.934C165.602 178.495 158.834 184.553 158.396 192.463C157.958 200.373 164.016 207.141 171.926 207.579C179.836 208.017 186.604 201.96 187.042 194.05Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M17.127 295.278V307.584",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M18.063 278.362V285.782",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M175.635 249.691V256.946",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3535 241.811H41.5555",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7399 236.301H47.7829C47.3974 236.301 47.085 236.614 47.085 236.999V242.84C47.085 243.225 47.3974 243.538 47.7829 243.538H59.7399C60.1254 243.538 60.4379 243.225 60.4379 242.84V236.999C60.4379 236.614 60.1254 236.301 59.7399 236.301Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1401 241.811H58.3604",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5265 236.301H64.5695C64.1841 236.301 63.8716 236.614 63.8716 236.999V242.84C63.8716 243.225 64.1841 243.538 64.5695 243.538H76.5265C76.912 243.538 77.2245 243.225 77.2245 242.84V236.999C77.2245 236.614 76.912 236.301 76.5265 236.301Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9468 241.811H75.1671",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3332 236.301H81.3762C80.9907 236.301 80.6782 236.614 80.6782 236.999V242.84C80.6782 243.225 80.9907 243.538 81.3762 243.538H93.3332C93.7187 243.538 94.0311 243.225 94.0311 242.84V236.999C94.0311 236.614 93.7187 236.301 93.3332 236.301Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7534 241.811H91.9554",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M110.138 236.301H98.1809C97.7954 236.301 97.4829 236.614 97.4829 236.999V242.84C97.4829 243.225 97.7954 243.538 98.1809 243.538H110.138C110.523 243.538 110.836 243.225 110.836 242.84V236.999C110.836 236.614 110.523 236.301 110.138 236.301Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5405 241.811H108.761",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M126.925 236.301H114.968C114.583 236.301 114.27 236.614 114.27 236.999V242.84C114.27 243.225 114.583 243.538 114.968 243.538H126.925C127.31 243.538 127.623 243.225 127.623 242.84V236.999C127.623 236.614 127.31 236.301 126.925 236.301Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M116.347 241.811H125.567",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M143.732 236.301H131.775C131.389 236.301 131.077 236.614 131.077 236.999V242.84C131.077 243.225 131.389 243.538 131.775 243.538H143.732C144.117 243.538 144.43 243.225 144.43 242.84V236.999C144.43 236.614 144.117 236.301 143.732 236.301Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M133.152 241.811H142.372",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M160.538 236.301H148.581C148.196 236.301 147.883 236.614 147.883 236.999V242.84C147.883 243.225 148.196 243.538 148.581 243.538H160.538C160.924 243.538 161.236 243.225 161.236 242.84V236.999C161.236 236.614 160.924 236.301 160.538 236.301Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M149.958 241.811H159.16",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5768 282.678L26.587 282.182L25.5768 281.686L24.585 281.19V282.182V283.174L25.5768 282.678Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39453 282.182L10.4047 282.678L11.4149 283.174V282.182V281.19L10.4047 281.686L9.39453 282.182Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8857 278.362H6.69393C6.46062 278.362 6.27148 278.551 6.27148 278.784V285.378C6.27148 285.612 6.46062 285.801 6.69393 285.801H14.8857C15.119 285.801 15.3081 285.612 15.3081 285.378V278.784C15.3081 278.551 15.119 278.362 14.8857 278.362Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4326 278.362H21.2408C21.0075 278.362 20.8184 278.551 20.8184 278.784V285.378C20.8184 285.612 21.0075 285.801 21.2408 285.801H29.4326C29.6659 285.801 29.855 285.612 29.855 285.378V278.784C29.855 278.551 29.6659 278.362 29.4326 278.362Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 434.5,
    y: 165.5,
    width: 119,
    height: 119,
    rx: 9.5,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 459.5,
    y: 196.167,
    width: 68.3333,
    height: 52.3333,
    rx: 5.5,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 267,
    r: 9.5,
    stroke: "#FCFCFC",
    strokeOpacity: 0.6
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482 180.417V177H494.26L496.611 180.417H505V183.832H498.901L496.55 180.417H482Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M243.948 54.823V20.0205C243.948 9.16146 252.787 0.322998 263.646 0.322998C274.505 0.322998 283.343 9.16146 283.343 20.0205V55M247.09 54.823V20.0205C247.09 10.8953 254.521 3.46469 263.646 3.46469C272.771 3.46469 280.202 10.8953 280.202 20.0205V55",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M288.845 90V100.569C288.845 100.804 288.649 101 288.415 101H275.405C275.157 101 274.961 100.804 274.961 100.569L274.961 90",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M273.396 67.4841L276.747 62.9345C276.851 62.8563 276.916 62.7129 276.916 62.5565L276.955 55.2693C276.955 55.0346 277.099 54.8391 277.281 54.8391H286.55C286.732 54.8391 286.876 55.0346 286.876 55.2693L286.915 62.5565C286.915 62.7129 286.98 62.8563 287.084 62.9345L290.435 67.4841C290.539 67.5623 290.604 67.7057 290.604 67.8752V89.7237C290.604 89.9583 290.408 90.1669 290.161 90.1669H273.657C273.422 90.1669 273.214 89.9713 273.214 89.7237V67.8752C273.214 67.7188 273.279 67.5623 273.383 67.4841",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M285.807 95.3982V99.9999",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M283.865 95.3982V99.9999",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M281.91 95.3982V99.9999",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M279.967 95.3982V99.9999",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M278.011 95.3982V99.9999",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M252.63 90V100.569C252.63 100.804 252.434 101 252.2 101H239.19C238.942 101 238.747 100.804 238.747 100.569V90",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M237.169 67.4841L240.52 62.9345C240.624 62.8563 240.689 62.7129 240.689 62.5565L240.728 55.2693C240.728 55.0346 240.872 54.8391 241.054 54.8391H250.323C250.505 54.8391 250.649 55.0346 250.649 55.2693L250.688 62.5565C250.688 62.7129 250.753 62.8563 250.857 62.9345L254.208 67.4841C254.312 67.5623 254.377 67.7057 254.377 67.8752V89.7237C254.377 89.9583 254.182 90.1669 253.934 90.1669H237.443C237.209 90.1669 237 89.9713 237 89.7237V67.8752C237 67.7188 237.065 67.5623 237.169 67.4841Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M249.593 95.3982V99.9999",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M247.638 95.3982V99.9999",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M245.695 95.3982V99.9999",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M243.74 95.3982V99.9999",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M241.797 95.3982V99.9999",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M655.944 54.5V20.8086C655.944 9.88829 664.833 1 675.753 1C686.673 1 695.561 9.88829 695.561 20.8086V55M659.104 54.5V20.8086C659.104 11.6319 666.576 4.15941 675.753 4.15941C684.93 4.15941 692.402 11.6319 692.402 20.8086V55",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M690.2 90V100.646C690.2 100.842 690.359 101 690.554 101H697.777C697.973 101 698.131 100.842 698.131 100.646V90",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M688.338 65.4731L690.475 61.7893C690.541 61.7238 690.593 61.6058 690.593 61.4747L690.619 55.5754C690.619 55.3788 690.724 55.2214 690.842 55.2214H697.331C697.449 55.2214 697.554 55.3788 697.554 55.5754L697.581 61.4747C697.581 61.6058 697.62 61.7238 697.699 61.7893L699.835 65.4731C699.901 65.5387 699.953 65.6567 699.953 65.7878V89.6734C699.953 89.87 699.783 90.0405 699.586 90.0405H688.6C688.404 90.0405 688.233 89.87 688.233 89.6734V65.7878C688.233 65.6567 688.286 65.5387 688.351 65.4731",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M648.184 64.8176L652.785 61.1207C652.903 61.0552 652.969 60.9372 652.969 60.8061L653.008 54.8806C653.008 54.6839 653.165 54.5266 653.362 54.5266H657.465H661.568C661.765 54.5266 661.922 54.6839 661.922 54.8806L661.962 60.8061C661.962 60.9372 662.04 61.0552 662.145 61.1207L666.747 64.8176C666.865 64.8832 666.93 65.0012 666.93 65.1323V66.653V88.3362C666.93 88.5329 666.773 88.6902 666.576 88.6902H648.354C648.157 88.6902 648 88.5329 648 88.3362V66.653V65.6173V65.1323C648 65.0012 648.079 64.8832 648.184 64.8176Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M664.151 88.6902V100.646C664.151 100.843 663.993 101 663.797 101H651.172C650.976 101 650.818 100.843 650.818 100.646V88.6902",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M659.89 95.9397H662.027C662.224 95.9397 662.381 95.7824 662.381 95.5857V93.9995C662.381 93.8028 662.224 93.6455 662.027 93.6455H659.89C659.693 93.6455 659.536 93.8028 659.536 93.9995V95.5857C659.536 95.7824 659.693 95.9397 659.89 95.9397Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M652.93 95.9397H655.067C655.263 95.9397 655.42 95.7824 655.42 95.5857V93.9995C655.42 93.8028 655.263 93.6455 655.067 93.6455H652.93C652.733 93.6455 652.576 93.8028 652.576 93.9995V95.5857C652.576 95.7824 652.733 95.9397 652.93 95.9397Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M656.954 91.6396H657.989C658.212 91.6396 658.409 91.4561 658.409 91.2201C658.409 90.9841 658.225 90.8137 657.989 90.8137H656.954C656.731 90.8137 656.534 90.9973 656.534 91.2201C656.534 91.443 656.718 91.6396 656.954 91.6396Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 694,
    cy: 167,
    r: 28,
    fill: "#FCFCFC",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_13053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.668 154.167H681.332C680.596 154.167 680 154.763 680 155.499V178.386C680 179.121 680.596 179.718 681.332 179.718H706.668C707.404 179.718 708 179.121 708 178.386V155.499C708 154.763 707.404 154.167 706.668 154.167Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.177 156.512H683.83C683.094 156.512 682.498 157.108 682.498 157.844V172.524C682.498 172.877 682.643 173.224 682.9 173.474L686.577 177.068C686.827 177.311 687.16 177.449 687.506 177.449H700.501C700.847 177.449 701.18 177.317 701.43 177.068L705.107 173.474C705.364 173.224 705.509 172.877 705.509 172.524V157.844C705.509 157.108 704.913 156.512 704.177 156.512Z",
    fill: "#1F1F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.868 161.874H687.132C686.396 161.874 685.8 162.471 685.8 163.206V170.997C685.8 171.733 686.396 172.329 687.132 172.329H700.868C701.604 172.329 702.2 171.733 702.2 170.997V163.206C702.2 162.471 701.604 161.874 700.868 161.874Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.519 157.205V158.114C688.519 159.092 689.31 159.883 690.288 159.883H697.711C698.69 159.883 699.48 159.092 699.48 158.114V157.205H688.512H688.519Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.036 173.973H690.226C689.49 173.973 688.894 174.57 688.894 175.305V176.762H693.361V175.305C693.361 174.57 692.765 173.973 692.029 173.973H692.036Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.774 173.973H695.963C695.228 173.973 694.631 174.57 694.631 175.305V176.762H699.099V175.305C699.099 174.57 698.503 173.973 697.767 173.973H697.774Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 688.75,
    y: 161.167,
    width: 1.75,
    height: 3.5,
    fill: "#1F1F20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 688.75,
    y: 169.917,
    width: 1.75,
    height: 3.5,
    fill: "#1F1F20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.5,
    y: 161.167,
    width: 1.75,
    height: 3.5,
    fill: "#1F1F20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.5,
    y: 168.167,
    width: 1.75,
    height: 5.25,
    transform: "rotate(-90 697.5 168.167)",
    fill: "#1F1F20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.25,
    y: 168.167,
    width: 1.75,
    height: 5.25,
    transform: "rotate(-90 685.25 168.167)",
    fill: "#1F1F20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.5,
    y: 169.917,
    width: 1.75,
    height: 3.5,
    fill: "#1F1F20"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 167,
    r: 28,
    fill: "#FCFCFC",
    fillOpacity: 0.05
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_218_13053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.796 162.395H290.3V156.584C290.3 156.096 289.866 155.702 289.331 155.702H274.669C274.134 155.702 273.701 156.096 273.701 156.584V162.395H269.204C268.405 162.395 267.754 162.975 267.754 163.684V177.009C267.754 177.718 268.405 178.298 269.204 178.298H294.803C295.602 178.298 296.252 177.718 296.252 177.009V163.684C296.252 162.975 295.602 162.395 294.803 162.395H294.796Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.235 167.703H294.314H294.329C294.697 167.703 295 167.996 295 168.352V172.138C295 172.494 294.697 172.788 294.329 172.788H294.249C293.881 172.788 293.578 173.081 293.578 173.437V176.839C293.578 176.93 293.506 177 293.412 177H289.14V171.761C289.14 171.475 288.895 171.237 288.599 171.237C288.303 171.237 288.057 171.475 288.057 171.761V177H285.842V171.761C285.842 171.475 285.596 171.237 285.3 171.237C285.004 171.237 284.759 171.475 284.759 171.761V177H282.544V171.761C282.544 171.475 282.298 171.237 282.002 171.237C281.707 171.237 281.461 171.475 281.461 171.761V177H279.238V171.761C279.238 171.475 278.993 171.237 278.697 171.237C278.401 171.237 278.155 171.475 278.155 171.761V177H275.94V171.761C275.94 171.474 275.695 171.237 275.399 171.237C275.103 171.237 274.857 171.474 274.857 171.761V177H270.628C270.534 177 270.462 176.93 270.462 176.839V173.437C270.462 173.081 270.159 172.788 269.791 172.788H269.712C269.344 172.788 269.041 172.494 269.041 172.138V168.352C269.041 167.996 269.344 167.703 269.712 167.703H269.791C270.159 167.703 270.462 167.409 270.462 167.053V164.014C270.462 163.924 270.534 163.854 270.628 163.854H275.846C275.94 163.854 276.012 163.784 276.012 163.693V161.255C276.012 161.164 276.084 161.094 276.178 161.094H277.982C278.076 161.094 278.148 161.025 278.148 160.934V158.161C278.148 158.07 278.22 158 278.314 158H285.712C285.805 158 285.878 158.07 285.878 158.161V160.934C285.878 161.025 285.95 161.094 286.044 161.094H287.848C287.942 161.094 288.014 161.164 288.014 161.255V163.693C288.014 163.784 288.086 163.854 288.18 163.854H293.398C293.491 163.854 293.564 163.924 293.564 164.014V167.053C293.564 167.409 293.867 167.703 294.235 167.703Z",
    fill: "#1C1C1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_13053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 25.551,
    fill: "white",
    transform: "translate(680 154.167)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_218_13053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.4912,
    height: 22.5965,
    fill: "white",
    transform: "translate(267.754 155.702)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecFullSetup);
export default __webpack_public_path__ + "static/media/rec-full-setup.6a6a6deb0e99a0f83d42f1c2906c5d55.svg";
export { ForwardRef as ReactComponent };